var _window, _window$document;
import React__default, { useLayoutEffect, useEffect, useRef, useState, useCallback, useMemo, forwardRef, useContext, createContext, useImperativeHandle } from 'react';
import { c as classNames, E as ErrorBoundary, F as FixedSizeList, N as Ne, d as de, Y as Ye, P as Pe, u as useSortable, C as CSS, K as KeyboardCode, a as PointerSensor$1, b as KeyboardSensor$1, e as useSensors, f as useSensor, D as DndContext, g as closestCenter, S as SortableContext, v as verticalListSortingStrategy, h as DragOverlay, i as arrayMove } from './vendor-3a2071be.js';
import { createUseStyles, useTheme } from 'react-jss';
import { sanitizeString } from '@sm/utils';
import { uniqueId, visuallyHidden as visuallyHidden$1 } from '@wds/utils';
import ReactDOM from 'react-dom';
import { defineMessages, t, L10NContext, T } from '@sm/intl';
import getFontWeights from '@sm/webassets/dist/components/SurveyTheme/getFontWeights';
import { c as contrastColor } from './theme-22bba55b.js';
import isDark from '@sm/webassets/dist/components/SurveyTheme/isDark';
const useStyles$10 = createUseStyles({
  rowStyles: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center'
  }
});
function Row({
  id,
  className,
  children,
  ...props
}) {
  const {
    rowStyles
  } = useStyles$10();
  return React__default.createElement("div", {
    id: id,
    className: classNames(rowStyles, className),
    ...props
  }, children);
}
const useStyles$$ = createUseStyles(theme => {
  var _theme$breakpoints;
  return {
    tooltip: {
      'span[data-tooltip] &': {
        display: 'none'
      },
      [`@media (min-width: ${((_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.md.min) ?? '769px'})`]: {
        'span[data-tooltip]:hover &, span[data-tooltip]:focus &': {
          display: 'inline-block'
        }
      },
      position: 'absolute',
      left: ({
        center
      }) => center,
      bottom: 20,
      width: 275,
      transform: 'translate(-50%, -5px)',
      textAlign: 'center',
      zIndex: 12,
      fontSize: 13,
      '&:after': {
        position: 'absolute',
        bottom: -4,
        left: '50%',
        width: 10,
        height: 10,
        backgroundColor: 'white',
        content: '""',
        marginLeft: -5,
        transform: 'rotate(45deg)',
        boxShadow: [[3, 5, 5, 'rgb(0 0 0 / 0.07)']],
        zIndex: 13
      }
    },
    tooltipBody: {
      display: 'inline-block',
      maxWidth: 275,
      color: 'black',
      fontWeight: 300,
      fontFamily: theme.fontFamily,
      fontStyle: 'normal',
      boxShadow: [[0, 2, 10, 0, 'rgb(0 0 0 / 0.14)']],
      background: 'white',
      padding: [[12, 16]],
      lineHeight: 1.4,
      borderRadius: 2,
      textAlign: 'left'
    }
  };
});
const defaultSelectors = ['a[href]', 'button', 'textarea', 'input:not([type="hidden"])', 'select', 'details', '[tabindex]:not([tabindex="-1"])'];
const useFocusTrap = ({
  selectors = defaultSelectors
} = {}) => {
  const focusRef = React__default.useRef(null);
  const [focusableEls, setEls] = React__default.useState([]);
  React__default.useEffect(() => {
    if (focusRef.current) {
      const els = Array.from(focusRef.current.querySelectorAll(selectors.join(',')));
      setEls(els);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusRef]);
  function handleFocus(e) {
    if (focusRef.current) {
      const focusableElements = focusableEls;
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else if (document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    }
  }
  React__default.useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Tab') {
        handleFocus(e);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  });
  return focusRef;
};
const useStyles$_ = createUseStyles(theme => {
  var _theme$questionBody;
  return {
    modalOverlay: {
      zIndex: 999,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end'
    },
    modal: {
      position: 'relative',
      width: '85vw',
      minHeight: '20vw',
      marginBottom: 20,
      background: 'white',
      borderRadius: 2
    },
    closeBtn: {
      position: 'absolute',
      cursor: 'pointer',
      background: 'transparent',
      right: 0,
      border: 0,
      padding: 8,
      marginTop: 0,
      color: 'black',
      zIndex: 105
    },
    tooltipText: {
      color: ((_theme$questionBody = theme.questionBody) === null || _theme$questionBody === void 0 ? void 0 : _theme$questionBody.color) || '#333E48',
      fontFamily: theme.fontFamily,
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '1.4',
      padding: [28, 12, 16]
    }
  };
});
const COPY$h = defineMessages({
  CLOSE_MODAL: {
    id: 'Modal.CloseModal',
    defaultMessage: 'Close tooltip',
    description: '[Type: label][Vis: Med] - close button text'
  }
});
function Modal({
  tooltip,
  closeModal
}) {
  const {
    modalOverlay,
    closeBtn,
    modal,
    tooltipText
  } = useStyles$_();
  const closeRef = React__default.useRef(null);
  const tooltipId = uniqueId('tooltip-modal');
  const focusRef = useFocusTrap();
  const handleClick = e => {
    // click on button or overlay should close modal
    e.stopPropagation();
    if (e.currentTarget === e.target) {
      closeModal();
    }
  };
  React__default.useEffect(() => {
    // listen for ESC to close modal
    const handleKeydown = e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        closeModal();
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [closeModal]);
  React__default.useEffect(() => {
    var _closeRef$current;
    (_closeRef$current = closeRef.current) === null || _closeRef$current === void 0 ? void 0 : _closeRef$current.focus();
  }, []);
  return React__default.createElement("div", {
    className: modalOverlay,
    onClick: handleClick,
    "aria-hidden": "true"
  }, React__default.createElement("div", {
    ref: focusRef,
    className: modal,
    role: "dialog",
    "aria-modal": "true",
    "aria-describedby": tooltipId
  }, React__default.createElement("button", {
    type: "button",
    className: closeBtn,
    ref: closeRef,
    onClick: handleClick,
    "aria-label": t(COPY$h.CLOSE_MODAL)
  }, "\u00D7"), React__default.createElement("p", {
    id: tooltipId,
    className: tooltipText
  }, tooltip)));
}

/** Displays a tooltip on hover for large screens and a modal on click for small screens */
const Tooltip = ({
  container,
  className,
  id = ''
}) => {
  /** container center position to display tooltip */
  const center = container.offsetWidth / 2;
  const text = container.getAttribute('data-tooltip') ?? '';
  const theme = useTheme();
  const {
    tooltip,
    tooltipBody
  } = useStyles$$({
    center
  });
  const [showModal, setShowModal] = React__default.useState(false);
  const [mode, setMode] = React__default.useState('TOOLTIP');
  const closeModal = () => {
    setShowModal(false);
    container.focus();
  };
  React__default.useEffect(() => {
    container.setAttribute('role', 'tooltip');
    // make tooltip anchor focusable
    if (!container.hasAttribute('tabIndex')) {
      container.setAttribute('tabIndex', '0');
    }
    // opens modal if matches small screen breakpoint
    const openModal = () => {
      var _theme$breakpoints2;
      const mql = window.matchMedia(`(max-width: ${(theme === null || theme === void 0 ? void 0 : (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2.md.min) ?? '769px'})`);
      if (mql.matches) {
        setMode('MODAL');
        setShowModal(true);
      } else {
        setMode('TOOLTIP');
      }
    };
    const handleClick = () => {
      openModal();
    };
    const handleKeydown = e => {
      if (e.code === 'Enter' || e.code === 'Space') {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      }
    };
    // listen for click, ENTER or SPACE to open modal
    container.addEventListener('click', handleClick);
    container.addEventListener('keydown', handleKeydown);
    return () => {
      container.removeEventListener('click', handleClick);
      container.removeEventListener('keydown', handleKeydown);
    };
  }, [container, theme]);
  const modalEl = showModal ? React__default.createElement(Modal, {
    tooltip: text,
    closeModal: closeModal
  }) : null;
  const tooltipEl = React__default.createElement("div", {
    className: classNames(tooltip, className)
  }, React__default.createElement("span", {
    id: id,
    className: tooltipBody,
    "aria-hidden": "true"
  }, text));
  const child = mode === 'MODAL' ? modalEl : tooltipEl;
  const containerEl = mode === 'MODAL' ? document.body : container;
  return ReactDOM.createPortal(child, containerEl);
};
const listSpacing = {
  margin: [16, 0],
  padding: [0, 0, 0, 40]
};
const mediaReset = {
  border: 0,
  maxWidth: '100%'
};
const useStyles$Z = createUseStyles({
  richTextContent: {
    // Typography
    '& a': {
      // Links are not themed by default. Users must select a link color in the editor
      color: 'blue',
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer'
      },
      '&:focus': {
        outline: 'currentColor auto 1px'
      }
    },
    '& ol': {
      ...listSpacing,
      listStyleType: 'decimal'
    },
    '& ul': {
      ...listSpacing,
      listStyle: 'disc outside none',
      '& ul li': {
        listStyle: 'circle'
      }
    },
    '& p': {
      margin: [13, 0]
    },
    '& b': {
      fontWeight: 'bold'
    },
    '& strong': {
      fontWeight: 'bold'
    },
    '& em': {
      fontStyle: 'italic'
    },
    '& i': {
      fontStyle: 'italic'
    },
    '& big': {
      fontSize: 'larger'
    },
    '& small': {
      fontSize: 'smaller'
    },
    '& sup': {
      fontSize: '75%',
      lineHeight: 0,
      position: 'relative',
      top: '-0.5em',
      verticalAlign: 'baseline'
    },
    // Media embeds
    '& iframe': mediaReset,
    '& img': {
      ...mediaReset,
      height: 'auto',
      '-ms-interpolation-mode': 'bicubic'
    },
    '& span[data-tooltip]': {
      position: 'relative',
      display: 'inline',
      borderBottom: [[1, 'dashed']],
      textDecoration: 'inherit',
      cursor: 'pointer'
    }
  }
});

// Support iframe video embeds and their matching attributes
const sanitizeOptions = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'sandbox', 'scrolling']
};
function RichText({
  id: elementId,
  element: Element = 'div',
  text,
  className,
  ...containerProps
}) {
  const {
    richTextContent
  } = useStyles$Z();
  const [tooltipNodes, setTooltipNodes] = React__default.useState([]);
  const tooltipRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (tooltipRef !== null && tooltipRef !== void 0 && tooltipRef.current) {
      const el = tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current;
      setTooltipNodes(Array.from(el.querySelectorAll('[data-tooltip]')));
    }
  }, []);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Element, {
    id: elementId,
    className: classNames(richTextContent, className),
    dangerouslySetInnerHTML: {
      __html: sanitizeString(text, sanitizeOptions)
    },
    ref: tooltipRef,
    translate: "no",
    ...containerProps
  }), tooltipNodes.map(container => {
    const id = uniqueId('rich-text-tooltip');
    container.setAttribute('aria-describedby', id);
    return React__default.createElement(Tooltip, {
      key: id,
      container: container,
      id: id
    });
  }));
}
const useStyles$Y = createUseStyles(theme => ({
  wdsIcons: ({
    color,
    size
  }) => {
    var _theme$palette, _theme$palette2, _theme$palette2$color;
    const fontSize = size ? {
      fontSize: theme.iconSize[size]
    } : {
      fontSize: 'inherit'
    };
    const chosenColor =
    // @ts-expect-error Fallback styles are acceptable
    ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.text[color]) || ((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$color = _theme$palette2[color]) === null || _theme$palette2$color === void 0 ? void 0 : _theme$palette2$color.main) || 'currentColor';
    return {
      ...fontSize,
      width: '1em',
      height: '1em',
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'center',
      fill: chosenColor
    };
  }
}));

// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
const getDisplayName = Component => Component.displayName || Component.name || 'Component';
function withIcon(Component) {
  function WithIcon({
    color,
    title,
    size,
    ...rest
  }) {
    const classes = useStyles$Y({
      color,
      size
    });
    return React__default.createElement("svg", {
      className: classes.wdsIcons,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "xMidYMid",
      "aria-label": title,
      role: title ? 'img' : 'presentation',
      ...rest
    }, React__default.createElement(Component, null));
  }
  WithIcon.displayName = `WithIcon(${getDisplayName(Component)})`;
  WithIcon.getOriginalComponent = () => Component;
  return WithIcon;
}
const useSurveyIconStyles = createUseStyles({
  svgContainer: {
    display: 'inline-block',
    width: '1em',
    height: '1em'
  }
});
let instance = 0;
function withSvgIcon(Component, displayName = 'SvgElement') {
  function SvgIcon({
    id,
    'aria-labelledby': ariaLabelledBy,
    title,
    viewBox = '0 0 16 16',
    className,
    ...props
  }) {
    instance += 1;
    const styles = useSurveyIconStyles();
    const hasTitle = !!title && !ariaLabelledBy;
    const iconTitleId = id ? `${id}-icon-title` : `icon-title-${instance}`;
    return React__default.createElement("svg", {
      className: classNames(styles.svgContainer, className),
      viewBox: viewBox,
      preserveAspectRatio: "xMidYMid",
      "aria-hidden": hasTitle ? undefined : true,
      "aria-labelledby": hasTitle ? iconTitleId : ariaLabelledBy,
      role: hasTitle ? 'img' : undefined,
      focusable: "false",
      ...props,
      "data-testid": displayName
    }, hasTitle && React__default.createElement("title", {
      id: iconTitleId
    }, title), React__default.createElement(Component, null));
  }
  SvgIcon.displayName = displayName;
  return SvgIcon;
}
function DocumentXIconPath() {
  return React__default.createElement("path", {
    d: "m5.94.005 8.012.012C14.53.018 15 .487 15 1.067V14.95c0 .58-.47 1.05-1.05 1.05H2.05C1.47 16 1 15.53 1 14.95V4.94L5.94.004zM7 1.505V4.95c0 .541-.41.987-.936 1.044L5.95 6H2.5v8.5h11V1.514L7 1.505zM6.557 7.53 8 8.973 9.443 7.53a.765.765 0 0 1 1.083 1.082l-1.444 1.443 1.444 1.444a.765.765 0 0 1-1.083 1.082L8 11.138 6.557 12.58A.765.765 0 1 1 5.474 11.5l1.444-1.444-1.444-1.443A.765.765 0 1 1 6.557 7.53zM5.5 2.563 3.561 4.5H5.5V2.562z"
  });
}
var IconDocumentX = withIcon(DocumentXIconPath);
const useStyles$X = createUseStyles(theme => {
  var _theme$questionBody2;
  return {
    fallbackComponent: {
      fontFamily: ((_theme$questionBody2 = theme.questionBody) === null || _theme$questionBody2 === void 0 ? void 0 : _theme$questionBody2.fontFamily) ?? {},
      color: theme.questionColor,
      border: `1px solid ${theme.questionColor}`,
      borderRadius: '5px',
      width: '100%',
      height: '100%',
      minHeight: '220px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        fill: theme.questionColor
      }
    },
    errorMessage: {
      marginLeft: `8px` // equivalent to wrench theme.spacing[2]
    }
  };
});

const COPY$g = defineMessages({
  ERROR: {
    id: 'FallbackComponent.ERROR',
    defaultMessage: 'Error loading question',
    description: '[Type: label][Vis: high] - error message indicating a question could not be loaded'
  }
});
function FallbackComponent() {
  const {
    fallbackComponent,
    errorMessage
  } = useStyles$X();
  return React__default.createElement("div", {
    className: fallbackComponent
  }, React__default.createElement(IconDocumentX, null), React__default.createElement("p", {
    className: errorMessage
  }, t(COPY$g.ERROR)));
}
const withErrorBoundary = Component => {
  const displayName = Component.displayName || Component.name || 'Component';
  function ComponentWithErrorBoundary(props) {
    return React__default.createElement(ErrorBoundary, {
      FallbackComponent: FallbackComponent
    }, React__default.createElement(Component, {
      ...props
    }));
  }
  ComponentWithErrorBoundary.displayName = `withErrorBoundary(${displayName})`;
  return ComponentWithErrorBoundary;
};
const createFieldId = questionId => `question-field-${questionId}`;
const createLegendId = questionId => `question-title-legend-${questionId}`;
const createErrorRowId = questionId => `error-row-${questionId}`;
const createErrorId = questionId => `${questionId}-validation-message`;
const stripHTML = str => {
  const ref = document.createElement('div');
  ref.innerHTML = str;
  return ref.textContent || ref.innerText || '';
};

/**
 * Hook to split question-choices by type and filter for visibility
 */
function useQuestionChoices(choices = [], columns = []) {
  const options = choices.filter(c => !!c && c.visible);
  const columnOptions = columns.filter(c => !!c && c.visible);
  return {
    options,
    /** Standard column options (Matrix) */
    columnOptions,
    /** Standard answer options */
    sortableOptions: options.filter(c => !c.type),
    /** None-Of-The-Above (NOTA) option  */
    notaOption: options.find(c => c.type === 'NOTA'),
    /** Other answer option */
    otherOption: options.find(c => c.type === 'ANSWER'),
    /** Other comment option - One comment for the question */
    commentOption: options.find(c => c.type === 'COMMENT'),
    /** Other comment option - One comment per row (e.g. for Matrix) */
    commentColumnOption: options.find(c => c.type === 'COMMENT_COLUMN')
  };
}
const useStyles$W = createUseStyles(theme => {
  return {
    button: {
      color: theme.nextButton.color,
      backgroundColor: theme.nextButton.backgroundColor,
      fontFamily: theme.questionBody.fontFamily ?? {},
      fontSize: 15,
      border: [1, 'solid', 'transparent'],
      borderRadius: 2,
      padding: [1, 6],
      maxWidth: '100%',
      minWidth: 60,
      minHeight: 40,
      cursor: 'pointer',
      overflowWrap: 'break-word',
      transition: `all .2s linear`,
      '&:focus, &:hover': {
        outlineOffset: 5,
        outline: `1px solid ${theme.answerColor}`,
        // Safari seems to have an outline bug, may not render without boxshadow
        boxShadow: '0 0 4px transparent'
      }
    }
  };
});
const COPY$f = defineMessages({
  OK_LABEL: {
    id: 'Button.OK_LABEL',
    defaultMessage: 'OK',
    description: '[Type: button][Vis: high] - question ok label'
  }
});
// This might need to be a prop later once confirmed
const MAX_LENGTH = 20;
function Button({
  text = t(COPY$f.OK_LABEL),
  type = 'button',
  className,
  ...props
}) {
  const {
    button
  } = useStyles$W();
  const slicedText = text.length <= MAX_LENGTH ? text : text.slice(0, MAX_LENGTH);
  return (
    // eslint-disable-next-line react/button-has-type
    React__default.createElement("button", {
      className: classNames(button, className),
      type: type,
      ...props
    }, slicedText)
  );
}

/*eslint spaced-comment: ["error", "never", { "exceptions": ["NOSONAR"] }] */
/**
 * SSR Safe version of useLayoutEffect
 * @see https://code.corp.surveymonkey.com/webplatform/smweb/blob/master/apps/contentweb/src/app/pages/MRX/helpers/useIsomorphicLayoutEffect.js
 *
 * Note: `NOSONAR` is used to bypass a `minor:code-smell` error that states `createElement` is deprecated.
 * The eslint rule above disables the spaced comments to use NOSONAR as stated in the docs.
 */
const useSSRSafeLayoutEffect = typeof window !== 'undefined' && typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.createElement) !== 'undefined' //NOSONAR
? useLayoutEffect : useEffect;

/** Referentially stable empty function
 *
 * e.g. as default or placeholder */
// eslint-disable-next-line @typescript-eslint/no-empty-function
const EmptyFn = () => {};

/* eslint-disable no-param-reassign, no-plusplus */
/**
 * @name EasingFunctions- Useful easing equations
 * @comment only considering the t value for the range [0, 1] => [0, 1]
 */
const easingFunctions = {
  /** @comment linear - no easing, no acceleration */
  linear: t => t,
  /** @comment easeInQuad - accelerating from zero velocity */
  easeInQuad: t => t * t,
  /** @comment easeOutQuad - decelerating to zero velocity */
  easeOutQuad: t => t * (2 - t),
  /** @comment easeInOutQuad - acceleration until halfway, then deceleration */
  easeInOutQuad: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
  /** @comment easeInCubic - accelerating from zero velocity */
  easeInCubic: t => t * t * t,
  /** @comment easeOutCubic - decelerating to zero velocity */
  easeOutCubic: t => --t * t * t + 1,
  /** @comment easeInOutCubic - acceleration until halfway, then deceleration */
  easeInOutCubic: t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  /** @comment easeInQuart - accelerating from zero velocity */
  easeInQuart: t => t * t * t * t,
  /** @comment easeOutQuart - decelerating to zero velocity */
  easeOutQuart: t => 1 - --t * t * t * t,
  /** @comment easeInOutQuart - acceleration until halfway, then deceleration */
  easeInOutQuart: t => t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t,
  /** @comment easeInQuint - accelerating from zero velocity */
  easeInQuint: t => t * t * t * t * t,
  /** @comment easeOutQuint - decelerating to zero velocity */
  easeOutQuint: t => 1 + --t * t * t * t * t,
  /** @comment easeInOutQuint - acceleration until halfway, then deceleration */
  easeInOutQuint: t => t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t
};
/**
 * Given a start/end point of a scroll and time elapsed, calculate the scroll position we should be at
 */
function getValue(start, end, elapsed, duration, easingType = 'linear') {
  if (elapsed > duration) {
    return end;
  }
  const easing = typeof easingType === 'string' ? easingFunctions[easingType] : easingType;
  return start + (end - start) * easing(elapsed / duration);
}
/**
 * Smoothly animate between two values
 */
function animate({
  fromValue,
  toValue,
  onStart,
  onUpdate,
  onComplete,
  duration = 600,
  delay = 0,
  easingType = 'easeOutQuart'
}) {
  const startTime = performance.now() + delay;
  const tick = () => {
    const elapsed = performance.now() - startTime;
    const time = getValue(fromValue, toValue, elapsed, duration, easingType);
    const callback = elapsed <= duration ? tick : onComplete ?? EmptyFn;
    const updateAnimation = () => {
      onUpdate(time, callback);
    };
    window.requestAnimationFrame(updateAnimation);
  };
  onStart === null || onStart === void 0 ? void 0 : onStart();
  if (delay > 0) {
    setTimeout(() => {
      tick();
    }, delay);
  } else {
    tick();
  }
}
const useStyles$V = createUseStyles({
  paddingBox: ({
    padding,
    width
  }) => {
    return {
      paddingTop: (padding === null || padding === void 0 ? void 0 : padding.top) || 0,
      paddingBottom: (padding === null || padding === void 0 ? void 0 : padding.bottom) || 0,
      paddingLeft: (padding === null || padding === void 0 ? void 0 : padding.left) || 0,
      paddingRight: (padding === null || padding === void 0 ? void 0 : padding.right) || 0,
      width: width ? `${width.width}${width.format === 'PERCENT' ? '%' : 'px'}` : '100%',
      maxWidth: '100%'
    };
  }
});
function QuestionSpacing({
  padding,
  width,
  children,
  ...props
}) {
  const {
    paddingBox
  } = useStyles$V({
    padding,
    width
  });
  return React__default.createElement("div", {
    className: paddingBox,
    "data-testid": "QuestionSpacing__paddingBox",
    ...props
  }, children);
}

/**
 * Hook that calls the provided callback function when the ref element is blurred,
 * only if the next focus is outside the ref element
 *
 * @example
 * const ref = useRef<HTMLDivElement>(null);
 * useOnFocusLeave(ref, ()=> onLeaveQuestion());
 * <div rf={ref}><input /></div>
 */
function useOnFocusLeave(ref, focusCallback) {
  useEffect(() => {
    const ele = ref === null || ref === void 0 ? void 0 : ref.current;
    function handleFocus(e) {
      if (!(ele !== null && ele !== void 0 && ele.contains(e.relatedTarget))) {
        focusCallback(ref);
      }
    }
    ele === null || ele === void 0 ? void 0 : ele.addEventListener('focusout', handleFocus);
    return () => {
      ele === null || ele === void 0 ? void 0 : ele.removeEventListener('focusout', handleFocus);
    };
  }, [ref, focusCallback]);
}
const useStyles$U = createUseStyles({
  footerRow: ({
    hasFooterPadding
  }) => ({
    paddingTop: hasFooterPadding ? 20 : 0
  }),
  containerStyles: {
    position: 'relative',
    transition: 'opacity 500ms ease-out'
  },
  errorRow: {
    overflow: 'hidden'
  },
  formReset: {
    border: 0,
    minWidth: 0
  },
  headerRow: {
    marginBottom: 24,
    width: '100%'
  }
});
function QuestionFieldLayoutTemplate({
  footer,
  hasFooterPadding,
  children,
  clickShield,
  error,
  id,
  padding,
  width = {
    width: 100,
    format: 'PERCENT'
  },
  title,
  onSubmit,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onLeave = () => {},
  ...props
}) {
  const {
    footerRow,
    containerStyles,
    formReset,
    errorRow,
    headerRow
  } = useStyles$U({
    hasFooterPadding,
    clickShield
  });
  const containerRef = useRef(null);
  const errorRef = useRef(null);
  /** Keep track of last error to enable error-hiding animation */
  const [lastShownError, setLastShownError] = useState(error);
  const handleKeydown = useCallback(event => {
    if (event.key === 'Enter') {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    }
  }, [onSubmit]);
  /**
   * resolves double height animate issue with RAWR-1240
   */
  const isAnimating = useRef(false);
  useSSRSafeLayoutEffect(() => {
    const el = errorRef.current;
    if (!el || isAnimating.current) {
      return;
    }
    const hasError = !!error;
    const initialHeight = el.offsetHeight;
    el.style.height = 'auto'; // remove height to measure full size
    const {
      offsetHeight
    } = el;
    const fromValue = hasError ? 0 : offsetHeight;
    const toValue = hasError ? offsetHeight : 0;
    // don't animate if value is already correct (e.g. at initial load)
    if (initialHeight === toValue) {
      el.style.height = `${initialHeight}px`;
      return;
    }
    el.style.height = `${initialHeight}px`;
    animate({
      fromValue,
      toValue,
      duration: 300,
      delay: 200,
      onUpdate: (height, next) => {
        el.style.height = `${height}px`;
        next();
      },
      onStart: () => {
        isAnimating.current = true;
      },
      onComplete: () => {
        setLastShownError(error);
        isAnimating.current = false;
      }
    });
  }, [error]);
  const fieldsetRef = useRef(null);
  useOnFocusLeave(fieldsetRef, onLeave);
  useEffect(() => {
    const {
      current: container
    } = containerRef;
    container === null || container === void 0 ? void 0 : container.addEventListener('keydown', handleKeydown);
    return () => {
      return container === null || container === void 0 ? void 0 : container.removeEventListener('keydown', handleKeydown);
    };
  }, [containerRef, handleKeydown]);
  /**
   * This id is queried in RespWeb to calculate the offset for scroll-to-error animations in classic mode
   * ref: https://code.corp.surveymonkey.com/webplatform/smweb/pull/10725
   */
  let errorRowId;
  /** used in RespWeb for OQAATView */
  let fieldId;
  /** used in RespWeb for OQAATView */
  let questionTitleId;
  if (id) {
    errorRowId = createErrorRowId(id);
    fieldId = createFieldId(id);
    questionTitleId = createLegendId(id);
  }
  return React__default.createElement("div", {
    ref: containerRef,
    id: fieldId,
    ...props,
    className: containerStyles
  }, React__default.createElement(QuestionSpacing, {
    padding: padding,
    width: width
  }, React__default.createElement("div", {
    ref: errorRef,
    id: errorRowId,
    className: errorRow
  }, error || lastShownError), React__default.createElement("fieldset", {
    ref: fieldsetRef,
    className: formReset
  }, React__default.createElement("legend", {
    id: questionTitleId,
    className: headerRow,
    tabIndex: -1
  }, title), children), footer && React__default.createElement("div", {
    className: footerRow
  }, footer)));
}

/**
 * Calculate the max number of children each column can be filled in the layout
 * @param columns number of columns
 * @param total total child count
 * @description Based on the current implementation in production (as of Jan 20, 2021),
 * - if columns = 1, the max number of children per column = total (render all children vertically)
 * - if columns > 1, the max number of children per column = (total / columns) + 1
 */
const calculateMaxNumOfChildrenPerColumn = (columns, total) => {
  if (columns === 1) {
    return total;
  }
  const childrenPerColumn = total / columns;
  if (childrenPerColumn % 1 === 0) {
    return childrenPerColumn;
  }
  return Math.floor(childrenPerColumn) + 1;
};
/**
 * Divide the children array into slices for rendering
 * @param childrenArr - children array
 * @param maxCellsPerCol - maximum number of children per slice
 * @param totalColumns - number of columns
 * @example
 * childrenArr = [option1, option2, option3, option4, option5, option6, option7]
 * childrenPerSlice = 2
 * totalColumns = 3
 * output: [[option1, option2, option3], [option4, option5], [option6, option7]]
 */
const sliceChildren = (childrenArr, maxCellsPerCol, totalColumns) => {
  let index = 0;
  const result = [];
  const partialColumnsCount = totalColumns * maxCellsPerCol - childrenArr.length;
  // Calculate the number of fullColumns, to conditionally push slice with the correct # of cells
  let fullColumnsCount = totalColumns - partialColumnsCount;
  while (index < childrenArr.length) {
    if (fullColumnsCount > 0) {
      result.push(childrenArr.slice(index, index + maxCellsPerCol));
      index += maxCellsPerCol;
    } else {
      result.push(childrenArr.slice(index, index + maxCellsPerCol - 1));
      index += maxCellsPerCol - 1;
    }
    fullColumnsCount -= 1;
  }
  return result;
};
const useStyles$T = createUseStyles(theme => ({
  containerVertical: {
    display: 'initial'
  },
  containerHorizontal: {
    display: 'block'
  },
  /** shared between horizontal and vertical columns */
  column: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  columnHorizontal: {},
  /** Horizontal Column that adjust width to content width */
  columnHorizontalAutoAdjust: {
    width: 'auto'
  },
  [`@media (min-width: ${theme.breakpoints.xs.min})`]: {
    containerVertical: {
      display: 'flex'
    },
    containerHorizontal: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  },
  [`@media only screen and (min-width: ${theme.breakpoints.lg.min})`]: {
    columnHorizontal: {
      width: '19%'
    }
  },
  [`@media (min-width: ${theme.breakpoints.sm.min}) and (max-width: ${theme.breakpoints.md.max})`]: {
    columnHorizontal: {
      width: '24%'
    }
  },
  [`@media only screen and (max-width: ${theme.breakpoints.xxs.max})`]: {
    columnHorizontal: {
      width: '100%',
      display: 'block'
    },
    columnHorizontalAutoAdjust: {
      width: '100%',
      display: 'block'
    }
  },
  answerLayoutCell: ({
    gridCellMargin = '0'
  }) => ({
    margin: gridCellMargin,
    flex: [0, 0, 'auto'],
    wordBreak: 'normal',
    overflowWrap: 'anywhere'
  }),
  otherLayoutCell: ({
    otherCellMargin = '0'
  }) => ({
    margin: otherCellMargin
  })
}));
function QuestionAnswerLayoutTemplate({
  children,
  columns = 1,
  other,
  noneOfTheAbove,
  adjustToContent = false,
  gridCellMargin,
  otherCellMargin
}) {
  const {
    containerVertical,
    containerHorizontal,
    column,
    columnHorizontal,
    columnHorizontalAutoAdjust,
    answerLayoutCell,
    otherLayoutCell
  } = useStyles$T({
    columns,
    adjustToContent,
    gridCellMargin,
    otherCellMargin
  });
  const isHorizontal = columns === 'horizontal';
  /* Based on the columns config, divide the question answers
    (children of this component) into column groups for rendering.
       The reason we need to do this is when there are multiple columns,
    the answers are listed vertically instead of horizontally.
    For example:
    If there are 3 answers and 2 columns,
    Then the ordering will be:
    Answer 1    Answer 3
    Answer 2
       NOT:
    Answer 1    Answer 2
    Answer 3
    * though `horizontal` uses this
    
  */
  const columnGroups = useMemo(() => {
    const totalChildren = React__default.Children.count(children);
    const totalColumns = columns === 'horizontal' ? totalChildren : columns;
    const childrenArray = React__default.Children.toArray(children);
    if (!other && !!noneOfTheAbove && columns !== 'horizontal') {
      childrenArray.push(noneOfTheAbove);
    }
    const answersPerColumn = columns === 'horizontal' ? 1 : calculateMaxNumOfChildrenPerColumn(totalColumns, totalChildren + (!other && !!noneOfTheAbove ? 1 : 0));
    return sliceChildren(childrenArray, answersPerColumn, totalColumns);
  }, [children, columns, noneOfTheAbove, other]);
  const columnClassNames = isHorizontal ? [column, adjustToContent ? columnHorizontalAutoAdjust : columnHorizontal] : column;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: isHorizontal ? containerHorizontal : containerVertical
  }, columnGroups.map((col, columnIndex) => React__default.createElement("div", {
    key: `col-${columnIndex + 1}`,
    className: classNames(columnClassNames),
    "data-testid": "answer-layout-column"
  }, col.map((cell, cellIndex) => React__default.createElement("div", {
    key: `cell-${cellIndex + 1}`,
    "data-testid": "answer-layout-cell",
    className: answerLayoutCell
  }, cell))))), other && React__default.createElement("div", {
    className: otherLayoutCell
  }, other), (other && noneOfTheAbove || columns === 'horizontal') && React__default.createElement("div", {
    className: otherLayoutCell,
    "data-testid": "Other-NOTA"
  }, noneOfTheAbove));
}
function WarningIcon() {
  return React__default.createElement("g", {
    className: "warning-icon"
  }, React__default.createElement("path", {
    className: "background",
    transform: "translate(0 .49999)",
    d: "M8.49642,0.635797c.1494.086885.27371.210979.36079.360173L15.8621,12.9978c.2782.4766.1169,1.0883-.3602,1.3662-.1529.0891-.3267.136-.5037.136L1,14.5c-.552285,0-1-.4473-1-.999c0-.1766.046846-.35.135766-.5026L7.1291,0.996589c.27785-.476838.89002-.63837,1.36732-.360792Z",
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), React__default.createElement("path", {
    className: "foreground",
    transform: "translate(.000815 .49999)",
    d: "M8,11.2546c-.3797,0-.69349.2794-.74315.6419L7.25,11.9973v.26l.00685.1008C7.30651,12.7206,7.6203,13,8,13s.69349-.2794.74315-.6419L8.75,12.2573v-.26l-.00685-.1008C8.69349,11.534,8.3797,11.2546,8,11.2546ZM8,4c-.3797,0-.69349.2794-.74315.6419L7.25,4.74268v4.54393l.00685.10078c.04966.3625.36345.64191.74315.64191s.69349-.27941.74315-.64191L8.75,9.28661v-4.54393L8.74315,4.6419C8.69349,4.2794,8.3797,4,8,4Z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none"
  }));
}
var WarningIcon$1 = withSvgIcon(WarningIcon, 'WarningIcon');
const useStyles$S = createUseStyles(theme => {
  var _theme$breakpoints3;
  return {
    icon: {
      color: '#F05B24',
      fontSize: theme.fontSize.body,
      alignSelf: 'flex-start',
      marginTop: 2,
      flexShrink: 0
    },
    validationMessage: {
      fontFamily: theme.fontFamily,
      lineHeight: 1.5,
      color: '#333e48',
      fontWeight: 400,
      fontSize: 16,
      padding: theme.isDark ? 8 : [4, 0],
      backgroundColor: theme.isDark ? 'rgba(255, 255, 255, 0.9)' : '',
      borderRadius: 2,
      display: 'inline-flex',
      gap: 5,
      alignItems: 'center',
      marginBottom: 8,
      [`@media only screen and (max-width: ${(_theme$breakpoints3 = theme.breakpoints) === null || _theme$breakpoints3 === void 0 ? void 0 : _theme$breakpoints3.xxs.max})`]: {
        width: '100%',
        padding: theme.isDark ? 4 : [4, 0]
      }
    }
  };
});
function ValidationMessage({
  children,
  id,
  tag: Wrapper = 'span',
  ...props
}) {
  const {
    icon,
    validationMessage
  } = useStyles$S();
  return React__default.createElement(Wrapper, {
    className: validationMessage,
    "aria-live": "polite",
    id: id,
    ...props
  }, React__default.createElement(WarningIcon$1, {
    className: icon
  }), React__default.createElement("span", {
    translate: "no"
  }, children));
}
const useStyles$R = createUseStyles(theme => {
  const breakpointMedium = `@media only screen and (max-width: ${theme.breakpoints.md.max})`;
  const breakpointXsMin = `@media only screen and (min-width: ${theme.breakpoints.xs.min})`;
  const fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    inputArea: {
      fontFamily: theme.questionBody.fontFamily ?? {},
      fontWeight: fontWeightOptions.medium,
      fontSize: '18px',
      [breakpointMedium]: {
        fontSize: '16px'
      },
      lineHeight: '1.15em',
      padding: '6px 60px 6px 6px',
      maxWidth: '100%',
      [breakpointXsMin]: {
        // extra 66px to account for the padding
        width: ({
          cols
        }) => `calc(${cols}ch + 66px)`
      },
      width: '100%',
      border: `1px solid ${theme.answerColor}`,
      borderRadius: '0px',
      backgroundColor: '#fff',
      color: '#000',
      transition: 'all 0.1s linear',
      verticalAlign: 'top',
      textSizeAdjust: 'auto',
      '&:focus, &:hover': {
        outline: `2px solid ${theme.primaryAccentColor}`
      },
      '&:read-only:not(:disabled)': {
        borderColor: 'transparent',
        backgroundColor: theme.input.bgColor,
        color: theme.isDark ? '#fff' : '#000',
        opacity: 0.5
      },
      '&:disabled': {
        opacity: 0.4
      }
    }
  };
});
function TextArea({
  className,
  disabled = false,
  required = false,
  readOnly = false,
  cols = 50,
  ...props
}, forwardedRef) {
  const {
    inputArea
  } = useStyles$R({
    cols
  });
  return React__default.createElement("textarea", {
    className: classNames(inputArea, className),
    disabled: disabled,
    "aria-disabled": disabled,
    required: required,
    "aria-required": required,
    readOnly: readOnly,
    "aria-readonly": readOnly,
    spellCheck: true,
    ref: forwardedRef,
    ...props
  });
}
var TextArea$1 = forwardRef(TextArea);
const useStyles$Q = createUseStyles(theme => {
  const breakpointMedium = `@media only screen and (max-width: ${theme.breakpoints.md.max})`;
  const breakpointXsMin = `@media only screen and (min-width: ${theme.breakpoints.xs.min})`;
  const fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    inputField: {
      fontFamily: theme.questionBody.fontFamily ?? {},
      fontSize: '18px',
      [breakpointMedium]: {
        fontSize: '16px'
      },
      fontWeight: fontWeightOptions.medium,
      lineHeight: '1.5em',
      height: ({
        autoHeight
      }) => autoHeight ? {} : '50px',
      maxWidth: '100%',
      width: '100%',
      [breakpointXsMin]: {
        // extra 12px to account for the padding
        width: ({
          size
        }) => `calc(${size}ch + 12px)`
      },
      padding: '6px',
      border: `1px solid ${theme.answerColor}`,
      borderRadius: '0px',
      backgroundColor: '#fff',
      color: '#000',
      transition: 'all 0.1s linear',
      '&:focus, &:hover': {
        outline: `2px solid ${theme.primaryAccentColor}`
      },
      '&:read-only:not(:disabled)': {
        borderColor: 'transparent',
        backgroundColor: theme.input.bgColor,
        color: theme.isDark ? '#fff' : '#000',
        opacity: 0.5
      },
      '&:disabled': {
        opacity: 0.4
      }
    }
  };
});
function TextInput({
  className,
  autoHeight = false,
  size = 50,
  required = false,
  disabled = false,
  readOnly = false,
  onChange: handleChange,
  ...props
}, forwardedRef) {
  const {
    inputField
  } = useStyles$Q({
    autoHeight,
    size
  });
  return React__default.createElement("input", {
    type: "text",
    className: classNames(inputField, className),
    disabled: disabled,
    "aria-disabled": disabled,
    required: required,
    "aria-required": required,
    readOnly: readOnly,
    "aria-readonly": readOnly,
    spellCheck: true,
    onChange: handleChange,
    ...props,
    ref: forwardedRef
  });
}
var TextInput$1 = forwardRef(TextInput);
const useStyles$P = createUseStyles(theme => {
  return {
    commentLabelText: {
      ...theme.questionBody,
      marginBottom: 5,
      lineHeight: 1.25
    },
    commentLabel: {
      display: 'block'
    }
  };
});
function CommentChoice({
  label,
  lineCount = 3,
  charCount = 50,
  onChange,
  className,
  ...props
}) {
  const handleChange = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  const {
    commentLabel,
    commentLabelText
  } = useStyles$P();
  const multipleTextLines = lineCount > 1;
  return React__default.createElement("div", {
    className: className
  }, React__default.createElement("label", {
    id: `${props.id}-label`,
    htmlFor: props.id,
    className: commentLabel,
    tabIndex: -1
  }, React__default.createElement("div", {
    className: commentLabelText
  }, label), multipleTextLines ? React__default.createElement(TextArea$1, {
    onChange: handleChange,
    rows: lineCount,
    cols: charCount,
    ...props
  }) : React__default.createElement(TextInput$1, {
    autoHeight: true,
    onChange: handleChange,
    size: charCount,
    ...props
  })));
}

/**
 * Visually Hidden CSS properties
 * @description common css-properties to visually hide text and available for screen-readers.
 * There may be times where the css-specificity may not be high enough for the class to be invoked,
 * Ergo, the use of `!important` which will help ensure the properties are applied at any specificity.
 * @example
 * // usage with `react-jss`
 * import visuallyHiddenProperties from './utils/visuallyHidden';
 *
 * const useStyles = createUseStyles({
 *   srOnly: {...visuallyHiddenProperties}
 * })
 */
var visuallyHidden = {
  border: [[0], '!important'],
  /**
   * @desc for backwards compatibility
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip
   * @see https://caniuse.com/mdn-css_properties_clip
   */
  clip: ['rect(1px, 1px, 1px, 1px)', '!important'],
  /**
   * @desc future-proof version
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path
   * @see https://caniuse.com/css-clip-path
   */
  clipPath: ['inset(50%)', '!important'],
  height: ['1px', '!important'],
  margin: ['-1px', '!important'],
  overflow: ['hidden', '!important'],
  padding: [[0], '!important'],
  position: ['absolute', '!important'],
  width: ['1px', '!important'],
  /**
   * @desc preventing text to be condensed
   * @see https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
   */
  whiteSpace: ['nowrap', '!important']
};
const textReset = {
  margin: 0
};
const useStyles$O = createUseStyles(theme => {
  const {
    fontSize,
    ...questionTitleFormatting
  } = theme.questionTitle;
  const questionTitleFontSize = fontSize ?? {};
  return {
    srOnly: {
      ...visuallyHidden
    },
    addonContainer: {
      display: 'inline-block',
      margin: [0, 5],
      verticalAlign: 'text-bottom'
    },
    container: {
      position: 'relative',
      display: 'flex'
    },
    questionNumber: ({
      isRTL
    }) => ({
      margin: isRTL ? '0 0 0 0.25em' : '0 0.25em 0 0',
      flex: [0, 0]
    }),
    questionTitle: ({
      useDefaultFrontSize
    }) => {
      var _theme$questionTitle;
      return {
        ...textReset,
        ...questionTitleFormatting,
        color: ((_theme$questionTitle = theme.questionTitle) === null || _theme$questionTitle === void 0 ? void 0 : _theme$questionTitle.color) || theme.questionColor,
        fontSize: useDefaultFrontSize && !theme.isAccessible ? theme.fontSize.body : questionTitleFontSize,
        lineHeight: 1.25,
        whiteSpace: 'normal',
        wordWrap: 'break-word'
      };
    },
    requiredAsterisk: ({
      isRTL
    }) => ({
      display: 'inline-block',
      margin: isRTL ? '0 0 0 0.25em' : '0 0.25em 0 0'
    }),
    richText: {
      flex: [1, 0]
    }
  };
});
const COPY$e = defineMessages({
  REQUIRED: {
    id: 'RespondentQuestionTitle.REQUIRED',
    defaultMessage: '(Required.)',
    description: '[Type: label][Vis: medium] - visualy hidden required text'
  }
});
function RespondentQuestionTitle({
  element: Element = 'div',
  addon,
  heading,
  id,
  number,
  numbered,
  required,
  requiredAsterisk: showAsterisk,
  useDefaultFrontSize = false,
  ...props
}) {
  const {
    isRTL
  } = useContext(L10NContext);
  const {
    addonContainer,
    container,
    questionNumber,
    questionTitle,
    requiredAsterisk,
    richText,
    srOnly
  } = useStyles$O({
    useDefaultFrontSize,
    isRTL
  });
  return React__default.createElement(Element, {
    id: id,
    className: classNames(container, questionTitle),
    translate: "no",
    ...props
  }, required && showAsterisk && React__default.createElement("span", {
    "aria-hidden": true,
    className: requiredAsterisk
  }, "*"), numbered && React__default.createElement("span", {
    className: questionNumber
  }, number, "."), React__default.createElement(RichText, {
    element: "span",
    text: heading,
    className: richText
  }), required && React__default.createElement("span", {
    className: srOnly
  }, React__default.createElement(T, {
    desc: COPY$e.REQUIRED
  })), addon && React__default.createElement("span", {
    className: addonContainer
  }, addon));
}

// default text to be added as a translation to a specific version of Button directly.
const defaultOKConfig = {
  text: 'OK',
  visible: false
};
function QuestionField({
  id,
  title: titleProps,
  okButton: {
    visible: showButton,
    ...okButtonProps
  } = defaultOKConfig,
  error,
  errorId: errorIdProp,
  onLeave,
  padding = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  width,
  children,
  ...props
}) {
  const errorId = errorIdProp ?? createErrorId(id);
  return React__default.createElement(QuestionFieldLayoutTemplate, {
    footer: showButton && React__default.createElement(Button, {
      type: "button",
      ...okButtonProps
    }),
    hasFooterPadding: true,
    clickShield: false,
    error: error && React__default.createElement(ValidationMessage, {
      id: errorId
    }, error),
    onLeave: onLeave,
    id: id,
    padding: padding,
    width: width,
    title: React__default.createElement(RespondentQuestionTitle, {
      ...titleProps
    }),
    ...props
  }, children);
}
function useInputStyles({
  onChange,
  ...props
}) {
  /** extract props without affecting passthrough */
  const {
    checked: isChecked,
    defaultChecked: isDefaultChecked,
    disabled: isDisabled,
    'aria-disabled': isAriaDisabled,
    readOnly: isReadOnly,
    'aria-readonly': isAriaReadOnly
  } = props;
  /** configure style-props */
  const disabled = isDisabled || isAriaDisabled === 'true';
  const readOnly = isReadOnly || isAriaReadOnly === 'true';
  const [checked, setIsChecked] = useState(isDefaultChecked ?? isChecked ?? false);
  React__default.useEffect(() => {
    setIsChecked(isChecked ?? false);
  }, [isChecked]);
  /** handle change for checked style (controlled/uncontrolled) */
  const handleChange = e => {
    setIsChecked(e.target.checked);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  const styleProps = {
    checked,
    disabled,
    readOnly
  };
  const inputProps = {
    ...props,
    onChange: handleChange
  };
  return {
    styleProps,
    inputProps
  };
}
const radioGroupContext = createContext(undefined);
function useRadioGroup() {
  return useContext(radioGroupContext);
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, no-console */
function throwControlChangeError(isControlled, controlled, name, state) {
  const conState = ['controlled', 'uncontrolled'];
  const stateStr = isControlled ? conState : [...conState].reverse();
  if (isControlled !== (controlled !== undefined)) {
    console.error([`@sm/question-ui: A component is changing the ${stateStr[0]} ${state} state of ${name} to be ${stateStr[1]}.`, 'Elements should not switch from uncontrolled to controlled (or vice versa).', `Decide between using a controlled or uncontrolled ${name} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
  }
}
function throwDefaultStateError(isControlled, defaultValue, defaultProp, name, state) {
  if (!isControlled && defaultValue !== defaultProp) {
    console.error([`@sm/question-ui: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. `, `To suppress this warning opt to use a controlled ${name}.`].join('\n'));
  }
}
function useControlledState({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = React__default.useRef(controlled !== undefined);
  const [valueState, setValue] = React__default.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    const {
      current: defaultValue
    } = React__default.useRef(defaultProp);
    React__default.useEffect(() => {
      throwControlChangeError(isControlled, controlled, name, state);
      throwDefaultStateError(isControlled, defaultValue, defaultProp, name, state);
    }, [state, name, controlled, defaultProp]);
  }
  const setValueIfUncontrolled = React__default.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, [setValue]);
  return [value, setValueIfUncontrolled];
}
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  }
}
/**
 * useForkRef
 * Joins refs together and returns a combination of the two as a new ref
 *
 * @param refA
 * @param refB
 */
function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }
    return refValue => {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

/**
 * SMQ Tier 3
 */
function RadioGroup({
  children,
  name: nameProp,
  value: valueProp,
  defaultValue,
  onChange,
  disabled = false,
  readOnly = false,
  ...divProps
}) {
  const [value, setValueState] = useControlledState({
    controlled: valueProp,
    default: defaultValue,
    name: 'RadioGroup'
  });
  const handleChange = e => {
    setValueState(e.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  const name = nameProp;
  return React__default.createElement(radioGroupContext.Provider
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  , {
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      name,
      onChange: handleChange,
      value,
      disabled,
      readOnly
    }
  }, React__default.createElement("div", {
    role: "radiogroup",
    ...divProps
  }, children));
}
const useStyles$N = createUseStyles({
  inputContainer: {
    display: 'inline-flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1em',
    minWidth: '1em',
    cursor: 'pointer'
  },
  input: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    opacity: 0.00001,
    zIndex: 1,
    margin: 0,
    cursor: ({
      disabled,
      readOnly
    }) => disabled || readOnly ? 'default' : 'pointer',
    pointerEvents: ({
      disabled,
      readOnly
    }) => disabled || readOnly ? 'none' : undefined
  },
  controlIcon: {
    width: '100%',
    height: '100%',
    opacity: ({
      checked
    }) => checked ? 1 : 0,
    transition: 'opacity .2s linear'
  }
});
function BaseInput({
  element: Element = 'span',
  className,
  icon,
  checked: checkedProp,
  defaultChecked,
  onClick,
  onChange,
  ...inputProps
}, forwardedRef) {
  /** extract props without affecting passthrough */
  const {
    disabled: disabledProp,
    'aria-disabled': ariaDisabledProp,
    readOnly: readOnlyProp,
    'aria-readonly': ariaReadOnlyProp
  } = inputProps;
  const disabled = disabledProp || ariaDisabledProp === 'true';
  const readOnly = readOnlyProp || ariaReadOnlyProp === 'true';
  const [checked, setChecked] = useControlledState({
    controlled: checkedProp,
    default: defaultChecked,
    state: 'checked',
    name: 'BaseInput'
  });
  const handleChange = e => {
    if (e.nativeEvent.defaultPrevented) {
      return;
    }
    if (disabled || readOnly) {
      e.preventDefault();
      return;
    }
    const newChecked = e.target.checked;
    setChecked(newChecked);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  const handleClick = e => {
    if (disabled || readOnly) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  const {
    inputContainer,
    input,
    controlIcon
  } = useStyles$N({
    disabled,
    readOnly,
    checked
  });
  return React__default.createElement(Element, {
    className: classNames(inputContainer, className)
  }, React__default.createElement("input", {
    className: input,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    onChange: handleChange,
    onClick: handleClick,
    ...inputProps,
    ref: forwardedRef
  }), React__default.cloneElement(icon, {
    className: controlIcon
  }));
}
var BaseInput$1 = forwardRef(BaseInput);
function RadioIcon() {
  return React__default.createElement("g", {
    className: "radio-icon"
  }, React__default.createElement("ellipse", {
    fill: "currentColor",
    className: "background",
    transform: "translate(8 8)",
    rx: "8",
    ry: "8"
  }), React__default.createElement("path", {
    fill: "#fff",
    className: "checkmark",
    transform: "matrix(.91924 .91924 -.91924 .91924 -.72152 -9.5796)",
    d: "m14.521 0h1.4788v8h-5.0216l-0.002914-1.4404h3.5456l-1e-6 -6.5596z"
  }));
}
var RadioIcon$1 = withSvgIcon(RadioIcon, 'RadioIcon');
const useStyles$M = createUseStyles(theme => ({
  radioInput: {
    color: theme.isDark ? '#fff' : '#000',
    backgroundColor: ({
      checked
    }) => {
      if (checked) {
        return theme.isDark ? '#fff' : '#000';
      }
      return '#fff';
    },
    border: `1px solid ${theme.answerColor}`,
    borderRadius: '100%',
    '& .checkmark': {
      fill: theme.isDark ? '#000' : '#fff'
    },
    '&:focus-within': {
      boxShadow: `0 0 0 1px ${theme.primaryAccentColor}`,
      borderColor: '#fff'
    },
    '& input': {
      cursor: 'pointer'
    }
  }
}));
function RadioInput({
  className,
  ...props
}, forwardedRef) {
  const {
    inputProps,
    styleProps
  } = useInputStyles(props);
  const styles = useStyles$M(styleProps);
  return React__default.createElement(BaseInput$1, {
    type: "radio",
    className: classNames(styles.radioInput, className),
    icon: React__default.createElement(RadioIcon$1, null),
    ref: forwardedRef,
    ...inputProps
  });
}
var RadioInput$1 = forwardRef(RadioInput);

// get the margin top by taking the font size and the line height and divide by 2 to get the margin top
const marginTopHelper$1 = (height = 0, lineHeight = 1) => {
  return Math.max(0, (height * lineHeight - height) / 2); // no negative margins
};

const useStyles$L = createUseStyles(theme => {
  var _theme$questionBody3;
  return {
    controlLabel: ({
      checked,
      disabled
    }) => {
      const borderStyle = checked ? 'solid' : 'dashed';
      const borderColor = disabled && !checked ? 'transparent' : theme.questionColor;
      const fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
      return {
        display: 'flex',
        alignItems: 'start',
        cursor: 'pointer',
        padding: [5, 8, 7, 8],
        gap: 8,
        borderRadius: 4,
        border: [1, 'solid', checked ? theme.questionColor : 'transparent'],
        backgroundColor: checked ? theme.correctAnswerHighlightColor : 'transparent',
        ...theme.questionBody,
        lineHeight: 1.5,
        fontWeight: checked ? fontWeightOptions.medium : theme.questionBody.fontWeight ?? fontWeightOptions.light,
        '&:hover': {
          border: [1, borderStyle, borderColor]
        },
        '&:focus-within': {
          background: theme.correctAnswerHighlightColor
        }
      };
    },
    icon: {
      flexShrink: 0,
      fontSize: ({
        inputSize
      }) => inputSize ?? '1em',
      marginTop: marginTopHelper$1((_theme$questionBody3 = theme.questionBody) === null || _theme$questionBody3 === void 0 ? void 0 : _theme$questionBody3.fontSize, 1.5),
      // The following selector singles out Safari and Chrome on iOS14 to
      // implement a workaround for the lack of flex gap.
      '@supports (-webkit-touch-callout: none) and (not (translate: none))': {
        marginRight: 8
      }
    }
  };
});
function Radio({
  children: label = '',
  className,
  onChange,
  checked: checkedProp,
  name: nameProp,
  disabled: disabledProp,
  readOnly: readOnlyProp,
  inputSize,
  ...props
}, forwardedRef) {
  const radioGroup = useRadioGroup();
  let checked = checkedProp;
  let name = nameProp;
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  const disabled = (radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.disabled) ?? disabledProp;
  const readOnly = (radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.readOnly) ?? readOnlyProp;
  const handleChange = e => {
    const {
      id,
      checked: isChecked,
      value
    } = e.target;
    radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange({
      id,
      checked: isChecked,
      value
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id,
      checked: isChecked,
      value
    });
  };
  const {
    inputProps,
    styleProps
  } = useInputStyles({
    ...props,
    name,
    checked,
    disabled,
    readOnly,
    onChange: handleChange
  });
  const {
    controlLabel,
    icon
  } = useStyles$L({
    ...styleProps,
    inputSize
  });
  return React__default.createElement("label", {
    tabIndex: -1,
    htmlFor: props.id,
    className: classNames(controlLabel, className)
  }, React__default.createElement(RadioInput$1, {
    ...inputProps,
    ref: forwardedRef,
    className: icon
  }), React__default.createElement(RichText, {
    element: "span",
    text: label
  }));
}
var Radio$1 = forwardRef(Radio);
const useStyles$K = createUseStyles(theme => {
  const breakpointSmMax = `@media screen and (max-width: ${theme.breakpoints.sm.max})`;
  return {
    rowStyles: {
      borderRadius: '3px',
      textAlign: 'center',
      cursor: 'pointer',
      alignItems: 'center',
      padding: '3px',
      ...theme.questionBody,
      fontSize: '20px'
    },
    rowLabel: {
      margin: [0, 2, 0, 2],
      fontSize: '18px',
      padding: '3px',
      width: ({
        width = 60
      }) => `${width}%`,
      wordWrap: 'wrap',
      flexWrap: 'wrap',
      /**
       * There is a known jss issue that results in media query
       * checks not occurring for all mapped elements, hence the use of !important
       * https://github.com/cssinjs/jss/issues/1320
       * https://github.com/cssinjs/jss/issues/1327#issuecomment-707967909
       * Because function rules/values have higher source order specificity (rendered after static rules),
       * we're using !important to override that.
       * */
      [breakpointSmMax]: {
        width: ['50%', '!important']
      }
    },
    rowRadio: {
      justifyContent: 'center',
      gap: 0,
      padding: '3px',
      fontSize: 'inherit',
      width: ({
        radioWidth = 20
      }) => `${radioWidth}%`,
      [breakpointSmMax]: {
        width: ['25%', '!important']
      }
    }
  };
});
function BestWorstRow({
  id: rowId,
  label,
  value = null,
  columnIds = [],
  className,
  onChange,
  onClick,
  onKeyDown,
  width,
  ...props
}) {
  const DEFAULT_RADIO_WIDTH = 20;
  const [bestColId, worstColId] = columnIds;
  const bestRadioId = `${rowId}_${bestColId}`;
  const worstRadioId = `${rowId}_${worstColId}`;
  const labelId = `${rowId}_label`;
  const radioEvents = {
    onClick,
    onKeyDown
  };
  const radioWidth = width !== undefined ? (100 - width) / 2 : DEFAULT_RADIO_WIDTH;
  const handleChange = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: rowId,
      value: e.value,
      checked: e.checked
    });
  };
  const {
    rowStyles,
    rowLabel,
    rowRadio
  } = useStyles$K({
    width,
    radioWidth
  });
  return React__default.createElement(Row, {
    className: classNames(rowStyles, className),
    ...props
  }, React__default.createElement(Radio$1, {
    id: bestRadioId,
    className: rowRadio,
    value: bestColId,
    name: rowId,
    checked: value === bestColId,
    "aria-labelledby": `${bestColId} ${labelId}`,
    onChange: handleChange,
    ...radioEvents
  }), React__default.createElement("span", {
    className: rowLabel
  }, React__default.createElement(RichText, {
    id: labelId,
    element: "span",
    text: label
  })), React__default.createElement(Radio$1, {
    id: worstRadioId,
    className: rowRadio,
    value: worstColId,
    name: rowId,
    checked: value === worstColId,
    "aria-labelledby": `${worstColId} ${labelId}`,
    onChange: handleChange,
    ...radioEvents
  }));
}
const useStyles$J = createUseStyles(theme => {
  const breakpointSmMax = `@media screen and (max-width: ${theme.breakpoints.sm.max})`;
  return {
    rowList: {
      '& > :nth-child(even)': {
        backgroundColor: theme.input.bgColor
      }
    },
    headerColumn: ({
      radioWidth = 20
    }) => ({
      display: 'table',
      width: `${radioWidth}%`,
      padding: '5px 8px',
      alignItems: 'center',
      textAlign: 'center',
      ...theme.questionBody,
      fontSize: '20px',
      fontWeight: 500,
      [breakpointSmMax]: {
        width: '25%'
      }
    }),
    labelColumn: ({
      labelWidth = 60
    }) => ({
      display: 'table',
      width: `${labelWidth}%`,
      margin: [0, 2, 0, 2],
      padding: '3px',
      [breakpointSmMax]: {
        width: '50%'
      }
    })
  };
});
function BestWorst({
  id: questionId,
  disabled: _dis,
  readOnly: _ro,
  choices: fields = [],
  responses = [],
  columnChoices = [],
  onChange,
  labelWidth,
  ...questionFieldProps
}) {
  const DEFAULT_RADIO_WIDTH = 20;
  const [selectedChoices, setSelectedChoices] = useState(responses);
  const [bestAnswerColumn, worstAnswerColumn] = columnChoices;
  const columnIds = columnChoices === null || columnChoices === void 0 ? void 0 : columnChoices.map(c => c.id);
  const errorId = createErrorId(questionId);
  const radioWidth = labelWidth !== undefined ? (100 - labelWidth) / 2 : DEFAULT_RADIO_WIDTH;
  /** Filter choices that exist and are visible  */
  const {
    options: rowFields
  } = useQuestionChoices(fields);
  /** determines whether a radio should be rendered as checked or unchecked */
  const getRadioSelection = id => {
    var _selectedChoices$find;
    return ((_selectedChoices$find = selectedChoices.find(c => c.id === id)) === null || _selectedChoices$find === void 0 ? void 0 : _selectedChoices$find.value[0].id) ?? '';
  };
  /** unChecks selected choice  */
  const unCheckOption = radioId => {
    const newChoices = selectedChoices.filter(c => !radioId.match(c.id));
    setSelectedChoices(newChoices);
    onChange === null || onChange === void 0 ? void 0 : onChange(newChoices);
  };
  /** handles adding new checked selection to responses */
  const handleChange = e => {
    let newChoices = [];
    const rowId = e.id;
    const rowValue = e.value;
    /** remove any other checked radio in the same row or column */
    newChoices = selectedChoices.filter(row => !(row.id === rowId || row.value.find(col => col.value === rowValue)));
    newChoices.push({
      id: rowId,
      value: [{
        id: rowValue,
        value: rowValue
      }]
    });
    setSelectedChoices(newChoices);
    onChange === null || onChange === void 0 ? void 0 : onChange(newChoices);
  };
  const handleClick = e => {
    const input = e.target;
    const isSelected = selectedChoices.find(c => input.id.match(c.id));
    if (isSelected && input.checked) {
      unCheckOption(input.id);
    }
  };
  const handleKeyboard = e => {
    const input = e.target;
    const isSelected = selectedChoices.find(c => input.id.match(c.id));
    if (e.code === 'Space' && isSelected) {
      e.preventDefault();
      unCheckOption(input.id);
    }
  };
  const {
    headerColumn,
    rowList,
    labelColumn
  } = useStyles$J({
    labelWidth,
    radioWidth
  });
  return (
    /*
      NOTE: The id has been modified to work in hybrid mode. The id needs to
      be different from the question-field id created in the responseweb.
    */
    React__default.createElement(QuestionField, {
      id: `hybrid-${questionId}`,
      "data-testid": "BestWorstQuestionType",
      ...questionFieldProps
    }, React__default.createElement("div", {
      className: rowList
    }, React__default.createElement(Row, null, React__default.createElement(RichText, {
      id: bestAnswerColumn === null || bestAnswerColumn === void 0 ? void 0 : bestAnswerColumn.id,
      element: "span",
      text: bestAnswerColumn === null || bestAnswerColumn === void 0 ? void 0 : bestAnswerColumn.label,
      className: classNames(headerColumn)
    }), React__default.createElement("span", {
      className: classNames(headerColumn, labelColumn)
    }), React__default.createElement(RichText, {
      id: worstAnswerColumn === null || worstAnswerColumn === void 0 ? void 0 : worstAnswerColumn.id,
      element: "span",
      text: worstAnswerColumn === null || worstAnswerColumn === void 0 ? void 0 : worstAnswerColumn.label,
      className: classNames(headerColumn)
    })), rowFields === null || rowFields === void 0 ? void 0 : rowFields.map(field => {
      const rowId = `${questionId}_${field.id}`;
      return React__default.createElement(BestWorstRow, {
        key: rowId,
        id: rowId,
        label: field.label,
        width: labelWidth,
        value: getRadioSelection(rowId),
        columnIds: columnIds,
        onChange: handleChange,
        onClick: handleClick,
        onKeyDown: handleKeyboard,
        "aria-describedby": questionFieldProps.error && errorId || undefined
      });
    })))
  );
}
var BestWorst$1 = withErrorBoundary(BestWorst);
function CheckboxIcon() {
  return React__default.createElement("g", {
    className: "checkbox-icon"
  }, React__default.createElement("rect", {
    fill: "currentColor",
    className: "background",
    width: "16",
    height: "16",
    rx: "2",
    ry: "2"
  }), React__default.createElement("path", {
    fill: "#fff",
    className: "checkmark",
    transform: "matrix(.91924 .91924 -.91924 .91924 -.72152 -9.5796)",
    d: "m14.521 0h1.4788v8h-5.0216l-0.002914-1.4404h3.5456l-1e-6 -6.5596z"
  }));
}
var CheckboxIcon$1 = withSvgIcon(CheckboxIcon, 'CheckboxIcon');
function SelectIcon() {
  return React__default.createElement("g", {
    className: "select-icon"
  }, React__default.createElement("polygon", {
    className: "select-arrow select-arrow-top",
    transform: "matrix(1.4619 0 0 1.4619 5.8783 5.4791)",
    points: "1.4514 -3.0633 5.5556 1.0409 -2.6529 1.0409",
    fill: "currentColor",
    stroke: "transparent",
    strokeLinejoin: "round",
    strokeWidth: ".5"
  }), React__default.createElement("polygon", {
    className: "select-arrow select-arrow-bottom",
    transform: "matrix(-1.4619 0 0 -1.4619 10.122 10.522)",
    points: "1.4514 -3.0633 5.5556 1.0409 -2.6529 1.0409",
    fill: "currentColor",
    stroke: "transparent",
    strokeLinejoin: "round",
    strokeWidth: ".5"
  }));
}
var SelectIcon$1 = withSvgIcon(SelectIcon, 'SelectIcon');
function CaretDown() {
  return React__default.createElement("g", {
    className: "caret-down-icon"
  }, React__default.createElement("path", {
    d: "M13.254 4c.19.001.38.088.526.26.267.316.29.81.073 1.158l-.073.1L8.53 11.74l-.084.086a.66.66 0 0 1-.901-.007l-.076-.08L2.22 5.523l-.073-.1a1.024 1.024 0 0 1 0-1.058l.073-.1.084-.085a.674.674 0 0 1 .446-.175V4h10.504z",
    fill: "currentColor"
  }));
}
var CaretDownIcon = withSvgIcon(CaretDown, 'CaretDownIcon');
function CaretDownOutline() {
  return React__default.createElement("g", {
    className: "caret-down-icon"
  }, React__default.createElement("path", {
    d: "m922.74 642.16l-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    transform: "matrix(-.016568 0 0 -.016568 15.842 16.026)",
    fill: "currentcolor"
  }));
}
var CaretDownOutlineIcon = withSvgIcon(CaretDownOutline, 'CaretDownOutlineIcon');
function CaretUpOutline() {
  return React__default.createElement("g", {
    className: "caret-up-icon"
  }, React__default.createElement("path", {
    d: "m922.74 642.16-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    transform: "matrix(.016568 0 0 .016568 .15803 -.025552)",
    fill: "currentcolor"
  }));
}
var CaretUpOutlineIcon = withSvgIcon(CaretUpOutline, 'CaretUpOutlineIcon');
function CaretLeftOutline() {
  return React__default.createElement("g", {
    className: "caret-left-icon"
  }, React__default.createElement("path", {
    transform: "matrix(0 -.016568 .016568 0 -.025552 15.842)",
    d: "m922.74 642.16-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    fill: "currentcolor"
  }));
}
var CaretLeftOutlineIcon = withSvgIcon(CaretLeftOutline, 'CaretLeftOutlineIcon');
function CaretRightOutline() {
  return React__default.createElement("g", {
    className: "caret-right-icon"
  }, React__default.createElement("path", {
    transform: "matrix(0 .016568 -.016568 0 16.026 .15803)",
    d: "m922.74 642.16-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    fill: "currentcolor"
  }));
}
var CaretRightOutlineIcon = withSvgIcon(CaretRightOutline, 'CaretRightOutlineIcon');
function DragHandleIcon() {
  return React__default.createElement("g", {
    className: "drag-handle-icon"
  }, React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 2)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }), React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 5.3333)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }), React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 8.6667)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }), React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 12)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }));
}
var DragHandleIcon$1 = withSvgIcon(DragHandleIcon, 'DragHandleIcon');
function Calendar() {
  return React__default.createElement("g", {
    fill: "currentcolor",
    transform: "matrix(.031614 0 0 .031614 .33438 .33438)"
  }, React__default.createElement("path", {
    d: "m405.17 363.15h-55.727c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.727c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4z"
  }), React__default.createElement("path", {
    d: "m314.23 363.15h-55.727c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.727c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4z"
  }), React__default.createElement("path", {
    d: "m223.28 363.15h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4z"
  }), React__default.createElement("path", {
    d: "m132.34 363.15h-55.725c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.726c2.209 0 4-1.791 4-4v-48.256c-1e-3 -2.209-1.792-4-4.001-4z"
  }), React__default.createElement("path", {
    d: "m349.44 340.41h55.727c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.727c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m258.5 340.41h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m167.56 340.41h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m76.611 340.41h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m349.44 261.41h55.727c2.209 0 4-1.791 4-4v-48.255c0-2.209-1.791-4-4-4h-55.727c-2.209 0-4 1.791-4 4v48.255c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m258.5 261.41h55.727c2.209 0 4-1.791 4-4v-48.255c0-2.209-1.791-4-4-4h-55.727c-2.209 0-4 1.791-4 4v48.255c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m363.37 114.86h6.938c10.543 0 19.09-8.549 19.09-19.091v-72.39c0-10.54-8.547-19.089-19.09-19.089h-6.938c-10.545 0-19.092 8.549-19.092 19.089v72.389c2e-3 10.543 8.549 19.092 19.092 19.092z"
  }), React__default.createElement("path", {
    d: "m118.5 115.33h6.938c10.544 0 19.091-8.55 19.091-19.091v-72.389c0-10.541-8.547-19.09-19.091-19.09h-6.938c-10.543 0-19.09 8.549-19.09 19.09v72.389c0 10.541 8.547 19.091 19.09 19.091z"
  }), React__default.createElement("path", {
    d: "M453.916,43.558h-48.996v57.209c0,19.084-15.525,29.61-34.607,29.61h-6.938c-19.084,0-34.609-15.526-34.609-34.61v-52.209h-168.713v52.682c0,19.084-15.525,34.61-34.609,34.61h-6.938c-19.083,0-34.608-15.526-34.608-34.61v-52.682h-52.862C13.923,43.558,0,57.481,0,74.595v375.03c0,17.114,13.923,31.037,31.036,31.037h422.88c17.113,0,31.035-13.923,31.035-31.037v-375.03c.002-17.113-13.922-31.037-31.035-31.037Zm0,406.067h-422.879l-.001-283.213h422.886l.016,283.212c-.002,0-.008.001-.022.001Z"
  }));
}
var CalendarIcon = withSvgIcon(Calendar, 'CalendarIcon');
function CheckOutlineIcon() {
  return React__default.createElement("g", {
    className: "checkoutline-icon"
  }, React__default.createElement("path", {
    fill: "currentcolor",
    transform: "matrix(.8 0 0 0.8-1.6-1.6)",
    d: "M10.6,13.8L8.45,11.65q-.275-.275-.7-.275t-.7.275-.275.7.275.7L9.9,15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7-.7-.275-.7.275L10.6,13.8ZM12,22q-2.075,0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175t-.788-3.9q0-2.075.788-3.9t2.137-3.175Q6.275,3.575,8.1,2.788t3.9-.788q2.075,0,3.9.788t3.175,2.137q1.35,1.35,2.138,3.175t.787,3.9q0,2.075-.788,3.9t-2.137,3.175q-1.35,1.35-3.175,2.138t-3.9.787Zm0-2q3.35,0,5.675-2.325t2.325-5.675-2.325-5.675-5.675-2.325-5.675,2.325Q4,8.65,4,12t2.325,5.675t5.675,2.325Zm0-8"
  }));
}
var CheckOutlineIcon$1 = withSvgIcon(CheckOutlineIcon, 'CheckOutlineIcon');
function CloseOutlineIcon() {
  return React__default.createElement("g", {
    className: "closeoutline-icon",
    fill: "currentColor"
  }, React__default.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm6.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0zm-3.318-3.182a.75.75 0 0 1 0 1.06L9.061 8l2.121 2.121a.75.75 0 0 1-1.06 1.061L8 9.061l-2.121 2.121a.75.75 0 0 1-1.061-1.06L6.939 8 4.818 5.879a.75.75 0 0 1 1.06-1.061L8 6.939l2.121-2.121a.75.75 0 0 1 1.061 0z"
  }));
}
var CloseOutlineIcon$1 = withSvgIcon(CloseOutlineIcon, 'CloseOutlineIcon');
function CloudArrowUpIcon() {
  return React__default.createElement("g", {
    className: "cloudarrowup-icon",
    fill: "currentColor"
  }, React__default.createElement("path", {
    d: "m8.446 6.397.084.073 2.5 2.5a.75.75 0 0 1-.976 1.133l-.084-.073-1.22-1.219v5.439a.75.75 0 0 1-1.493.102l-.007-.102V8.811l-1.22 1.22a.75.75 0 0 1-.976.072l-.084-.073a.75.75 0 0 1-.073-.976l.073-.084 2.5-2.5a.75.75 0 0 1 .976-.073zM9.5 1a4.75 4.75 0 0 1 4.677 5.586l-.057.271-.013.046.113.06a3.499 3.499 0 0 1 1.757 2.64l.018.213.005.193a3.491 3.491 0 0 1-3.3 3.486l-.191.005H10.75a.75.75 0 1 1 0-1.5h1.759c1.05 0 1.91-.812 1.986-1.843l.005-.148c0-.922-.63-1.717-1.511-1.936a.75.75 0 0 1-.507-1.027 3.25 3.25 0 1 0-6.1-2.213.75.75 0 0 1-1.07.453l-.217-.136a1.25 1.25 0 0 0-1.716 1.654l.12.212a.75.75 0 0 1-.494 1.048 1.998 1.998 0 0 0 .346 3.93L3.5 12h1.75a.75.75 0 1 1 0 1.5H3.5a3.5 3.5 0 0 1-3.495-3.308L0 10c0-1.217.626-2.308 1.597-2.936l.175-.107.063-.034-.02-.08-.036-.195-.022-.198-.007-.2a2.75 2.75 0 0 1 3.18-2.717l.209.042.12.033.094-.177a4.753 4.753 0 0 1 3.692-2.41l.236-.016L9.5 1z"
  }));
}
var CloudArrowUpIcon$1 = withSvgIcon(CloudArrowUpIcon, 'CloudArrowUpIcon');
function HeartIcon() {
  return React__default.createElement("g", {
    className: "heart-icon"
  }, React__default.createElement("path", {
    d: "m14.78 2.259c-0.77098-0.8019-1.8346-1.2563-2.947-1.259-1.1121 0.002982-2.1753 0.45735-2.946 1.259l-0.887 0.915-0.889-0.915c-0.76906-0.80332-1.8329-1.2576-2.945-1.2576s-2.1759 0.4543-2.945 1.2576c-1.628 1.677-1.628 4.396 0 6.074l6.243 6.438c0.13979 0.14616 0.33325 0.22883 0.5355 0.22883s0.39571-0.082668 0.5355-0.22883l6.244-6.438c0.7858-0.81546 1.2237-1.9046 1.221-3.037 0-1.14-0.44-2.232-1.22-3.037z",
    fill: "currentColor"
  }));
}
var HeartIcon$1 = withSvgIcon(HeartIcon, 'HeartIcon');
function StarIcon() {
  return React__default.createElement("g", {
    className: "star-icon"
  }, React__default.createElement("path", {
    d: "M5.738,5.528l-4.999.008-.103.007c-.634.085-.878.933-.34,1.345l4.06,3.105-1.548,5.028-.023.094c-.12.65.623,1.149,1.17.732L8,12.772l4.044,3.075.08.053c.564.332,1.272-.215,1.068-.879l-1.55-5.028l4.062-3.105.078-.069c.457-.454.152-1.282-.521-1.283l-5-.008L8.704,0.525c-.093271-.310889-.379421-.523792-.704-.523792s-.610729.212903-.704.523792L5.738,5.528Z",
    fill: "currentColor"
  }));
}
var StarIcon$1 = withSvgIcon(StarIcon, 'StarIcon');
function ThumbsUpIcon() {
  return React__default.createElement("g", {
    className: "thumbs-up-icon"
  }, React__default.createElement("path", {
    d: "M10,2.509c.125.598.06,1.217-.048,1.737l-.068.298-.073.269-.166.567c-.02.08-.022.122,0,.122h5.105c.462363-.026197.901269.205584,1.140346.602205s.239077.892969,0,1.28959-.677983.628402-1.140346.602205h-.5c.462363-.026197.901269.205584,1.140346.602205s.239077.892969,0,1.28959-.677983.628402-1.140346.602205l-.5.001c.462363-.026197.901269.205584,1.140346.602205s.239077.892969,0,1.28959-.677983.628402-1.140346.602205h-.75c.364265-.011529.705904.176222.891446.489903s.185543.703512,0,1.017194-.527181.501432-.891446.489903L8.078,15l-1.526-.013-.13-.005c-.378-.023-.8-.155-1.263-.397-.097921-.05214-.159074-.154063-.159-.265v-8.148c-.000163-.095485.045138-.185345.122-.242c1.113-.812,1.834-1.54,2.162-2.182.15-.303.245-.653.328-1l.12-.51c.148-.606.32-1.117.769-1.226.33-.08,1.23.205,1.5,1.497ZM2.8,6.001c.386209,0,.699448.312791.7.699v7.084c-.000552.386209-.313791.699-.7.699h-2.1c-.386209,0-.699448-.312791-.7-.699L0,6.7c0-.185652.07375-.363699.205025-.494975s.309323-.205025.494975-.205025h2.1Z",
    fill: "currentColor"
  }));
}
var ThumbsUpIcon$1 = withSvgIcon(ThumbsUpIcon, 'ThumbsUpIcon');
function SmileyIcon() {
  return React__default.createElement("g", {
    className: "smiley-icon"
  }, React__default.createElement("path", {
    d: "m8 0c4.4183 0 8 3.5817 8 8s-3.5817 8-8 8-8-3.5817-8-8 3.5817-8 8-8zm3.738 8.815c-0.1822-0.079843-0.38866-0.08403-0.57395-0.01164s-0.33423 0.21543-0.41405 0.39764c-0.4769 1.0938-1.5567 1.801-2.75 1.801s-2.2731-0.7072-2.75-1.801c-0.16624-0.37942-0.60858-0.55224-0.988-0.386s-0.55224 0.60858-0.386 0.988c0.71589 1.6395 2.335 2.6993 4.124 2.6993s3.4081-1.0597 4.124-2.6993c0.079843-0.1822 0.08403-0.38866 0.01164-0.57395s-0.21543-0.33423-0.39764-0.41405zm-7.238-3.315c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1 1-0.44772 1-1-0.44772-1-1-1zm7 0c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1 1-0.44772 1-1-0.44772-1-1-1z",
    fill: "currentColor"
  }));
}
var SmileyIcon$1 = withSvgIcon(SmileyIcon, 'SmileyIcon');
function InfoIcon() {
  return React__default.createElement("g", {
    className: "info-icon"
  }, React__default.createElement("path", {
    fill: "currentcolor",
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm.775 6.632c-.081-.613-.868-.877-1.302-.39L5.94 7.963l-.067.088a.746.746 0 0 0 .13.967l.088.067c.305.2.72.15.969-.13l.224-.252.001 4.498.007.106c.082.613.868.877 1.302.39l1.567-1.756.068-.088a.746.746 0 0 0-.129-.967l-.088-.067a.75.75 0 0 0-.97.128l-.26.29.001-4.5zm-.742-4.181a.748.748 0 0 0-.749.747v1.05l.007.102a.749.749 0 0 0 1.491-.101V3.198l-.007-.101a.749.749 0 0 0-.742-.646z"
  }));
}
var InfoIcon$1 = withSvgIcon(InfoIcon, 'InfoIcon');
const useStyles$I = createUseStyles(theme => ({
  checkboxInput: ({
    checked,
    disabled,
    readOnly
  }) => {
    const checkBgColor = checked ? theme.questionColor : '#fff';
    const backgroundColor = disabled || readOnly ? '#aaa' : checkBgColor;
    return {
      color: disabled || readOnly ? '#aaa' : theme.questionColor,
      borderRadius: 2,
      backgroundColor,
      border: `1px solid ${disabled || readOnly ? '#aaa' : theme.questionColor}`,
      '& .checkmark': {
        fill: theme.isDark ? '#000' : '#fff'
      },
      '&:focus-within': {
        boxShadow: `0 0 0 1px ${theme.primaryAccentColor}`,
        borderColor: '#fff'
      },
      '& input': {
        cursor: 'pointer'
      }
    };
  }
}));
function CheckboxInput({
  className,
  ...props
}, ref) {
  const {
    inputProps,
    styleProps
  } = useInputStyles(props);
  const {
    checkboxInput
  } = useStyles$I(styleProps);
  return React__default.createElement(BaseInput$1, {
    ref: ref,
    type: "checkbox",
    className: classNames(checkboxInput, className),
    icon: React__default.createElement(CheckboxIcon$1, null),
    ...inputProps
  });
}
var CheckboxInput$1 = React__default.forwardRef(CheckboxInput);

// get the margin top by taking the font size and the line height and divide by 2 to get the margin top
const marginTopHelper = (height = 0, lineHeight = 1) => {
  return Math.max(0, (height * lineHeight - height) / 2); // no negative margins
};

const useStyles$H = createUseStyles(theme => {
  var _theme$questionBody4;
  return {
    checkboxContainer: ({
      checked,
      disabled
    }) => {
      const borderStyle = checked ? 'solid' : 'dashed';
      const borderColor = disabled && !checked ? 'transparent' : theme.questionColor;
      const fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
      return {
        display: 'flex',
        alignItems: 'start',
        cursor: 'pointer',
        padding: [5, 8, 7, 8],
        gap: 8,
        borderRadius: 4,
        border: [1, 'solid', checked ? theme.questionColor : 'transparent'],
        backgroundColor: checked ? theme.input.bgColor : 'inherit',
        ...theme.questionBody,
        lineHeight: 1.5,
        fontWeight: checked ? fontWeightOptions.medium : theme.questionBody.fontWeight ?? fontWeightOptions.light,
        '&:hover': {
          border: [1, borderStyle, borderColor]
        },
        '&:focus-within': {
          background: theme.input.bgColor
        }
      };
    },
    icon: {
      flexShrink: 0,
      fontSize: ({
        inputSize
      }) => inputSize ?? '1em',
      marginTop: marginTopHelper((_theme$questionBody4 = theme.questionBody) === null || _theme$questionBody4 === void 0 ? void 0 : _theme$questionBody4.fontSize, 1.5),
      // The following selector singles out Safari and Chrome on iOS14 to
      // implement a workaround for the lack of flex gap.
      '@supports (-webkit-touch-callout: none) and (not (translate: none))': {
        marginRight: 8
      }
    }
  };
});
function Checkbox$2({
  children: label = '',
  inputSize,
  onChange,
  ...props
}, ref) {
  const handleChange = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: e.target.id,
      checked: e.target.checked,
      value: e.target.value
    });
  };
  const {
    inputProps,
    styleProps
  } = useInputStyles({
    ...props,
    onChange: handleChange
  });
  const {
    checkboxContainer,
    icon
  } = useStyles$H({
    ...styleProps,
    inputSize
  });
  return React__default.createElement("label", {
    htmlFor: inputProps.id,
    className: checkboxContainer,
    tabIndex: -1
  }, React__default.createElement(CheckboxInput$1, {
    ref: ref,
    ...inputProps,
    className: icon
  }), React__default.createElement(RichText, {
    element: "span",
    text: label
  }));
}
var Checkbox$3 = forwardRef(Checkbox$2);
const useStyles$G = createUseStyles(theme => ({
  checkbox: {
    '& label': {
      alignItems: 'baseline'
    }
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  textInput: {
    opacity: ({
      isChecked
    }) => isChecked ? 1 : 0.5,
    marginTop: 5,
    marginLeft: 32,
    maxWidth: 'calc(100% - 32px)',
    [`@media (max-width: ${theme.breakpoints.xxs.max})`]: {
      marginLeft: 0,
      maxWidth: '100%'
    },
    // overwrite TextInput styles
    fontSize: theme.questionBody.fontSize,
    lineHeight: 'normal'
  },
  checkHover: {
    '&:hover': {
      outline: 'none',
      cursor: 'pointer'
    }
  }
}));
function CheckboxTextfield(props) {
  const {
    id,
    children: label,
    value: inputValue = '',
    defaultValue,
    maxLength,
    onClick,
    onKeyDown,
    onChange,
    checked: checkedProp = false,
    ...checkboxProps
  } = props;
  const [isChecked, setIsChecked] = useState(checkedProp);
  const [value, setValue] = React__default.useState(defaultValue || inputValue);
  const {
    checkbox,
    textInput,
    checkHover
  } = useStyles$G({
    isChecked
  });
  const handleValueChange = e => {
    setValue(e.value);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id,
      value: e.value,
      checked: e.checked
    });
  };
  const handleInputChange = e => {
    if (!isChecked) {
      setIsChecked(true);
    }
    handleValueChange({
      id,
      value: e.target.value,
      checked: true
    });
  };
  const inputRef = React__default.useRef(null);
  const handleCheckboxClick = e => {
    if (!isChecked && e.clientX !== 0 && e.clientY !== 0) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
    setIsChecked(!isChecked);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  const handleTextboxClick = () => {
    if (!isChecked) {
      setIsChecked(true);
    }
    handleValueChange({
      id,
      value,
      checked: true
    });
  };
  const handleKeyDown = e => {
    if (e.code === 'Space') {
      e.preventDefault();
      setIsChecked(!isChecked);
      handleValueChange({
        id,
        value,
        checked: !isChecked
      });
      return;
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  };
  React__default.useEffect(() => {
    setIsChecked(checkedProp);
  }, [checkedProp]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Checkbox$3, {
    id: `checkbox-input-${id}`,
    checked: isChecked,
    onKeyDown: handleKeyDown,
    onClick: handleCheckboxClick,
    onChange: handleValueChange,
    className: checkbox,
    value: value,
    maxLength: maxLength,
    ...checkboxProps
  }, label), React__default.createElement(TextInput$1, {
    id: `checkbox-field-${id}`,
    onChange: handleInputChange,
    onClick: handleTextboxClick,
    className: classNames(textInput, {
      [checkHover]: !isChecked
    }),
    defaultValue: defaultValue,
    autoHeight: true,
    maxLength: maxLength,
    tabIndex: isChecked ? 0 : -1,
    ref: inputRef
  }));
}

/**
 * Maximum input characters is 20,000
 * Resolves: RAWR-1186
 */
const TEXT_INPUT_MAX_CHARS = 20000;
const useStyles$F = createUseStyles({
  commentChoiceContainer: {
    marginTop: '10px'
  }
});
const INPUT_SIZE$2 = 20;
function Checkbox({
  id: questionId,
  required: _req,
  readOnly: _ro,
  disabled,
  columnLayout,
  choices = [],
  responses = [],
  choiceNoneOfTheAbove,
  choiceOther,
  choiceComment,
  onChange,
  ...questionFieldProps
}) {
  const [selectedChoices, setSelectedChoices] = useState(responses);
  const errorId = createErrorId(questionId);
  /**
   * Default value by id
   * used for text-input based choices
   */
  const getDefaultValueById = id => {
    var _responses$find;
    return (_responses$find = responses.find(c => c.id === id)) === null || _responses$find === void 0 ? void 0 : _responses$find.value;
  };
  const handleDefault = id => {
    var _responses$find2;
    return (_responses$find2 = responses.find(c => c.id === id)) === null || _responses$find2 === void 0 ? void 0 : _responses$find2.value;
  };
  const isChecked = id => !!selectedChoices.find(item => item.id === id);
  const handleChange = e => {
    // 1. remove NOTA from array
    const newState = selectedChoices.filter(c => c.id !== e.id && c.type !== 'NOTA');
    // 2. if e.target.checked remove item from array
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const handleNAChange = e => {
    const newState = selectedChoices.filter(c => c.type === 'COMMENT');
    // 2. if e.target.checked remove item from array
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value,
        type: 'NOTA'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const handleOtherChange = e => {
    const newState = selectedChoices.filter(c => c.id !== e.id && c.type !== 'NOTA');
    // 2. if e.target.checked remove item from array
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value,
        type: 'ANSWER'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const handleCommentChange = e => {
    const newState = selectedChoices.filter(c => c.type !== 'COMMENT');
    if (newState && !!e.target.value) {
      newState.push({
        id: e.target.id,
        value: e.target.value,
        type: 'COMMENT'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const {
    commentChoiceContainer
  } = useStyles$F();
  return React__default.createElement(QuestionField, {
    id: questionId,
    "data-testid": "CheckboxQuestionType",
    ...questionFieldProps
  }, React__default.createElement(QuestionAnswerLayoutTemplate, {
    gridCellMargin: [0, 2, 5, 2],
    otherCellMargin: [0, 2, 5, 2],
    noneOfTheAbove: choiceNoneOfTheAbove && (choiceNoneOfTheAbove === null || choiceNoneOfTheAbove === void 0 ? void 0 : choiceNoneOfTheAbove.visible) && React__default.createElement(Checkbox$3, {
      id: choiceNoneOfTheAbove.id,
      value: choiceNoneOfTheAbove.id,
      onChange: handleNAChange,
      checked: isChecked(choiceNoneOfTheAbove.id),
      disabled: disabled,
      readOnly: _ro,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      inputSize: INPUT_SIZE$2
    }, choiceNoneOfTheAbove.label),
    other: (choiceOther === null || choiceOther === void 0 ? void 0 : choiceOther.type) === 'ANSWER' && (choiceOther === null || choiceOther === void 0 ? void 0 : choiceOther.visible) && React__default.createElement(CheckboxTextfield, {
      id: choiceOther.id,
      defaultValue: handleDefault(choiceOther.id),
      onChange: handleOtherChange,
      checked: isChecked(choiceOther.id),
      maxLength: TEXT_INPUT_MAX_CHARS,
      disabled: disabled,
      readOnly: _ro,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      inputSize: INPUT_SIZE$2
    }, choiceOther.label),
    columns: columnLayout
  }, choices === null || choices === void 0 ? void 0 : choices.map(choice => {
    return React__default.createElement(Checkbox$3, {
      key: choice.id,
      id: choice.id,
      onChange: handleChange,
      checked: isChecked(choice.id),
      value: choice.id,
      disabled: disabled,
      readOnly: _ro,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      inputSize: INPUT_SIZE$2
    }, choice.label);
  })), choiceComment && React__default.createElement(CommentChoice, {
    id: choiceComment.id,
    label: choiceComment.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(choiceComment.id),
    lineCount: choiceComment.linesCount,
    charCount: choiceComment.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    "aria-describedby": questionFieldProps.error && errorId || undefined,
    className: commentChoiceContainer
  }));
}
var Checkbox$1 = withErrorBoundary(Checkbox);
function CommentBox({
  id: questionId,
  required: _req,
  disabled,
  readOnly,
  responses: defaultResponses = [],
  onChange,
  cols = 50,
  rows = 3,
  ...fieldProps
}) {
  const {
    error,
    errorId = createErrorId(questionId),
    title: {
      id: titleId
    }
  } = fieldProps;
  const defaultValue = useMemo(() => {
    var _defaultResponses$fin;
    return ((_defaultResponses$fin = defaultResponses.find(r => !!r.value)) === null || _defaultResponses$fin === void 0 ? void 0 : _defaultResponses$fin.value) ?? '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const handleChange = e => {
    const responses = e.target.value ? [{
      id: questionId,
      value: e.target.value
    }] : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  return React__default.createElement(QuestionField, {
    id: questionId,
    errorId: errorId,
    "data-testid": "CommentBoxQuestionType",
    ...fieldProps
  }, React__default.createElement(TextArea$1, {
    name: questionId,
    defaultValue: defaultValue,
    disabled: disabled,
    readOnly: readOnly,
    cols: cols,
    rows: rows,
    onChange: handleChange,
    "aria-invalid": !!error,
    "aria-describedby": error && errorId,
    "aria-labelledby": titleId,
    maxLength: TEXT_INPUT_MAX_CHARS
  }));
}
var CommentBox$1 = withErrorBoundary(CommentBox);
const useStyles$E = createUseStyles(theme => {
  const {
    color,
    fontSize,
    fontFamily,
    fontWeight
  } = theme.questionBody;
  return {
    selectContainerStyles: {
      maxWidth: '100%',
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflow: 'hidden',
      transition: 'all 0.1s linear',
      borderRadius: `4px`,
      border: `2px solid transparent`,
      outline: `1px solid transparent`,
      '&:focus-within, &:hover': {
        border: `2px solid ${theme.primaryAccentColor}`,
        outline: `1px solid #fff`
      },
      color: '#000'
    },
    selectStyles: {
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflow: 'hidden',
      fontSize,
      fontFamily,
      fontWeight,
      lineHeight: 'normal',
      outline: 'none',
      backgroundColor: '#fff',
      color: 'inherit',
      maxWidth: '100%',
      padding: ({
        isRTL = false
      }) => isRTL ? '6px 6px 6px 1.75em' : '6px 1.75em 6px 6px',
      verticalAlign: 'bottom',
      textSizeAdjust: 'auto',
      // Prevent de fault chevron from showing
      mozAppearance: 'none',
      webkitAppearance: 'none',
      appearance: 'none',
      transition: 'border 0.1s linear',
      border: `1px solid ${color}`,
      '&:focus-within, &:hover': {
        border: `1px solid transparent`
      }
    },
    selectIconStyles: {
      position: 'absolute',
      width: '1em',
      height: '1em',
      display: 'block',
      margin: '0 .5em',
      right: ({
        isRTL = false
      }) => isRTL ? 'auto' : 0,
      left: ({
        isRTL = false
      }) => isRTL ? 0 : 'auto',
      zIndex: 2,
      pointerEvents: 'none'
    },
    disabledStyles: {
      opacity: 0.4
    }
  };
});
function NativeSelect({
  required,
  children,
  disabled,
  className,
  icon = React__default.createElement(SelectIcon$1, null),
  ...props
}) {
  const {
    isRTL
  } = useContext(L10NContext);
  const {
    selectStyles,
    selectContainerStyles,
    selectIconStyles,
    disabledStyles
  } = useStyles$E({
    isRTL
  });
  const {
    className: iconClasses,
    ...iconProps
  } = icon.props;
  return React__default.createElement("div", {
    className: classNames(selectContainerStyles, disabled ? disabledStyles : {}, className)
  }, React__default.cloneElement(icon, {
    // this will apply our placement styles, along with any other supplied classes
    className: classNames(selectIconStyles, iconClasses),
    // apply all other props.
    ...iconProps
  }), React__default.createElement("select", {
    className: selectStyles,
    required: required,
    "aria-required": required,
    "data-testid": "select",
    disabled: disabled,
    ...props
  }, children));
}
const useStyles$D = createUseStyles(({
  questionBody: {
    fontFamily,
    fontSize,
    fontWeight
  }
}) => ({
  selectOption: {
    fontFamily,
    fontSize,
    fontWeight
  }
}));
function SelectAnswerOption({
  id,
  label,
  ...props
}) {
  const {
    selectOption
  } = useStyles$D();
  return React__default.createElement("option", {
    id: id,
    "data-testid": "select-answer-option",
    className: selectOption,
    ...props
  }, label);
}
const useStyles$C = createUseStyles(theme => {
  const {
    color,
    fontSize,
    fontFamily,
    fontWeight
  } = theme.questionBody;
  return {
    inputGroup: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: ({
        rtl
      }) => rtl ? 'row-reverse' : 'row',
      transition: 'all 0.1s linear',
      border: `1px solid ${color}`,
      '&:focus-within, &:hover': {
        border: `1px solid transparent`
      }
    },
    input: {
      border: 'none',
      textAlign: ({
        rtl
      }) => rtl ? 'right' : 'left',
      height: ({
        height
      }) => height || 'auto',
      width: 'calc(100% - 30px)',
      outline: 'currentColor none medium',
      backgroundColor: '#FFF',
      padding: '6px 0 6px 10px',
      fontSize,
      fontFamily,
      fontWeight
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      height: ({
        height
      }) => height || 'auto',
      width: 30,
      backgroundColor: '#FFF',
      border: 'none'
    },
    buttonIcon: {
      transform: ({
        isOpen
      }) => isOpen ? 'rotate(180deg)' : 'rotate(0)'
    }
  };
});
const ComboBoxInputGroup = React__default.forwardRef(({
  isOpen,
  value,
  height,
  rtl = false,
  onChange,
  open,
  close,
  onKeyDown,
  'aria-activedescendant': ariaActiveDescendant,
  'aria-autocomplete': ariaAutocomplete,
  'aria-controls': ariaControls,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  className,
  ...rest
}, ref) => {
  const inputRef = useRef(null);
  useImperativeHandle(ref, () => inputRef.current);
  const {
    inputGroup,
    input,
    button,
    buttonIcon
  } = useStyles$C({
    isOpen,
    height,
    rtl
  });
  return React__default.createElement("div", {
    className: classNames(inputGroup, className),
    ...rest
  }, React__default.createElement("input", {
    className: input,
    type: "text",
    role: "combobox",
    "aria-autocomplete": ariaAutocomplete,
    "aria-expanded": isOpen,
    "aria-controls": ariaControls,
    "aria-activedescendant": ariaActiveDescendant,
    value: value,
    onChange: onChange,
    onClick: open,
    onKeyDown: onKeyDown,
    ref: inputRef
  }), React__default.createElement("button", {
    className: button,
    type: "button",
    tabIndex: -1,
    "aria-expanded": isOpen,
    "aria-controls": ariaControls,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    onClick: () => {
      var _inputRef$current2;
      if (isOpen) {
        close();
      } else {
        open();
      }
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    }
  }, React__default.createElement(CaretDownIcon, {
    className: buttonIcon
  })));
});
const useStyles$B = createUseStyles({
  listBox: {
    listStyle: 'none',
    width: 'fit-content',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&:focus-visible': {
      outline: '#005fcc auto 1px',
      outlineOffset: 1
    }
  }
});

/**
 * Scroll to the item at the specified index if it is fully or partially obscured
 * */
const scrollToItem = (itemRect, containerRef) => {
  var _containerRef$current;
  const ulRect = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect();
  if (!ulRect || !containerRef.current) {
    return;
  }
  if (itemRect.top < ulRect.top) {
    // eslint-disable-next-line no-param-reassign
    containerRef.current.scrollTop -= ulRect.top - itemRect.top;
  } else if (itemRect.bottom > ulRect.bottom) {
    // eslint-disable-next-line no-param-reassign
    containerRef.current.scrollTop += itemRect.bottom - ulRect.bottom;
  }
};
/**
 * Returns the number of items visible inside the listbox given its current dimensions
 * note: if height is 0, it will return 10 as a default to satisfy tests
 * */
const numItemsVisible = (containerHeight, itemHeight = 48) => {
  return !containerHeight ? 10 : Math.round(containerHeight / itemHeight);
};

/**
 * Focus another item in the listBox depending on which key is pressed
 * @param key The key that was pressed
 * @param focusedIndex The index of the currently focused item
 * @param itemCount The number of items in the listBox
 * @param visibleItemCount The number of items visible in the listBox
 * @param focusItem Function which updates the the currently focused item
 */
const focusNext = (key, focusedIndex, itemCount, visibleItemCount, focusItem) => {
  const lastIndex = itemCount - 1;
  if (key === 'End') {
    focusItem(lastIndex);
    return;
  }
  if (focusedIndex === null) {
    focusItem(0);
    return;
  }
  switch (key) {
    case 'Down':
    case 'ArrowDown':
      if (focusedIndex < lastIndex) {
        focusItem(focusedIndex + 1);
      } else {
        focusItem(0);
      }
      break;
    case 'Up':
    case 'ArrowUp':
      if (focusedIndex > 0) {
        focusItem(focusedIndex - 1);
      } else {
        focusItem(lastIndex);
      }
      break;
    case 'PageDown':
      if (focusedIndex < lastIndex - visibleItemCount) {
        focusItem(focusedIndex + visibleItemCount);
      } else {
        focusItem(lastIndex);
      }
      break;
    case 'PageUp':
      if (focusedIndex > visibleItemCount) {
        focusItem(focusedIndex - visibleItemCount);
      } else {
        focusItem(0);
      }
      break;
    case 'Home':
      focusItem(0);
      break;
  }
};
React__default.forwardRef(({
  children,
  focusedIndex: externalFocusedIndex,
  tabIndex,
  onKeyDown,
  onClick,
  onChange,
  className,
  ...rest
}, ref) => {
  const {
    listBox
  } = useStyles$B();
  const [focusedIndex, setFocusedIndex] = useState(null);
  // override internal focusedIndex with external state if provided
  useEffect(() => {
    if (externalFocusedIndex !== undefined) {
      setFocusedIndex(externalFocusedIndex);
    }
  }, [externalFocusedIndex]);
  const itemsRef = useRef([]);
  const ulRef = useRef(null);
  const focusItem = index => {
    setFocusedIndex(index);
  };
  useImperativeHandle(ref, () => ulRef.current);
  useEffect(() => {
    var _itemsRef$current;
    if (focusedIndex === null) {
      return;
    }
    // Scroll to the currently focused item anytime the focused index changes
    scrollToItem((_itemsRef$current = itemsRef.current) === null || _itemsRef$current === void 0 ? void 0 : _itemsRef$current[focusedIndex].getBoundingClientRect(), ulRef);
    // call the onChange callback if the focused index changes
    onChange === null || onChange === void 0 ? void 0 : onChange({
      target: itemsRef.current[focusedIndex],
      value: itemsRef.current[focusedIndex].dataset.value ?? ''
    });
  }, [focusedIndex]);
  const handleKeyDown = e => {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    if (!(e.target instanceof HTMLUListElement)) {
      return;
    }
    if (['Down', 'Up', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'End', 'Home'].includes(e.key)) {
      var _ulRef$current;
      e.preventDefault();
      // Focus another item in the listBox depending on which key is pressed
      focusNext(e.key, focusedIndex, itemsRef.current.length, numItemsVisible((_ulRef$current = ulRef.current) === null || _ulRef$current === void 0 ? void 0 : _ulRef$current.getBoundingClientRect().height), focusItem);
    }
  };
  const handleClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (e.target instanceof HTMLLIElement) {
      setFocusedIndex(itemsRef.current.indexOf(e.target));
    }
  };
  const interactiveProps = {
    tabIndex,
    'aria-activedescendant': tabIndex !== undefined && focusedIndex !== null ? `ListBoxItem-${focusedIndex}` : undefined
  };
  return React__default.createElement("ul", {
    ref: ulRef,
    className: classNames(listBox, className),
    role: "listbox",
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    ...interactiveProps,
    ...rest
  }, React__default.Children.map(children, (child, index) => React__default.isValidElement(child) && React__default.cloneElement(child, {
    key: child.props.value,
    id: child.props.id ?? `ListBoxItem-${index}`,
    selected: index === focusedIndex,
    ref: el => {
      itemsRef.current[index] = el;
    }
  })));
});
const useStyles$A = createUseStyles({
  listBoxItem: ({
    selected,
    disabled
  }) => ({
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
    backgroundColor: '#FFF',
    cursor: 'pointer',
    ...(selected && {
      backgroundColor: 'rgb(237, 238, 238)'
    }),
    '&:hover, &:focus': {
      backgroundColor: 'rgb(237, 238, 238)'
    },
    '&:active': {
      backgroundColor: 'rgb(224, 226, 226)'
    },
    ...(disabled && {
      opacity: 0.5,
      pointerEvents: 'none'
    })
  })
});
const ListBoxItem = React__default.forwardRef(({
  children,
  disabled,
  selected,
  value,
  className,
  ...rest
}, ref) => {
  const {
    listBoxItem
  } = useStyles$A({
    disabled,
    selected
  });
  return React__default.createElement("li", {
    ref: ref,
    "data-value": value,
    className: classNames(listBoxItem, className),
    role: "option",
    "aria-selected": selected ? true : undefined,
    ...rest
  }, children);
});
const useStyles$z = createUseStyles({
  listBoxContainer: {
    // TODO: Possible to utilize focus-visible to show only on keyboard interaction? (with child)
    '&:focus-within': {
      outline: '#005fcc auto 1px',
      outlineOffset: 1
    }
  },
  listBox: {
    listStyle: 'none',
    width: 'fit-content',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 0
  }
});
const ARIA_ACTIVEDESCENDANT = 'aria-activedescendant';
/**
 * A virtualized version of the List component, using `react-window` to render large datasets. This component should only be used when the number of items would cause performance issues with the standard List component (most likely >500 items).
 */
const VirtualizedListBox = React__default.forwardRef(({
  height = 325,
  width = 175,
  itemSize,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  [ARIA_ACTIVEDESCENDANT]: ariaActiveDescendant,
  tabIndex,
  itemCount,
  focusedIndex: externalFocusedIndex,
  onChange,
  onKeyDown,
  onClick,
  className,
  children,
  ...rest
}, ref) => {
  const [focusedIndex, setFocusedIndex] = useState(null);
  const listRef = useRef(null);
  const innerRef = useRef(null);
  const outerRef = useRef(null);
  const itemsRef = useRef([]);
  // override internal focusedIndex with external state if provided
  useEffect(() => {
    if (externalFocusedIndex !== undefined) {
      if (externalFocusedIndex !== null) {
        var _listRef$current;
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollToItem(externalFocusedIndex);
      }
      setFocusedIndex(externalFocusedIndex);
    }
  }, [externalFocusedIndex]);
  const {
    listBoxContainer,
    listBox
  } = useStyles$z();
  const handleChange = item => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      target: item,
      value: item.dataset.value ?? ''
    });
  };
  /**
   * Scroll to and focus the item at the specified index
   */
  const focusItem = index => {
    var _listRef$current2;
    (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.scrollToItem(index);
    setFocusedIndex(index);
    handleChange(itemsRef.current[index]);
  };
  useImperativeHandle(ref, () => ({
    listRef,
    innerRef,
    outerRef,
    itemsRef
  }));
  const handleKeyDown = useCallback(e => {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    if (!(e.target instanceof HTMLUListElement)) {
      return;
    }
    if (['Down', 'Up', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'End', 'Home'].includes(e.key)) {
      var _outerRef$current;
      e.preventDefault();
      // Focus another item in the listBox depending on which key is pressed
      focusNext(e.key, focusedIndex, itemCount, numItemsVisible((_outerRef$current = outerRef.current) === null || _outerRef$current === void 0 ? void 0 : _outerRef$current.getBoundingClientRect().height), focusItem);
    }
  }, [focusedIndex, itemCount, onKeyDown]);
  const handleClick = useCallback(e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (e.target instanceof HTMLLIElement) {
      setFocusedIndex(itemsRef.current.indexOf(e.target));
      handleChange(e.target);
    }
  }, [onClick]);
  useSSRSafeLayoutEffect(() => {
    var _outerRef$current2;
    const listElement = innerRef.current;
    (_outerRef$current2 = outerRef.current) === null || _outerRef$current2 === void 0 ? void 0 : _outerRef$current2.removeAttribute('tabindex');
    if (listElement) {
      listElement.className = listBox;
      listElement.setAttribute('role', 'listbox');
      listElement.addEventListener('keydown', handleKeyDown);
      listElement.addEventListener('click', handleClick);
      if (tabIndex === undefined) {
        listElement.removeAttribute('tabindex');
      } else {
        listElement.setAttribute('tabindex', tabIndex === null || tabIndex === void 0 ? void 0 : tabIndex.toString());
      }
      if (ariaLabel) {
        listElement.setAttribute('aria-label', ariaLabel);
      }
      if (ariaLabelledBy) {
        listElement.setAttribute('aria-labelledby', ariaLabelledBy);
      }
    }
    return () => {
      if (listElement) {
        listElement.removeEventListener('keydown', handleKeyDown);
        listElement.removeEventListener('click', handleClick);
      }
    };
  }, [ariaLabel, ariaLabelledBy, handleClick, handleKeyDown, listBox, tabIndex]);
  useSSRSafeLayoutEffect(() => {
    const listElement = innerRef.current;
    if (ariaActiveDescendant || tabIndex !== undefined && focusedIndex !== null) {
      listElement === null || listElement === void 0 ? void 0 : listElement.setAttribute(ARIA_ACTIVEDESCENDANT, ariaActiveDescendant ?? `ListBoxItem-${focusedIndex}`);
    } else {
      listElement === null || listElement === void 0 ? void 0 : listElement.removeAttribute(ARIA_ACTIVEDESCENDANT);
    }
  }, [ariaActiveDescendant, focusedIndex, tabIndex]);
  return React__default.createElement(FixedSizeList, {
    className: classNames(listBoxContainer, className),
    itemSize: itemSize,
    height: Math.min(height, itemCount * itemSize),
    width: width,
    innerElementType: "ul",
    innerRef: innerRef,
    outerRef: outerRef,
    overscanCount: 10,
    itemCount: itemCount,
    ref: listRef,
    ...rest
  }, props => React__default.cloneElement(children(props), {
    id: children(props).props.id ?? `ListBoxItem-${props.index}`,
    selected: props.index === focusedIndex,
    ref: el => {
      itemsRef.current[props.index] = el;
    }
  }));
});
const useStyles$y = createUseStyles(theme => {
  return {
    comboBox: {
      display: 'inline-block',
      width: ({
        width
      }) => width,
      borderRadius: `4px`,
      border: `2px solid transparent`,
      outline: `1px solid transparent`,
      '&:focus-within, &:hover': {
        border: `2px solid ${theme.primaryAccentColor}`,
        outline: `1px solid #fff`
      }
    },
    listBox: {
      display: ({
        isOpen
      }) => isOpen ? 'block' : 'none',
      '&:focus-within': {
        outline: 'none'
      },
      border: '1px solid rgb(204, 204, 204)'
    },
    listBoxItem: {
      direction: ({
        rtl
      }) => rtl ? 'rtl' : 'ltr',
      paddingLeft: '10px'
    }
  };
});
function ComboBox({
  id,
  options,
  height,
  width = '100%',
  itemSize = 48,
  className,
  classes,
  filterOnChange = false,
  value: outsideValue = '',
  optionAlign = 'center',
  filter,
  onChange,
  rtl = false,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  ...rest
}) {
  var _comboBoxRef$current;
  const comboBoxRef = useRef(null);
  const inputRef = useRef(null);
  const listBoxRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState(outsideValue);
  const [currentOptions, setCurrentOptions] = useState(options);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [filterActive, setFilterActive] = useState(!filterOnChange);
  // the initial value of the input field when the listbox is opened (used to control whether the filter is active or not)
  const [valueOnOpen, setValueOnOpen] = useState(outsideValue);
  /** For preventing onChange being called on first render */
  const firstRender = useRef(true);
  const {
    comboBox,
    listBox,
    listBoxItem
  } = useStyles$y({
    isOpen,
    width,
    rtl
  });
  const closeListBox = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };
  const openListBox = () => {
    if (!isOpen) {
      setValueOnOpen(value);
      setIsOpen(true);
    }
  };
  // close the listbox when the user clicks outside of it
  useOnFocusLeave(comboBoxRef, () => {
    closeListBox();
    setFocusedIndex(null);
  });
  const focusItem = index => {
    setFocusedIndex(index);
  };
  // call onChange when value changes
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        value,
        target: inputRef.current
      });
    }
  }, [value]);
  // filter the current options if a filter is provided and filtering is active. If filtering is inactive, reset the current options to the original options
  useEffect(() => {
    if (filter && filterActive) {
      setCurrentOptions(options.filter(option => filter(option, value)));
    } else if (!filterActive) {
      setCurrentOptions(options);
    }
  }, [options, value, filter, filterActive]);
  // if filterOnChange is true, activate filtering if the value has changed since the listbox was opened, otherwise deactivate filtering
  useEffect(() => {
    if (filterOnChange) {
      setFilterActive(value !== valueOnOpen);
    }
  }, [filterOnChange, value, valueOnOpen]);
  // if the current value matches an option when the list opens, focus it and center it in the list
  useEffect(() => {
    if (isOpen) {
      const matchingOption = currentOptions.find(option => option.label === value);
      if (matchingOption) {
        var _listBoxRef$current, _listBoxRef$current$l;
        (_listBoxRef$current = listBoxRef.current) === null || _listBoxRef$current === void 0 ? void 0 : (_listBoxRef$current$l = _listBoxRef$current.listRef.current) === null || _listBoxRef$current$l === void 0 ? void 0 : _listBoxRef$current$l.scrollToItem(currentOptions.indexOf(matchingOption), optionAlign // position the option in the list according to the alignment (default is `center`)
        );

        setFocusedIndex(currentOptions.indexOf(matchingOption));
      }
    }
  }, [isOpen, currentOptions, value, optionAlign]);
  useEffect(() => {
    setValue(outsideValue);
  }, [outsideValue]);
  const handleKeyDown = e => {
    switch (e.key) {
      case 'ArrowDown':
      case 'Down':
      case 'ArrowUp':
      case 'Up':
      case 'PageDown':
      case 'PageUp':
        e.preventDefault();
        openListBox();
        if (!e.altKey) {
          var _listBoxRef$current2, _listBoxRef$current2$;
          focusNext(e.key, focusedIndex, currentOptions.length, numItemsVisible((_listBoxRef$current2 = listBoxRef.current) === null || _listBoxRef$current2 === void 0 ? void 0 : (_listBoxRef$current2$ = _listBoxRef$current2.outerRef.current) === null || _listBoxRef$current2$ === void 0 ? void 0 : _listBoxRef$current2$.getBoundingClientRect().height, itemSize), focusItem);
        }
        break;
      case 'Escape':
        if (isOpen) {
          closeListBox();
          setFocusedIndex(null);
        } else {
          setValue('');
        }
        break;
      case 'Enter':
        e.preventDefault();
        if (isOpen) {
          if (focusedIndex !== null) {
            var _listBoxRef$current3, _listBoxRef$current3$;
            setValue(((_listBoxRef$current3 = listBoxRef.current) === null || _listBoxRef$current3 === void 0 ? void 0 : (_listBoxRef$current3$ = _listBoxRef$current3.itemsRef.current) === null || _listBoxRef$current3$ === void 0 ? void 0 : _listBoxRef$current3$[focusedIndex].textContent) ?? '');
          }
          closeListBox();
          setFocusedIndex(null);
        }
        break;
    }
  };
  const handleListBoxClick = () => {
    var _inputRef$current3;
    (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
    closeListBox();
  };
  const activeDescendant = focusedIndex !== null && currentOptions[focusedIndex] ? `${id}-${currentOptions[focusedIndex].value}` : undefined;
  return React__default.createElement("div", {
    className: classNames(comboBox, classes === null || classes === void 0 ? void 0 : classes.comboBox, className),
    ref: comboBoxRef,
    ...rest
  }, React__default.createElement(ComboBoxInputGroup, {
    ref: inputRef,
    className: classes === null || classes === void 0 ? void 0 : classes.inputGroup,
    height: height,
    rtl: rtl,
    value: value,
    isOpen: isOpen,
    "aria-controls": `${id}-listbox`,
    "aria-autocomplete": filter ? 'list' : 'none',
    "aria-activedescendant": activeDescendant,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    open: openListBox,
    close: closeListBox,
    onChange: e => setValue(e.target.value),
    onKeyDown: handleKeyDown
  }), React__default.createElement(VirtualizedListBox, {
    ref: listBoxRef,
    itemSize: itemSize,
    itemCount: currentOptions.length,
    className: classNames(listBox, classes === null || classes === void 0 ? void 0 : classes.listBox),
    focusedIndex: focusedIndex,
    width: (_comboBoxRef$current = comboBoxRef.current) === null || _comboBoxRef$current === void 0 ? void 0 : _comboBoxRef$current.clientWidth,
    onChange: e => {
      var _e$target;
      return setValue(((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.textContent) ?? '');
    },
    onClick: handleListBoxClick,
    tabIndex: -1,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-activedescendant": activeDescendant,
    /**
     * adding inline style to overwrite react-window inline styles as per their docs
     * https://github.com/bvaughn/react-window
     */
    style: {
      position: 'absolute'
    }
  }, ({
    index,
    style
  }) => React__default.createElement(ListBoxItem, {
    className: classNames(listBoxItem, classes === null || classes === void 0 ? void 0 : classes.listBoxItem),
    style: style,
    value: currentOptions[index].value,
    id: `${id}-${currentOptions[index].value}`,
    key: `${id}-${currentOptions[index].value}`
  }, currentOptions[index].label)));
}
const useStyles$x = createUseStyles({
  srOnly: visuallyHidden
});

/** default element for the visually hidden component */
const DEFAULT_ELEMENT = 'span';
/**
 * A component to have visually hidden text still available to Assistive
 * Technologies, such as screen-readers.
 * All HTML properties are available on the selected `element` tag used.
 */
function VisuallyHidden({
  element: Tag = DEFAULT_ELEMENT,
  className,
  ...props
}) {
  const {
    srOnly
  } = useStyles$x();
  return React__default.createElement(Tag, {
    className: classNames(srOnly, className),
    ...props
  });
}
const useCalendarStyles = createUseStyles({
  calendarPickerWrapper: {
    width: ({
      width
    }) => width,
    height: ({
      height
    }) => height,
    border: '1px solid #CCCCCC',
    padding: '10px',
    background: '#FFFFFF',
    color: '#333333'
  },
  calendarControls: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px'
  },
  button: {
    border: 'none',
    borderRadius: 0,
    background: 'transparent',
    width: '60px',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#05467E',
      color: '#FFFFFF'
    }
  },
  comboboxWrapper: {
    display: 'flex',
    flexGrow: 1,
    '& > div': {
      width: '50%'
    }
  },
  monthWrapper: {
    display: 'grid',
    margin: '32px 0 0',
    gridTemplateColumns: `repeat(1, 100%)`,
    gridGap: '0 64px'
  }
});
const useMonthStyles = createUseStyles({
  weekdayLabel: {
    textAlign: 'center',
    marginBottom: '10px',
    fontSize: '10px'
  },
  weekGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    justifyContent: 'center'
  }
});
const useDayStyles = createUseStyles({
  dayDefault: {
    padding: '8px',
    border: '1px solid #CCCCCC',
    borderRadius: '0',
    color: '#001217',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: '#05467E',
      borderColor: '#05467E'
    }
  },
  daySelected: {
    color: '#FFFFFF',
    backgroundColor: '#71c9ed'
  },
  daySelectedFirstOrLast: {
    color: '#FFFFFF',
    backgroundColor: '#000000',
    borderColor: '#000000'
  },
  dayDisabled: {
    color: '#808285',
    backgroundColor: '#FFFFFF'
  }
});
const COPY$d = defineMessages({
  DAY_OF_MONTH: {
    id: 'Day.dayOfMonth',
    defaultMessage: '{dayInCalendar, date, full}',
    description: '[Type: label][Vis: high] - label for the full date'
  }
});
function Day({
  dayLabel,
  date,
  focusedDate,
  isDateSelected,
  isDateFocused,
  isDateHovered,
  onDateHover,
  onDateSelect,
  onDateFocus,
  isFirstOrLastSelectedDate
}) {
  const dayRef = useRef(null);
  const fn = () => false;
  const {
    isSelected,
    isSelectedStartOrEnd,
    isWithinHoverRange,
    disabledDate,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex
  } = Ne({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked: fn,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef
  });
  useEffect(() => {
    if (dayRef && dayRef.current && isDateFocused(date)) {
      dayRef.current.focus();
    }
  }, [dayRef, date, isDateFocused]);
  const {
    dayDefault,
    daySelected,
    daySelectedFirstOrLast,
    dayDisabled
  } = useDayStyles();
  if (!dayLabel) {
    return React__default.createElement("div", null);
  }
  return React__default.createElement("button", {
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    type: "button",
    ref: dayRef,
    "aria-label": t(COPY$d.DAY_OF_MONTH, {
      dayInCalendar: date
    }),
    className: classNames(dayDefault, {
      [daySelected]: isSelected || isWithinHoverRange,
      [daySelectedFirstOrLast]: isSelectedStartOrEnd,
      [dayDisabled]: disabledDate
    })
  }, dayLabel);
}
const COPY$c = defineMessages({
  DAY_OF_WEEK_LEGEND_SHORT: {
    id: 'Month.dayOfWeekLegendShort',
    defaultMessage: '{dayOfTheWeek, select, Mo {Mo} Tu {Tu} We {We} Th {Th} Fr {Fr} Sa {Sa} Su {Su}}',
    description: '[Type: label][Vis: high] - label for the day of the week in shorthand'
  },
  DAY_OF_WEEK_LEGEND_FULL: {
    id: 'Month.dayOfWeekLegendLong',
    defaultMessage: '{dayOfTheWeek, select, Mo {Monday} Tu {Tuesday} We {Wednesday} Th {Thursday} Fr {Friday} Sa {Saturday} Su {Sunday}}',
    description: '[Type: label][Vis: high] - label for the day of the week'
  }
});
function Month({
  year,
  month,
  firstDayOfWeek,
  ...dayProps
}) {
  const {
    days,
    weekdayLabels
  } = de({
    year,
    month,
    firstDayOfWeek
  });
  const {
    weekdayLabel,
    weekGrid
  } = useMonthStyles();
  return React__default.createElement("div", null, React__default.createElement("div", {
    className: weekGrid,
    role: "grid"
  }, weekdayLabels.map(dayLabel => React__default.createElement("div", {
    className: weekdayLabel,
    key: dayLabel,
    role: "columnheader"
  }, React__default.createElement("span", {
    role: "presentation"
  }, React__default.createElement(T, {
    desc: COPY$c.DAY_OF_WEEK_LEGEND_SHORT,
    values: {
      dayOfTheWeek: dayLabel
    }
  })), React__default.createElement(VisuallyHidden, null, React__default.createElement(T, {
    desc: COPY$c.DAY_OF_WEEK_LEGEND_FULL,
    values: {
      dayOfTheWeek: dayLabel
    }
  })))), days.map((day, index) => {
    if (typeof day === 'object') {
      return React__default.createElement(Day, {
        date: day.date,
        key: day.dayLabel,
        dayLabel: day.dayLabel,
        ...dayProps
      });
    }
    const emptyDayKey = `empty-day-${index}`;
    return React__default.createElement("div", {
      key: emptyDayKey
    });
  })));
}
const COPY$b = defineMessages({
  PREVIOUS_MONTH: {
    id: 'CalendarPicker.previousMonth',
    defaultMessage: 'Previous Month',
    description: '[Type: button][Vis: high] - button label to go to previous month'
  },
  NEXT_MONTH: {
    id: 'CalendarPicker.nextMonth',
    defaultMessage: 'Next Month',
    description: '[Type: button][Vis: high] - button label to go to next month'
  },
  MONTH_SELECT: {
    id: 'CalendarPicker.month',
    defaultMessage: 'Select a month',
    description: '[Type: label][Vis: high] - label for month selection combo box'
  },
  YEAR_SELECT: {
    id: 'CalendarPicker.year',
    defaultMessage: 'Select a year',
    description: '[Type: label][Vis: high] - label for year selection combo box'
  },
  MONTHS: {
    id: 'CalendarPicker.months',
    defaultMessage: '{months, select, January {January} February {February} March {March} April {April} May {May} June {June} July {July} August {August} September {September} October {October} November {November} December {December}}',
    description: '[Type: label][Vis: high] - label for the months'
  }
});
const startingYear = new Date().getFullYear() - 200;
const yearOptions = [...Array(251)].map((_, year) => ({
  label: `${startingYear + year}`,
  value: `${startingYear + year}`
}));
function getPreviousMonth(currentMonth) {
  let newDate;
  if (currentMonth.getMonth() - 1 < 0) {
    newDate = new Date(currentMonth.getFullYear() - 1, 11, currentMonth.getDate());
  } else {
    const prevMonthLastDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 0).getDate();
    if (currentMonth.getDate() > prevMonthLastDay) {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, prevMonthLastDay);
    } else {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, currentMonth.getDate());
    }
  }
  return newDate;
}
function getNextMonth(currentMonth) {
  let newDate;
  if (currentMonth.getMonth() + 1 > 11) {
    newDate = new Date(currentMonth.getFullYear() + 1, 0, currentMonth.getDate());
  } else {
    const nextMonthLastDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 2, 0).getDate();
    if (currentMonth.getDate() > nextMonthLastDay) {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, nextMonthLastDay);
    } else {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, currentMonth.getDate());
    }
  }
  return newDate;
}
const comboBoxSeedId = 'calendar-picker-combobox';
function CalendarPicker({
  onDaySelect,
  onDateChange,
  selectedDate,
  width = '300px',
  height = 'auto',
  startingDayOfWeek = 0
}) {
  const focusTrapRef = useFocusTrap({
    selectors: ['button:not([tabindex="-1"])', 'input']
  });
  const comboboxId = useMemo(() => uniqueId(comboBoxSeedId), []);
  const selectId = useMemo(() => uniqueId('calendar-picker-select'), []);
  const [state, setState] = useState(selectedDate);
  const handleDateChange = ({
    startDate
  }) => {
    const d = startDate ?? new Date();
    setState(d);
    onDaySelect === null || onDaySelect === void 0 ? void 0 : onDaySelect(d);
  };
  const {
    firstDayOfWeek,
    activeMonths,
    isDateSelected,
    isDateHovered,
    isFirstOrLastSelectedDate,
    isDateFocused,
    focusedDate,
    onDateHover,
    onDateSelect,
    onDateFocus,
    goToDate
  } = Ye({
    startDate: selectedDate,
    endDate: null,
    focusedInput: Pe,
    onDatesChange: handleDateChange,
    numberOfMonths: 1,
    /*
     * minBookingDays and exactBookingDays are used to remove the date range feature
     * see: https://github.com/tomgreenwood1/react-datepicker/tree/f2b1969cb4808c68d578428c4c5e6ed98c96461e/packages/hooks#exactminbookingdays-boolean--undefined-default-false
     */
    minBookingDays: 1,
    exactMinBookingDays: true,
    /*
     * firstDayofWeek is used to set the first day of the week. 0 = Sunday, 1 = Monday, etc.
     */
    firstDayOfWeek: startingDayOfWeek
  });
  useEffect(() => {
    goToDate(selectedDate);
  }, [selectedDate, goToDate]);
  const currentMonth = activeMonths[0];
  const {
    comboboxWrapper,
    calendarControls,
    calendarPickerWrapper,
    button,
    monthWrapper
  } = useCalendarStyles({
    height,
    width
  });
  // populate monthOptions array
  const monthNames = [t(COPY$b.MONTHS, {
    months: 'January'
  }), t(COPY$b.MONTHS, {
    months: 'February'
  }), t(COPY$b.MONTHS, {
    months: 'March'
  }), t(COPY$b.MONTHS, {
    months: 'April'
  }), t(COPY$b.MONTHS, {
    months: 'May'
  }), t(COPY$b.MONTHS, {
    months: 'June'
  }), t(COPY$b.MONTHS, {
    months: 'July'
  }), t(COPY$b.MONTHS, {
    months: 'August'
  }), t(COPY$b.MONTHS, {
    months: 'September'
  }), t(COPY$b.MONTHS, {
    months: 'October'
  }), t(COPY$b.MONTHS, {
    months: 'November'
  }), t(COPY$b.MONTHS, {
    months: 'December'
  })];
  const monthOptions = monthNames.map(name => ({
    label: name,
    value: name
  }));
  const getMonthLabel = monthNamesIndex => {
    return monthNames[monthNamesIndex];
  };
  const handleMonthChange = e => {
    const monthIndex = monthOptions.findIndex(i => i.value === e.target.value);
    const newDate = new Date(currentMonth.year, monthIndex, state.getDate());
    if (monthIndex !== -1) {
      goToDate(newDate);
      setState(newDate);
      onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
    }
  };
  const handleYearChange = e => {
    if (e.value.length >= 4) {
      const newDate = new Date(parseInt(e.value, 10), currentMonth.month, state.getDate());
      goToDate(newDate);
      setState(newDate);
      onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
    }
  };
  const handleGoToPreviousMonths = () => {
    const newDate = getPreviousMonth(state);
    setState(newDate);
    goToDate(newDate);
    onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
  };
  const handleGoToNextMonths = () => {
    const newDate = getNextMonth(state);
    setState(newDate);
    goToDate(newDate);
    onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
  };
  return React__default.createElement("div", {
    className: calendarPickerWrapper,
    "data-testid": "CalendarPicker",
    ref: focusTrapRef
  }, React__default.createElement("div", {
    className: calendarControls
  }, React__default.createElement("button", {
    type: "button",
    onClick: handleGoToPreviousMonths,
    className: button,
    "aria-label": t(COPY$b.PREVIOUS_MONTH),
    "data-testid": "previous-month-button"
  }, React__default.createElement(CaretLeftOutlineIcon, null)), React__default.createElement("div", {
    className: comboboxWrapper
  }, React__default.createElement("div", null, React__default.createElement(NativeSelect, {
    id: selectId,
    value: getMonthLabel(currentMonth.month),
    onChange: handleMonthChange
  }, monthOptions.map(option => React__default.createElement(SelectAnswerOption, {
    value: option.value,
    label: option.value,
    key: option.value
  })))), React__default.createElement("div", null, React__default.createElement(ComboBox, {
    id: comboboxId,
    "aria-label": t(COPY$b.YEAR_SELECT),
    options: yearOptions,
    value: currentMonth.year.toString(),
    onChange: handleYearChange
  }))), React__default.createElement("button", {
    type: "button",
    onClick: handleGoToNextMonths,
    className: button,
    "aria-label": t(COPY$b.NEXT_MONTH),
    "data-testid": "next-month-button"
  }, React__default.createElement(CaretRightOutlineIcon, null))), React__default.createElement("div", {
    className: monthWrapper
  }, React__default.createElement(Month, {
    year: currentMonth.year,
    month: currentMonth.month,
    firstDayOfWeek: firstDayOfWeek,
    onChange: goToDate,
    focusedDate: focusedDate,
    isDateSelected: isDateSelected,
    isDateFocused: isDateFocused,
    isDateHovered: isDateHovered,
    onDateHover: onDateHover,
    onDateSelect: onDateSelect,
    onDateFocus: onDateFocus,
    isFirstOrLastSelectedDate: isFirstOrLastSelectedDate
  })));
}
const useStyles$w = createUseStyles({
  container: {
    visibility: ({
      calendarVisibility
    }) => {
      return calendarVisibility ? 'visible' : 'hidden';
    }
  }
});
const DisclosureContainer = forwardRef(function DisclosureContainer({
  onClose,
  visible = false,
  className,
  ...props
}, ref) {
  const focusTrapRef = useFocusTrap({
    selectors: ['button:not([tabindex="-1"])', 'input']
  });
  const disclosureRef = useForkRef(focusTrapRef, ref);
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };
    const handleClick = e => {
      var _focusTrapRef$current;
      const target = e.target;
      const clickedOutside = !((_focusTrapRef$current = focusTrapRef.current) !== null && _focusTrapRef$current !== void 0 && _focusTrapRef$current.contains(target));
      const comboBoxOptionClicked = !target.id.startsWith(comboBoxSeedId);
      if (visible && clickedOutside && comboBoxOptionClicked) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };
    if (visible) {
      /*
       * RAWR-1437
       * Delay setting up the EventListener to after the current render, otherwise the handleClick triggers
       * when the calendar first opens and closes the calendar right away.
       */
      setTimeout(() => {
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('click', handleClick);
      }, 0);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClick);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const {
    container
  } = useStyles$w({
    calendarVisibility: visible
  });
  return React__default.createElement("div", {
    ref: disclosureRef,
    className: classNames(container, className),
    ...props
  });
});

// constants.ts
const US_DATE_FORMAT = 'MM/DD/YYYY';
const EURO_DATE_FORMAT = 'DD/MM/YYYY';
const DATE_DELIMITER = /[/.-]/g;
const validDateStringCheck = dateString => {
  const badValues = ['0', ' '];
  const isValid = dateString.every(value => {
    // eslint-disable-next-line no-restricted-globals
    return badValues.indexOf(value) === -1 && !isNaN(parseInt(value, 10));
  });
  return dateString.length === 3 && isValid;
};
const toDateString = (date, format = US_DATE_FORMAT) => {
  if (!date) {
    return '';
  }
  const segments = date.toISOString().split('T')[0].split(DATE_DELIMITER);
  const [y, m, d] = segments.map(s => s);
  if (format === US_DATE_FORMAT) {
    return `${m}/${d}/${y}`;
  }
  return `${d}/${m}/${y}`;
};
const isValidDate = (year, month, day) => {
  const date = new Date(`${year}-${month}-${day}T00:00:00`);
  return date.getFullYear() === Number(year) && date.getMonth() === Number(month) - 1 && date.getDate() === Number(day);
};
const stringToDate = (dateString, format = US_DATE_FORMAT) => {
  if (!dateString) {
    return new Date();
  }
  if (!validDateStringCheck(dateString.split(DATE_DELIMITER))) {
    return new Date();
  }
  if (format === EURO_DATE_FORMAT) {
    const [d, m, y] = dateString.split(DATE_DELIMITER);
    if (isValidDate(y, m, d)) {
      return new Date(`${y.padStart(4, '0')}-${m.padStart(2, '0')}-${d.padStart(2, '0')}T00:00:00`);
    }
  }
  const [m, d, y] = dateString.split(DATE_DELIMITER);
  if (isValidDate(y, m, d)) {
    return new Date(`${y.padStart(4, '0')}-${m.padStart(2, '0')}-${d.padStart(2, '0')}T00:00:00`);
  }
  return new Date();
};
const useStyles$v = createUseStyles(theme => {
  return {
    container: {
      position: 'relative'
    },
    dateInputWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    dateInput: {
      maxWidth: '175px',
      maxHeight: '36px',
      padding: ({
        isRTL = false
      }) => isRTL ? '6px 6px 6px 36px' : '6px 36px 6px 6px'
    },
    calendarButton: {
      borderRadius: 'none',
      border: 'none',
      margin: ({
        isRTL = false
      }) => isRTL ? '0 -37px 0 0' : '0 0 0 -37px',
      height: '34px',
      width: '36px',
      fontSize: '15px',
      color: '#404040',
      backgroundColor: '#EFEFEF',
      '&:focus, &:hover': {
        cursor: 'pointer',
        outline: `2px solid ${theme.primaryAccentColor}`,
        background: 'linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.2) 30%, #EFEFEF 100%)'
      },
      '&:focus': {
        borderRadius: '3px'
      },
      '&:active': {
        background: 'linear-gradient(0deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.4) 30%, #EFEFEF 100%)'
      },
      '&:disabled': {
        opacity: '.5'
      }
    },
    calendarWrapper: {
      position: 'absolute',
      bottom: ({
        calendarPosition
      }) => calendarPosition,
      zIndex: 100
    },
    commentLabel: {
      fontWeight: theme.questionBody.fontWeight,
      fontFamily: theme.questionBody.fontFamily,
      marginBottom: 5,
      display: 'block',
      fontSize: '14px'
    }
  };
});
const defaultLabels$1 = {
  dateInputLabel: 'Date',
  iconButton: 'Open Calendar',
  usDateFormat: 'MM/DD/YYYY',
  intlDateFormat: 'DD/MM/YYYY'
};
function DateInput({
  onChange,
  dateFormat = US_DATE_FORMAT,
  defaultValue = '',
  id,
  className,
  labels = defaultLabels$1,
  ...props
}, ref) {
  const [calendarVisibility, setCalendarVisibility] = useState(false);
  const dateInputID = useMemo(() => uniqueId('date-input-'), []);
  const internalInputRef = useRef(null);
  const inputRef = useForkRef(ref, internalInputRef);
  const calendarButtonRef = useRef(null);
  const disclosureRef = useRef(null);
  const dateValueRef = useRef(defaultValue);
  const calendarPosition = useRef('100%');
  useSSRSafeLayoutEffect(() => {
    if (internalInputRef.current && disclosureRef.current) {
      const inputBound = internalInputRef.current.getBoundingClientRect();
      const disclosureBound = disclosureRef.current.getBoundingClientRect();
      if (inputBound.top < disclosureBound.height) {
        // not enough space
        calendarPosition.current = 'auto';
      } else {
        calendarPosition.current = '100%';
      }
    }
  }, [calendarVisibility]);
  const {
    dateInputLabel,
    iconButton,
    usDateFormat,
    intlDateFormat
  } = labels;
  const handleCalendarVisibility = () => {
    setCalendarVisibility(s => {
      return !s;
    });
  };
  const handleDisclosureClose = () => {
    var _calendarButtonRef$cu;
    (_calendarButtonRef$cu = calendarButtonRef.current) === null || _calendarButtonRef$cu === void 0 ? void 0 : _calendarButtonRef$cu.focus();
    setCalendarVisibility(false);
  };
  const handleDaySelect = date => {
    var _internalInputRef$cur;
    const dateString = toDateString(date, dateFormat);
    dateValueRef.current = dateString;
    (_internalInputRef$cur = internalInputRef.current) === null || _internalInputRef$cur === void 0 ? void 0 : _internalInputRef$cur.setAttribute('value', dateString);
    onChange === null || onChange === void 0 ? void 0 : onChange(dateString);
    handleDisclosureClose();
  };
  const handleInputChange = e => {
    dateValueRef.current = e.target.value;
    onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
  };
  const {
    isRTL
  } = useContext(L10NContext);
  const {
    dateInput,
    calendarButton,
    calendarWrapper,
    commentLabel,
    dateInputWrapper,
    container
  } = useStyles$v({
    isRTL,
    calendarPosition: calendarPosition.current
  });
  return React__default.createElement("div", {
    className: classNames(container, className),
    id: id
  }, React__default.createElement("label", {
    htmlFor: dateInputID,
    className: commentLabel
  }, dateInputLabel), React__default.createElement("div", {
    className: dateInputWrapper
  }, React__default.createElement(TextInput$1, {
    "data-testid": "DateInput",
    className: dateInput,
    maxLength: 10,
    onChange: handleInputChange,
    defaultValue: dateValueRef.current,
    ref: inputRef,
    placeholder: dateFormat === 'DD/MM/YYYY' ? intlDateFormat : usDateFormat,
    id: dateInputID,
    ...props
  }), React__default.createElement("button", {
    type: "button",
    ref: calendarButtonRef,
    className: calendarButton,
    onClick: handleCalendarVisibility,
    "aria-expanded": calendarVisibility,
    "aria-label": iconButton
  }, React__default.createElement(CalendarIcon, null))), React__default.createElement(DisclosureContainer, {
    className: calendarWrapper,
    onClose: handleDisclosureClose,
    ref: disclosureRef,
    visible: calendarVisibility,
    "data-testid": "DisclosureContainer"
  }, React__default.createElement(CalendarPicker
  /** date coming out */, {
    /** date coming out */
    onDaySelect: handleDaySelect,
    /** date going in */
    selectedDate: stringToDate(dateValueRef.current, dateFormat)
  })));
}
var DateInput$1 = forwardRef(DateInput);
const COPY$a = defineMessages({
  DATE_LABEL: {
    id: 'DateInputWrapper.dateLabel',
    defaultMessage: 'Date',
    description: '[Type: label][Vis: high] - label for date input'
  },
  DATE_BUTTON_LABEL: {
    id: 'DateInputWrapper.dateButton',
    defaultMessage: 'Open calendar',
    description: '[Type: button][Vis: high] - aria text for opening the calendar picker'
  },
  US_DATE_FORMAT: {
    id: 'DateInputWrapper.dateFormatUs',
    defaultMessage: 'MM/DD/YYYY',
    description: '[Type: label][Vis: high] - ISO 8601 US date character format notation. No localized delimiter translation. Must be uppercase.'
  },
  INTL_DATE_FORMAT: {
    id: 'DateInputWrapper.dateFormatIntl',
    defaultMessage: 'DD/MM/YYYY',
    description: '[Type: label][Vis: high] - ISO 8601 International date character format notation. Must be uppercase.'
  }
});
function DateInputWrapper(props, ref) {
  // translates and defines the label dictionary
  const l10n = {
    dateInputLabel: t(COPY$a.DATE_LABEL),
    iconButton: t(COPY$a.DATE_BUTTON_LABEL),
    usDateFormat: t(COPY$a.US_DATE_FORMAT),
    intlDateFormat: t(COPY$a.INTL_DATE_FORMAT)
  };
  return React__default.createElement(DateInput$1, {
    labels: l10n,
    ...props,
    ref: ref
  });
}
var DateInputWrapper$1 = forwardRef(DateInputWrapper);
const useStyles$u = createUseStyles(theme => ({
  container: {
    display: 'flex'
  },
  verticalContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  horizontalContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    /**
     * including specific margin value to match production
     */
    marginRight: 35
  },
  label: {
    fontSize: '14px',
    fontWeight: theme.questionBody.fontWeight,
    fontFamily: theme.questionBody.fontFamily,
    width: '100%',
    display: 'block',
    marginBottom: '5px'
  },
  input: {
    /**
     * including specific height and width values to match production
     */
    maxWidth: '50px',
    maxHeight: '36px',
    textAlign: 'center'
  },
  separator: {
    width: '20px',
    height: '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  srOnly: {
    ...visuallyHidden
  }
}));
const defaultLabels = {
  timeLabel: 'Time',
  hour: 'Hour',
  minutes: 'Minutes',
  daytimeLabel: 'AM/PM',
  am: 'AM',
  pm: 'PM',
  hourPlaceholder: 'hh',
  minutesPlaceholder: 'mm'
};
function TimeInput({
  onChange,
  defaultValue = {
    hour: '',
    minute: '',
    period: 'AM'
  },
  id = uniqueId('TimeInput-'),
  className,
  required,
  'aria-describedby': ariaDescribedBy,
  labels = defaultLabels
}) {
  const [state, setState] = useState(defaultValue);
  const timeLabelID = `${id}-time-label`;
  const hourLabelID = `${id}-hour-label`;
  const hourInputID = `${id}-hour-input`;
  const minuteLabelID = `${id}-minute-label`;
  const minuteInputID = `${id}-minute-input`;
  const periodLabelID = `${id}-period-label`;
  const periodSelectID = `${id}-period-input`;
  const handleHourChange = e => {
    const newState = {
      ...state,
      hour: e.target.value
    };
    // if hour is > 12, set daytime period to PM
    if (!Number.isNaN(parseInt(newState.hour, 10)) && parseInt(newState.hour, 10) > 12) {
      newState.period = 'PM';
    }
    if (!newState.period) {
      newState.period = 'AM';
    }
    setState(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const handleHourOnBlur = e => {
    const newState = {
      ...state
    };
    // if hour is > 12, subtract 12 from the hour value to maintain 12 hour time
    if (!Number.isNaN(parseInt(e.target.value, 10)) && parseInt(e.target.value, 10) > 12) {
      newState.hour = String(parseInt(e.target.value, 10) - 12);
      setState(newState);
      onChange === null || onChange === void 0 ? void 0 : onChange(newState);
    }
  };
  const handleMinuteChange = e => {
    const newState = {
      ...state,
      minute: e.target.value
    };
    setState(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const handleSelectChange = e => {
    const newState = {
      ...state,
      period: e.target.value
    };
    setState(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const {
    container,
    verticalContainer,
    horizontalContainer,
    input,
    label,
    separator,
    srOnly
  } = useStyles$u();
  return React__default.createElement("div", {
    className: classNames(container, className),
    id: id,
    "data-testid": "TimeInput"
  }, React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("label", {
    htmlFor: hourInputID,
    id: hourLabelID,
    "aria-labelledby": `${timeLabelID} ${hourLabelID}`,
    className: srOnly
  }, labels.hour), React__default.createElement("div", {
    className: horizontalContainer
  }, React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("div", {
    className: label,
    id: timeLabelID
  }, labels.timeLabel), React__default.createElement(TextInput$1, {
    className: input,
    maxLength: 2,
    onChange: handleHourChange,
    onBlur: handleHourOnBlur,
    value: state.hour,
    placeholder: labels.hourPlaceholder,
    id: hourInputID,
    required: required,
    "aria-describedby": ariaDescribedBy
  })), React__default.createElement("span", {
    className: separator
  }, ":"), React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("label", {
    htmlFor: minuteInputID,
    id: minuteLabelID,
    "aria-labelledby": `${timeLabelID} ${minuteLabelID}`,
    className: srOnly
  }, labels.minutes), React__default.createElement(TextInput$1, {
    className: input,
    maxLength: 2,
    onChange: handleMinuteChange,
    value: state.minute,
    placeholder: labels.minutesPlaceholder,
    id: minuteInputID,
    "aria-labelledby": `${timeLabelID} ${minuteLabelID}`,
    required: required,
    "aria-describedby": ariaDescribedBy
  })))), React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("label", {
    id: periodLabelID,
    htmlFor: periodSelectID,
    className: label
  }, labels.daytimeLabel), React__default.createElement(NativeSelect, {
    id: periodSelectID,
    value: state.period,
    onChange: handleSelectChange,
    required: required
  }, React__default.createElement(SelectAnswerOption, {
    value: "AM",
    label: labels.am
  }), React__default.createElement(SelectAnswerOption, {
    value: "PM",
    label: labels.pm
  }))));
}
const COPY$9 = defineMessages({
  TIME_LABEL: {
    id: 'TimeInputWrapper.timeLabel',
    defaultMessage: 'Time',
    description: '[Type: label][Vis: high] - label for time input'
  },
  HOUR_LABEL: {
    id: 'TimeInputWrapper.hour',
    defaultMessage: 'Hour',
    description: '[Type: label][Vis: high] - label for hour input'
  },
  MINUTES_LABEL: {
    id: 'TimeInputWrapper.minutes',
    defaultMessage: 'Minutes',
    description: '[Type: label][Vis: high] - label for minutes input'
  },
  DAYTIME_LABEL: {
    id: 'TimeInputWrapper.daytimeLabel',
    defaultMessage: 'AM/PM',
    description: '[Type: label][Vis: high] - label for daytime AM/PM select'
  },
  AM: {
    id: 'TimeInputWrapper.am',
    defaultMessage: 'AM',
    description: '[Type: label][Vis: high] - label for ante meridiem'
  },
  PM: {
    id: 'TimeInputWrapper.pm',
    defaultMessage: 'PM',
    description: '[Type: label][Vis: high] - label for post meridiem'
  },
  HOUR_PLACEHOLDER: {
    id: 'TimeInputWrapper.hhPlaceholder',
    defaultMessage: 'hh',
    description: '[Type: placeholder][Vis: high] - placeholder text for hour input'
  },
  MINUTE_PLACEHOLDER: {
    id: 'TimeInputWrapper.mmPlaceholder',
    defaultMessage: 'mm',
    description: '[Type: placeholder][Vis: high] - placeholder text for minutes input'
  }
});
function TimeInputWrapper(props) {
  // translates and defines the label dictionary
  const l10n = {
    timeLabel: t(COPY$9.TIME_LABEL),
    hour: t(COPY$9.HOUR_LABEL),
    minutes: t(COPY$9.MINUTES_LABEL),
    daytimeLabel: t(COPY$9.DAYTIME_LABEL),
    am: t(COPY$9.AM),
    pm: t(COPY$9.PM),
    hourPlaceholder: t(COPY$9.HOUR_PLACEHOLDER),
    minutesPlaceholder: t(COPY$9.MINUTE_PLACEHOLDER)
  };
  return React__default.createElement(TimeInput, {
    labels: l10n,
    ...props
  });
}
const useStyles$t = createUseStyles(theme => {
  const {
    fontSize,
    fontFamily,
    fontWeight
  } = theme.questionBody;
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '7px',
      color: theme.answerColor
    },
    label: {
      fontSize,
      fontFamily,
      fontWeight,
      color: theme.questionColor,
      marginBottom: '14px'
    },
    inputContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '35px',
      [`@media (max-width: ${theme.breakpoints.sm.min})`]: {
        flexDirection: 'column',
        gap: '5px'
      }
    },
    inlineErrorContainer: {
      padding: '10px 0',
      fontSize: '16px',
      fontWeight: theme.questionBody.fontWeight,
      fontFamily: theme.questionBody.fontFamily,
      '& ul': {
        padding: 0,
        margin: 0
      },
      '& ul li': {
        paddingBottom: '0.2rem',
        listStyle: 'none',
        '&:before': {
          content: '"*"',
          marginRight: '5px'
        }
      }
    }
  };
});
const COPY$8 = defineMessages({
  DATE_INTL_FORMAT_ERROR: {
    id: 'DateTime.formatErrorDateIntl',
    defaultMessage: 'Please provide date in DD/MM/YYYY format.',
    description: '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 US date character format notation)'
  },
  DATE_US_FORMAT_ERROR: {
    id: 'DateTime.formatErrorDateUs',
    defaultMessage: 'Please provide date in MM/DD/YYYY format.',
    description: '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 international date character format notation)'
  },
  ERROR_ENTER_HOURS: {
    id: 'DateTime.errorEnterHours',
    defaultMessage: 'Please enter hours from 0 to 12.',
    description: '[Type: label][Vis: high] - label for incorrect or missing hour input'
  },
  ERROR_ENTER_MINUTES: {
    id: 'DateTime.errorEnterMinutes',
    defaultMessage: 'Please enter minutes from 0 to 59.',
    description: '[Type: label][Vis: high] - label for incorrect or missing minute input'
  },
  ERROR_SELECT_PERIOD: {
    id: 'DateTime.errorSelectPeriod',
    defaultMessage: 'Please select AM/PM.',
    description: '[Type: label][Vis: high] - label for incorrect or missing period selection'
  }
});
function DateTime({
  id: questionId,
  required,
  choices = [],
  responses = [],
  showDate = true,
  showTime = true,
  dateFormat,
  onChange,
  inlineErrors = [],
  ...questionFieldProps
}) {
  const [responseValues, setResponseValues] = useState(responses);
  const errorId = createErrorId(questionId);
  const dateInputRef = useRef(null);
  /** Translation keys may change so this separates the key from the message */
  const errorMessage = useMemo(() => {
    return {
      ERROR_PROVIDE_DATE_INTL_FORMAT: t(COPY$8.DATE_INTL_FORMAT_ERROR),
      ERROR_PROVIDE_DATE_US_FORMAT: t(COPY$8.DATE_US_FORMAT_ERROR),
      ERROR_ENTER_HOURS: t(COPY$8.ERROR_ENTER_HOURS),
      ERROR_ENTER_MINUTES: t(COPY$8.ERROR_ENTER_MINUTES),
      ERROR_SELECT_PERIOD: t(COPY$8.ERROR_SELECT_PERIOD)
    };
  }, []);
  const getDateValueById = id => {
    const choice = responseValues.find(item => item.id === id);
    return choice === null || choice === void 0 ? void 0 : choice.value.date;
  };
  const getTimeValueById = id => {
    const choice = responseValues.find(item => item.id === id);
    return choice !== null && choice !== void 0 && choice.value ? {
      hour: choice === null || choice === void 0 ? void 0 : choice.value.hour,
      minute: choice === null || choice === void 0 ? void 0 : choice.value.minute,
      period: choice === null || choice === void 0 ? void 0 : choice.value.period
    } : undefined;
  };
  const handleDateOrTimeChange = ({
    id,
    date,
    time
  }) => {
    var _newResponse$value, _newResponse$value2, _newResponse$value3;
    const newState = responseValues.filter(r => r.id !== id);
    const prevState = responseValues.find(r => r.id === id) ?? {
      id,
      value: {
        date: '',
        hour: '',
        minute: '',
        period: 'AM'
      }
    };
    const newDateOrTime = time ?? {
      date
    };
    const newResponse = {
      id,
      value: {
        ...prevState.value,
        ...newDateOrTime
      }
    };
    if ((_newResponse$value = newResponse.value) !== null && _newResponse$value !== void 0 && _newResponse$value.date || (_newResponse$value2 = newResponse.value) !== null && _newResponse$value2 !== void 0 && _newResponse$value2.hour || (_newResponse$value3 = newResponse.value) !== null && _newResponse$value3 !== void 0 && _newResponse$value3.minute) {
      newState.push(newResponse);
    }
    setResponseValues(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const {
    container,
    label,
    inputContainer,
    inlineErrorContainer
  } = useStyles$t();
  return React__default.createElement(QuestionField, {
    id: questionId,
    "data-testid": "DateTimeQuestionType",
    ...questionFieldProps
  }, choices === null || choices === void 0 ? void 0 : choices.map(choice => {
    return React__default.createElement("div", {
      className: container,
      key: choice.id,
      id: choice.id
    }, React__default.createElement(RichText, {
      element: "div",
      text: choice.label,
      className: label
    }), React__default.createElement("div", {
      className: inputContainer
    }, showDate && React__default.createElement(DateInputWrapper$1, {
      ref: dateInputRef,
      onChange: date => handleDateOrTimeChange({
        id: choice.id,
        date
      }),
      defaultValue: getDateValueById(choice.id),
      dateFormat: dateFormat,
      required: required,
      "aria-describedby": questionFieldProps.error && errorId || undefined
    }), showTime && React__default.createElement(TimeInputWrapper, {
      onChange: time => handleDateOrTimeChange({
        id: choice.id,
        time
      }),
      defaultValue: getTimeValueById(choice.id),
      required: required
    })), inlineErrors.length > 0 && React__default.createElement("div", {
      className: inlineErrorContainer
    }, React__default.createElement("ul", null, inlineErrors.filter(e => e.fieldId === choice.id).map(error => React__default.createElement("li", {
      key: `${error.fieldId}-${error.detail}`
    }, errorMessage[error.detail])))));
  }));
}
var DateTime$1 = withErrorBoundary(DateTime);
const useStyles$s = createUseStyles(theme => {
  const defaultFontSize = theme.fontSize.body;
  const {
    fontFamily = 'inherit',
    fontWeight = 'inherit',
    fontStyle = 'inherit',
    textDecoration = 'inherit',
    highlightColor = 'inherit',
    color = 'inherit'
  } = theme.questionBody ?? {};
  return {
    otherStyles: {
      marginTop: '5px',
      display: 'block'
    },
    hiddenInput: {
      display: 'none'
    },
    commentChoice: {
      marginTop: 10
    },
    label: {
      display: 'block',
      marginTop: '10px',
      position: 'relative',
      fontFamily,
      fontWeight,
      fontStyle,
      textDecoration,
      highlightColor,
      color,
      fontSize: defaultFontSize
    }
  };
});

/**
 * MultipleChoice Question Type (Tier 2)
 */
function Dropdown({
  id: questionId,
  disabled,
  required: _required,
  readOnly: _readOnly,
  choices = [],
  choiceOther,
  choiceComment,
  responses: defaultResponses = [],
  onChange,
  ...fieldProps
}) {
  const errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  const {
    options,
    sortableOptions,
    otherOption,
    commentOption
  } = useQuestionChoices([...choices, choiceOther, choiceComment]);
  const [responseValue, setResponseValue] = useState(defaultResponses);
  const {
    otherStyles,
    hiddenInput,
    commentChoice
  } = useStyles$s();
  /**
   * Default value by id
   * used for text-input based choices
   */
  const getDefaultValueById = id => {
    const defaultChoice = defaultResponses.find(c => c.id === id);
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  /**
   * Default value for the choices
   */
  const defaultValue = useMemo(() => {
    var _defaultResponses$fin2;
    return (_defaultResponses$fin2 = defaultResponses.find(c => c.type !== 'COMMENT')) === null || _defaultResponses$fin2 === void 0 ? void 0 : _defaultResponses$fin2.id;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   * Other Answer Textfield state
   */
  const [otherText, setOtherText] = useState(otherOption && getDefaultValueById(otherOption.id) || '');
  const handleSelectChange = e => {
    const choiceData = options.find(c => c.id === e.target.value);
    const responses = responseValue.filter(c => c.type === 'COMMENT');
    if (choiceData) {
      const {
        id,
        type
      } = choiceData;
      if (type === 'ANSWER') {
        /** Want to update the value with the value of the TextField texts, when otherAnswer is selected */
        responses.push({
          id,
          type,
          value: otherText
        });
      } else {
        responses.push({
          id,
          type,
          value: e.target.value
        });
      }
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * Other Answer Textfield Change
   */
  const handleTextChange = e => {
    const choiceData = options.find(c => c.type === 'ANSWER');
    const responses = responseValue.filter(c => c.type === 'COMMENT');
    if (choiceData) {
      const {
        id,
        type
      } = choiceData;
      responses.push({
        id,
        type,
        value: e.target.value
      });
      setOtherText(e.target.value);
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const handleCommentChange = e => {
    const choiceData = options.find(c => c.id === e.target.id);
    const responses = responseValue.filter(c => c.type !== 'COMMENT');
    if (choiceData && !!e.target.value) {
      const {
        id,
        type
      } = choiceData;
      responses.push({
        id,
        type,
        value: e.target.value
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const isOtherAnswerSelected = !!responseValue.find(c => c.type === 'ANSWER');
  const multipleTextLines = otherOption && (otherOption === null || otherOption === void 0 ? void 0 : otherOption.linesCount) > 1;
  return React__default.createElement(QuestionField, {
    id: questionId,
    errorId: errorId,
    "data-testid": "DropdownQuestionType",
    ...fieldProps
  }, React__default.createElement(NativeSelect, {
    defaultValue: defaultValue,
    disabled: disabled,
    onChange: handleSelectChange
  }, React__default.createElement(SelectAnswerOption, {
    value: undefined
  }), " ", sortableOptions === null || sortableOptions === void 0 ? void 0 : sortableOptions.map(choice => {
    return React__default.createElement(SelectAnswerOption, {
      key: choice.id,
      id: choice.id,
      label: choice.label,
      value: choice.id
    });
  }), otherOption && React__default.createElement(SelectAnswerOption, {
    key: otherOption.id,
    id: otherOption.id,
    label: otherOption.label,
    value: otherOption.id
  })), otherOption && (multipleTextLines ? React__default.createElement(TextArea$1, {
    defaultValue: getDefaultValueById(otherOption.id),
    autoFocus: false,
    rows: otherOption.linesCount,
    cols: otherOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    onChange: handleTextChange,
    className: classNames(otherStyles, {
      [hiddenInput]: !isOtherAnswerSelected
    }),
    tabIndex: isOtherAnswerSelected ? 0 : -1
  }) : React__default.createElement(TextInput$1, {
    defaultValue: getDefaultValueById(otherOption.id),
    autoFocus: false,
    autoHeight: true,
    size: otherOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    onChange: handleTextChange,
    className: classNames(otherStyles, {
      [hiddenInput]: !isOtherAnswerSelected
    }),
    tabIndex: isOtherAnswerSelected ? 0 : -1
  })), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    "aria-describedby": fieldProps.error && errorId,
    className: commentChoice
  }));
}
var Dropdown$1 = withErrorBoundary(Dropdown);
const useStyles$r = createUseStyles(theme => ({
  imageChoice: {
    display: 'flex',
    position: 'relative'
  },
  labelContainer: ({
    checked,
    disabled
  }) => {
    const borderColor = disabled && !checked ? 'transparent' : theme.primaryAccentColor;
    return {
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      cursor: 'pointer',
      width: '100%',
      border: [1, 'solid', checked ? theme.questionColor : theme.questionBody.highlightColor ?? 'rgb(208, 210, 211)'],
      borderRadius: 2,
      backgroundColor: checked ? theme.input.bgColor : 'inherit',
      ...theme.questionBody,
      '&:hover': {
        border: [1, 'solid', borderColor]
      },
      '&:focus-within': {
        border: [1, 'solid', borderColor]
      }
    };
  },
  controlImage: {
    position: 'absolute',
    right: '-1',
    top: '-1',
    width: '26px',
    height: '26px',
    transitionDuration: '0.3s',
    border: 'none',
    borderRadius: 2,
    zIndex: 10,
    transform: ({
      checked
    }) => checked ? 'scale(1)' : 'scale(0)'
  },
  optionLabel: ({
    checked
  }) => {
    return {
      padding: '9px 7px',
      width: '100%',
      wordWrap: 'break-word',
      fontWeight: checked ? 'bold' : 'normal',
      '&:focus-within': {
        background: theme.questionBody.highlightColor ?? 'rgb(208, 210, 211)'
      }
    };
  },
  imageContainer: {
    paddingTop: '75%',
    width: '100%',
    position: 'relative',
    '& > img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  },
  inputContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: '#EFEFEF'
  }
}));
const useStyles$q = createUseStyles(theme => ({
  imageInput: ({
    checked,
    disabled,
    readOnly
  }) => {
    const checkBgColor = checked ? theme.questionColor : 'transparent';
    const backgroundColor = disabled || readOnly ? '#aaa' : checkBgColor;
    return {
      color: disabled || readOnly ? '#aaa' : theme.input.activeColor,
      border: 'none',
      borderRadius: 4,
      backgroundColor,
      '& .checkmark': {
        fill: contrastColor(theme.input.activeColor)
      },
      '& input': {
        cursor: 'pointer'
      }
    };
  }
}));
function ImageInput({
  className,
  type,
  ...props
}, ref) {
  const {
    inputProps,
    styleProps
  } = useInputStyles(props);
  const {
    imageInput
  } = useStyles$q(styleProps);
  return React__default.createElement(BaseInput$1, {
    ref: ref,
    type: type,
    className: classNames(imageInput, className),
    icon: React__default.createElement(CheckboxIcon$1, null),
    ...inputProps
  });
}
var ImageInput$1 = React__default.forwardRef(ImageInput);
function ImageChoice$2({
  id,
  type,
  alt = '',
  label,
  src: imageSrc,
  className,
  checked,
  name,
  onChange,
  onKeyDown,
  onClick,
  disabled: disabledProp,
  'aria-disabled': ariaDisabledProp,
  readOnly: readOnlyProp,
  'aria-readonly': ariaReadOnlyProp,
  ...inputProps
}, ref) {
  const handleChange = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: e.target.id,
      checked: e.target.checked,
      value: e.target.value
    });
  };
  const handleClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    const target = e.target;
    let checkVal = true;
    if (!inputProps.required && checked) {
      checkVal = false;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: target.id,
      checked: checkVal,
      value: target.value
    });
  };
  const handleKeyboard = e => {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    const target = e.target;
    if (!inputProps.required && checked && e.code === 'Space') {
      e.preventDefault();
      onChange === null || onChange === void 0 ? void 0 : onChange({
        id: target.id,
        checked: false,
        value: target.value
      });
    }
  };
  const disabled = disabledProp || ariaDisabledProp === 'true';
  const readOnly = readOnlyProp || ariaReadOnlyProp === 'true';
  const {
    imageChoice,
    controlImage,
    inputContainer,
    labelContainer,
    optionLabel,
    imageContainer
  } = useStyles$r({
    disabled,
    readOnly,
    checked
  });
  const imageId = `${id}-image`;
  const labelId = `${id}-label`;
  const ariaDescribeId = alt ? imageId : undefined;
  const imageInputEvents = type === 'radio' ? {
    onClick: handleClick,
    onKeyDown: handleKeyboard,
    onChange: handleChange
  } : {
    onChange: handleChange
  };
  return React__default.createElement("div", {
    className: imageChoice
  }, React__default.createElement("label", {
    htmlFor: id,
    className: classNames(labelContainer, className),
    tabIndex: -1
  }, React__default.createElement("div", {
    className: inputContainer
  }, React__default.createElement(ImageInput$1, {
    "aria-labelledby": labelId,
    "aria-describedby": ariaDescribeId,
    ref: ref,
    checked: checked,
    className: controlImage,
    id: id,
    type: type,
    value: id,
    name: name,
    ...inputProps,
    ...imageInputEvents
  }), React__default.createElement("div", {
    className: imageContainer
  }, React__default.createElement("img", {
    id: imageId,
    src: imageSrc,
    alt: alt
  }))), label && React__default.createElement("span", {
    id: labelId,
    className: optionLabel
  }, label)));
}
var ImageChoiceOption = forwardRef(ImageChoice$2);
const useStyles$p = createUseStyles(theme => {
  var _theme$breakpoints4, _theme$breakpoints5, _theme$breakpoints6;
  const isFull = theme.layout.includes('CENTER') || theme.layout.includes('BANNER');
  const isThird = theme.layout.includes('THIRD');
  const isHalf = theme.layout.includes('HALF') || theme.layout.includes('FULL') && !theme.layout.includes('CENTER');
  const cols3 = 'repeat(3, minmax(0, 1fr))';
  const cols2 = 'repeat(2, minmax(0, 1fr))';
  const cols1 = 'minmax(0, 1fr)';
  return {
    imageChoiceContainer: {
      display: 'grid',
      flexWrap: 'wrap',
      gap: '25px',
      width: '100%',
      gridTemplateColumns: 'minmax(0, 1fr)',
      [`@media (min-width: ${(_theme$breakpoints4 = theme.breakpoints) === null || _theme$breakpoints4 === void 0 ? void 0 : _theme$breakpoints4.md.min})`]: {
        gridTemplateColumns: isFull || isThird ? cols2 : cols1
      },
      [`@media (min-width: ${(_theme$breakpoints5 = theme.breakpoints) === null || _theme$breakpoints5 === void 0 ? void 0 : _theme$breakpoints5.lg.min})`]: {
        gridTemplateColumns: () => {
          if (isFull || isThird) {
            return cols3;
          }
          if (isHalf) {
            return cols2;
          }
          return cols1;
        }
      },
      [`@media (min-width: ${(_theme$breakpoints6 = theme.breakpoints) === null || _theme$breakpoints6 === void 0 ? void 0 : _theme$breakpoints6.xl.min})`]: {
        gridTemplateColumns: isHalf ? cols2 : cols3
      }
    },
    imageChoice: {
      width: '100%'
    },
    noneOfTheAboveContainer: {
      marginTop: '15px'
    }
  };
});
const INPUT_SIZE$1 = 20;
function ImageChoice({
  id: questionId,
  readOnly,
  required,
  disabled,
  multiple = false,
  choices = [],
  choiceNoneOfTheAbove,
  onChange,
  responses = [],
  ...questionFieldProps
}) {
  const imageChoiceType = multiple ? 'checkbox' : 'radio';
  const groupName = !multiple ? `${questionId}-imageChoice` : undefined;
  const errorId = createErrorId(questionId);
  const [selectedChoices, setSelectedChoices] = useState(responses);
  const handleChange = e => {
    const newState = !multiple ? [] : selectedChoices.filter(c => c.id !== e.id && c.type !== 'NOTA');
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const handleNAChange = e => {
    const newState = [];
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value,
        type: 'NOTA'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const isChecked = id => !!selectedChoices.find(item => item.id === id);
  const {
    imageChoiceContainer,
    imageChoice,
    noneOfTheAboveContainer
  } = useStyles$p();
  return React__default.createElement(QuestionField, {
    id: questionId,
    "data-testid": "ImageChoiceQuestionType",
    errorId: errorId,
    ...questionFieldProps
  }, React__default.createElement("div", {
    className: imageChoiceContainer
  }, choices === null || choices === void 0 ? void 0 : choices.map(choice => {
    return React__default.createElement(ImageChoiceOption, {
      key: choice.id,
      id: choice.id,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      label: choice.label,
      onChange: handleChange,
      className: imageChoice,
      value: choice.id,
      src: choice.image.url,
      alt: choice.image.altText || '',
      name: groupName,
      type: imageChoiceType,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      checked: isChecked(choice.id)
    });
  })), choiceNoneOfTheAbove && (choiceNoneOfTheAbove === null || choiceNoneOfTheAbove === void 0 ? void 0 : choiceNoneOfTheAbove.visible) && React__default.createElement("div", {
    className: noneOfTheAboveContainer
  }, React__default.createElement(Checkbox$3, {
    id: choiceNoneOfTheAbove.id,
    value: choiceNoneOfTheAbove.id,
    onChange: handleNAChange,
    checked: isChecked(choiceNoneOfTheAbove.id),
    disabled: disabled,
    readOnly: readOnly,
    "aria-describedby": questionFieldProps.error && errorId || undefined,
    inputSize: INPUT_SIZE$1
  }, choiceNoneOfTheAbove.label)));
}
var ImageChoice$1 = withErrorBoundary(ImageChoice);
const useStyles$o = createUseStyles({
  imageStyles: {
    maxWidth: '100%',
    display: 'block'
  }
});
function Image({
  alt = '',
  className,
  ...props
}) {
  const {
    imageStyles
  } = useStyles$o();
  return React__default.createElement("img", {
    className: classNames(imageStyles, className),
    "data-testid": "image",
    alt: alt,
    ...props
  });
}
const useStyles$n = createUseStyles(theme => {
  return {
    presentationalTitleStyles: {
      fontFamily: theme.questionTitle.fontFamily ?? 'inherit',
      fontSize: theme.questionTitle.fontSize ?? '16px',
      fontWeight: theme.questionTitle.fontWeight ?? (theme.isAccessible ? 500 : 300),
      marginBottom: '24px',
      textDecoration: theme.questionTitle.textDecoration ?? 'inherit'
    },
    buttonStyles: {
      marginTop: '20px'
    }
  };
});
function ImagePresentational({
  text,
  image,
  padding = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  id,
  okButton = {
    visible: false
  }
}) {
  const richTextId = `text-presentational-header-${id}`;
  const {
    presentationalTitleStyles,
    buttonStyles
  } = useStyles$n();
  const {
    visible: showButton,
    ...buttonProps
  } = okButton;
  return React__default.createElement(QuestionSpacing, {
    padding: padding,
    "data-testid": "ImagePresentational"
  }, text && React__default.createElement(RichText, {
    id: richTextId,
    element: "div",
    text: text,
    className: presentationalTitleStyles
  }), React__default.createElement(Image, {
    ...image
  }), showButton && React__default.createElement(Button, {
    ...buttonProps,
    className: buttonStyles
  }));
}
var ImagePresentational$1 = withErrorBoundary(ImagePresentational);
const useStyles$m = createUseStyles(theme => ({
  radioInput: {
    '& label': {
      alignItems: 'baseline'
    }
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  textInput: {
    opacity: ({
      checked
    }) => checked ? 1 : 0.5,
    cursor: ({
      checked
    }) => checked ? 'inherit' : 'pointer',
    marginTop: 5,
    marginLeft: 32,
    maxWidth: 'calc(100% - 32px)',
    [`@media (max-width: ${theme.breakpoints.xxs.max})`]: {
      marginLeft: 0,
      maxWidth: '100%'
    },
    // overwrite TextInput styles
    fontSize: theme.questionBody.fontSize,
    lineHeight: 'normal'
  },
  checkHover: {
    '&:hover': {
      outline: 'none'
    }
  }
}));
function RadioTextfield({
  refs,
  ...props
}) {
  const {
    id,
    children: label,
    checked: checkedProp = false,
    value: valueProp,
    defaultValue,
    lineCount = 1,
    charCount = 50,
    maxLength,
    onClick,
    onChange,
    ...radioProps
  } = props;
  const radioGroup = useRadioGroup();
  const [checked, setChecked] = useState(checkedProp);
  const [value, setValue] = useState(defaultValue || valueProp);
  const radioInputRef = useRef(null);
  const radioRef = useForkRef(radioInputRef, refs === null || refs === void 0 ? void 0 : refs.radio);
  const textInputRef = useRef(null);
  const inputRef = useForkRef(textInputRef, refs === null || refs === void 0 ? void 0 : refs.text);
  const multipleTextLines = lineCount > 1;
  const handleValueChange = e => {
    radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange(e);
    setValue(e.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  const handleInputChange = e => {
    handleValueChange({
      id,
      value: e.target.value,
      checked
    });
  };
  const handleFocusChange = e => {
    handleValueChange({
      id,
      value: e.target.value,
      checked
    });
  };
  const handleClick = e => {
    /**
     * Selection via keyboard calls onClick event - check for
     * mouse-position to ensure we were called by a pointing device.
     */
    if (!checked && e.clientX !== 0 && e.clientY !== 0) {
      var _textInputRef$current;
      textInputRef === null || textInputRef === void 0 ? void 0 : (_textInputRef$current = textInputRef.current) === null || _textInputRef$current === void 0 ? void 0 : _textInputRef$current.focus();
    }
    setChecked(true);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  useEffect(() => {
    setChecked(checkedProp);
  }, [checkedProp]);
  useEffect(() => {
    if ((radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.value) !== value) {
      setChecked(false);
    }
  }, [radioGroup, value]);
  const {
    radioInput,
    textInput,
    checkHover
  } = useStyles$m({
    checked
  });
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Radio$1, {
    id: `radio-input-${id}`,
    checked: checked,
    value: value,
    onClick: handleClick,
    onChange: handleValueChange,
    className: radioInput,
    ref: radioRef,
    ...radioProps
  }, label), multipleTextLines ? React__default.createElement(TextArea$1, {
    id: `radio-field-${id}`,
    defaultValue: defaultValue,
    autoFocus: false,
    rows: lineCount,
    cols: charCount,
    maxLength: maxLength,
    onClick: handleClick,
    onChange: handleInputChange,
    onBlur: handleFocusChange,
    onFocus: handleFocusChange,
    className: classNames(textInput, {
      [checkHover]: !checked
    }),
    ref: inputRef,
    tabIndex: checked ? 0 : -1
  }) : React__default.createElement(TextInput$1, {
    id: `radio-field-${id}`,
    defaultValue: defaultValue,
    autoFocus: false,
    autoHeight: true,
    size: charCount,
    maxLength: maxLength,
    onClick: handleClick,
    onChange: handleInputChange,
    onBlur: handleFocusChange,
    onFocus: handleFocusChange,
    className: classNames(textInput, {
      [checkHover]: !checked
    }),
    ref: inputRef,
    tabIndex: checked ? 0 : -1
  }));
}
const useStyles$l = createUseStyles({
  commentChoiceContainer: {
    marginTop: '10px'
  }
});
const INPUT_SIZE = 20;
/**
 * MultipleChoice Question Type (Tier 2)
 */
function MultipleChoice({
  id: questionId,
  required,
  disabled,
  readOnly,
  columnLayout = 1,
  choices = [],
  choiceNoneOfTheAbove,
  choiceOther,
  choiceComment,
  responses: defaultResponses = [],
  onChange,
  ...fieldProps
}) {
  const groupId = createFieldId(questionId);
  const errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  const {
    options,
    sortableOptions,
    notaOption,
    otherOption,
    commentOption
  } = useQuestionChoices([...choices, choiceNoneOfTheAbove, choiceOther, choiceComment]);
  const [responseValue, setResponseValue] = useState(defaultResponses);
  /**
   * Default value by id
   * used for text-input based choices
   */
  const getDefaultValueById = id => {
    const defaultChoice = defaultResponses.find(c => c.id === id);
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  /**
   * Default value for the group
   */
  const defaultValue = useMemo(() => {
    var _defaultResponses$fin3;
    return (_defaultResponses$fin3 = defaultResponses.find(c => c.type !== 'COMMENT')) === null || _defaultResponses$fin3 === void 0 ? void 0 : _defaultResponses$fin3.value;
  },
  // defaultValues should not be changed post render (breaks rules of controlled components)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  /**
   * Determine if choice is selected
   * @return TRUE if the choice.id exists in responses
   */
  const isChecked = id => {
    return !!responseValue.find(c => c.id === id);
  };
  const handleRadioChange = e => {
    const choiceData = options.find(c => e.id.match(c.id));
    const responses = responseValue.filter(c => c.type === 'COMMENT');
    if (choiceData) {
      const {
        id,
        type
      } = choiceData;
      responses.push({
        id,
        type,
        value: e.value
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const handleCommentChange = e => {
    const choiceData = options.find(c => c.id === e.target.id);
    const responses = responseValue.filter(c => c.type !== 'COMMENT');
    if (choiceData && !!e.target.value) {
      const {
        id,
        type
      } = choiceData;
      responses.push({
        id,
        type,
        value: e.target.value
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * deselect choice if the question is not required
   */
  const unCheckOption = () => {
    if (required) {
      return;
    }
    const responses = responseValue.filter(c => c.type === 'COMMENT');
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const handleClick = e => {
    // match is used since RadioTextfield applies a prefix
    // to maintain unique ID's'
    const input = e.target;
    const isSelected = responseValue.find(c => input.id.match(c.id));
    if (isSelected && input.checked) {
      e.preventDefault();
      unCheckOption();
    }
  };
  const handleKeyboard = e => {
    const isSelected = responseValue.find(c => e.target.id.match(c.id));
    if (isSelected && e.code === 'Space') {
      e.preventDefault();
      unCheckOption();
    }
  };
  const radioEvents = {
    onClick: handleClick,
    onKeyDown: handleKeyboard
  };
  const radioGroupProps = {
    disabled,
    readOnly,
    name: groupId,
    defaultValue,
    onChange: handleRadioChange
  };
  const {
    commentChoiceContainer
  } = useStyles$l();
  return React__default.createElement(QuestionField, {
    id: questionId,
    errorId: errorId,
    "data-testid": "MultipleChoiceQuestionType",
    ...fieldProps
  }, React__default.createElement(RadioGroup, {
    ...radioGroupProps
  }, React__default.createElement(QuestionAnswerLayoutTemplate, {
    gridCellMargin: [0, 2, 5, 2],
    otherCellMargin: [0, 2, 5, 2],
    columns: columnLayout,
    other: otherOption && React__default.createElement(RadioTextfield, {
      id: otherOption.id,
      checked: isChecked(otherOption.id),
      defaultValue: getDefaultValueById(otherOption.id),
      lineCount: otherOption.linesCount,
      charCount: otherOption.charsCount,
      maxLength: TEXT_INPUT_MAX_CHARS,
      "aria-describedby": fieldProps.error && errorId,
      inputSize: INPUT_SIZE,
      ...radioEvents
    }, otherOption.label),
    noneOfTheAbove: notaOption && React__default.createElement(Radio$1, {
      id: notaOption.id,
      value: notaOption.id,
      checked: isChecked(notaOption.id),
      "aria-describedby": fieldProps.error && errorId,
      inputSize: INPUT_SIZE,
      ...radioEvents
    }, notaOption.label)
  }, sortableOptions.map(choice => React__default.createElement(Radio$1, {
    id: choice.id,
    key: choice.id,
    value: choice.id,
    checked: isChecked(choice.id),
    "aria-describedby": fieldProps.error && errorId,
    inputSize: INPUT_SIZE,
    ...radioEvents
  }, choice.label))), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    "aria-describedby": fieldProps.error && errorId,
    className: commentChoiceContainer
  })));
}
const useStyles$k = createUseStyles(theme => {
  const {
    fontSize,
    fontFamily,
    fontWeight
  } = theme.questionBody;
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      wordBreak: 'break-word',
      marginBottom: '7px',
      [`@media (max-width: ${theme.breakpoints.sm.min})`]: {
        flexWrap: 'wrap'
      }
    },
    label: {
      fontSize,
      fontFamily,
      fontWeight,
      color: theme.questionColor,
      flex: '0 0 20%',
      marginRight: '7px',
      [`@media (max-width: ${theme.breakpoints.sm.min})`]: {
        flex: '0 0 100%',
        margin: '0 2px 2px 0'
      }
    },
    input: {
      marginTop: 'auto',
      flex: 'auto'
    }
  };
});
function MultipleTextbox({
  id: questionId,
  required: _req,
  disabled,
  readOnly,
  choices = [],
  responses = [],
  onChange,
  size,
  ...fieldProps
}) {
  const [responseValues, setResponseValues] = useState(responses);
  const {
    error,
    errorId = createErrorId(questionId)
  } = fieldProps;
  const getDefaultValueById = id => {
    const defaultChoice = responseValues.find(item => item.id === id);
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  const handleChange = e => {
    const newState = responseValues.filter(response => response.id !== e.target.id);
    if (e.target.value) {
      const newResponse = {
        id: e.target.id,
        value: e.target.value
      };
      newState.push(newResponse);
    }
    setResponseValues(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  const {
    container,
    label,
    input
  } = useStyles$k();
  return React__default.createElement(QuestionField, {
    id: questionId,
    errorId: errorId,
    "data-testid": "MultipleTextbox",
    ...fieldProps
  }, choices === null || choices === void 0 ? void 0 : choices.map(choice => {
    const labelId = `${choice.id}-label`;
    return React__default.createElement("div", {
      className: container,
      key: choice.id
    }, React__default.createElement("label", {
      className: label,
      id: labelId,
      htmlFor: choice.id
    }, React__default.createElement(RichText, {
      element: "span",
      text: choice.label
    })), React__default.createElement(TextInput$1, {
      id: choice.id,
      defaultValue: getDefaultValueById(choice.id),
      disabled: disabled,
      readOnly: readOnly,
      size: size,
      onChange: handleChange,
      "aria-invalid": !!error,
      "aria-describedby": error && errorId,
      maxLength: TEXT_INPUT_MAX_CHARS,
      className: input
    }));
  }));
}
const useStyles$j = createUseStyles(theme => {
  const fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    npsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minWidth: 230
    },
    npsLabel: {
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 14,
      fontWeight: fontWeightOptions.light,
      lineHeight: 1.25
    },
    npsRatingButtonList: {
      margin: 0,
      padding: 0,
      display: 'inline-flex',
      listStyleType: 'none',
      border: [1, 'solid', theme.primaryAccentColor],
      borderRadius: 4,
      overflow: 'hidden',
      outline: [2, 'solid', 'transparent'],
      outlineOffset: 2,
      width: '100%'
    },
    npsRatingButton: ({
      isRTL
    }) => ({
      padding: 0,
      minWidth: 20,
      flex: '1 1 9.09%',
      '& + $npsRatingButton': {
        borderLeft: isRTL ? 0 : [2, 'solid', theme.primaryAccentColor],
        borderRight: isRTL ? [2, 'solid', theme.primaryAccentColor] : 0
      }
    }),
    minLabel: ({
      isRTL
    }) => ({
      margin: isRTL ? [0, 4, 2, 0] : [0, 0, 2, 4]
    }),
    maxLabel: ({
      isRTL
    }) => ({
      margin: isRTL ? [0, 0, 2, 4] : [0, 4, 2, 0]
    }),
    srOnly: visuallyHidden$1
  };
});
const useStyles$i = createUseStyles(theme => {
  // theme.correctAnswerHighlightColor is the correct color, but not an accurate token.
  const focusBackgroundColor = theme.correctAnswerHighlightColor;
  return {
    container: {
      position: 'relative',
      display: 'flex',
      cursor: 'pointer'
    },
    radio: {
      appearance: 'none',
      outline: 'none',
      position: 'absolute',
      width: '100%',
      height: '100%',
      '&:focus + $label, &:hover + $label': {
        border: [2, 'solid', theme.primaryAccentColor],
        backgroundColor: focusBackgroundColor
      },
      '&:checked + $label': {
        backgroundColor: theme.questionColor,
        color: theme.primaryBackgroundColor,
        fontWeight: 'bold',
        transition: 'background 200ms ease'
      }
    },
    label: {
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      border: [2, 'solid', 'transparent'],
      backgroundColor: theme.primaryBackgroundColor,
      color: theme.questionColor,
      fontFamily: theme.fontFamily,
      fontSize: 15,
      fontWeight: 700,
      padding: [10, 0],
      width: '100%'
    }
  };
});
function NpsRatingButton({
  id,
  className,
  children: label,
  component: Tag = 'div',
  ...props
}) {
  const styles = useStyles$i();
  return React__default.createElement(Tag, {
    className: classNames(styles.container, className)
  }, React__default.createElement("input", {
    id: id,
    type: "radio",
    className: styles.radio,
    ...props
  }), React__default.createElement("label", {
    className: classNames(styles.label),
    htmlFor: id
  }, label));
}
const COPY$7 = defineMessages({
  NPS_QUESTION_TITLE: {
    id: 'Nps.QUESTION_TITLE',
    defaultMessage: '<div class="{srOnlyClass}">On a scale of {minValue} to {maxValue}, </div>{heading}<div id="{instructionsId}" class="{srOnlyClass}"> {minValue} for {minLabelText}, {maxValue} for {maxLabelText}</div>',
    description: '[Type: header][Vis: high] - question title'
  }
});
/** Unicode dash characters, in addition to standard delimiters (forward/back-slash, pipe, hyphen) */
const LABEL_SEPERATOR = /\s(?:[\u2010-\u2015\u2043/\-|])\s/gi;
function Nps({
  id: questionId,
  choices = [],
  className,
  title,
  rowId,
  responses: defaultResponses = [],
  required,
  onChange,
  ...fieldProps
}) {
  var _choices$, _choices$slice$;
  const [responseValue, setResponseValue] = useState(defaultResponses);
  const defaultValue = useMemo(() => {
    var _defaultResponses$fin4;
    return ((_defaultResponses$fin4 = defaultResponses.find(r => !!r.value)) === null || _defaultResponses$fin4 === void 0 ? void 0 : _defaultResponses$fin4.value) ?? '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const ratingChanged = e => {
    const {
      value
    } = e.target;
    const response = value ? [{
      id: rowId,
      value
    }] : [];
    /**
     * FIXES: RAWR-1628
     * Safari doesn't apply focus by default; an inelegant solution for an inelegant browser.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
     */
    e.target.focus();
    setResponseValue(response);
    onChange === null || onChange === void 0 ? void 0 : onChange(response);
  };
  const unCheckOption = input => {
    if (required) {
      return;
    }
    // eslint-disable-next-line no-param-reassign
    input.checked = false;
    setResponseValue([]);
    onChange === null || onChange === void 0 ? void 0 : onChange([]);
  };
  const buttonClicked = e => {
    var _responseValue$;
    const input = e.target;
    const isSelected = ((_responseValue$ = responseValue[0]) === null || _responseValue$ === void 0 ? void 0 : _responseValue$.value) === input.value;
    if (isSelected && input.checked) {
      unCheckOption(input);
    }
  };
  const handleKeyboard = e => {
    var _responseValue$2;
    const input = e.target;
    const isSelected = ((_responseValue$2 = responseValue[0]) === null || _responseValue$2 === void 0 ? void 0 : _responseValue$2.value) === input.value;
    if (isSelected && e.code === 'Space') {
      e.preventDefault();
      unCheckOption(input);
    }
  };
  const getLabel = str => {
    let parts = str.split(LABEL_SEPERATOR);
    // the direction of the label is not always written reverse,
    // and is not based on RTL. (i.e. Russian)
    if (Number.isNaN(Number(parts[0]))) {
      parts = parts.reverse();
    }
    const [numLabel, textLabel] = parts;
    return [numLabel, textLabel ?? numLabel];
  };
  const {
    isRTL
  } = useContext(L10NContext);
  const errorId = createErrorId(questionId);
  const {
    npsContainer,
    npsLabel,
    minLabel,
    maxLabel,
    srOnly,
    npsRatingButtonList,
    npsRatingButton
  } = useStyles$j({
    isRTL
  });
  const {
    heading
  } = title;
  const minFullLabel = ((_choices$ = choices[0]) === null || _choices$ === void 0 ? void 0 : _choices$.label) ?? '';
  const maxFullLabel = ((_choices$slice$ = choices.slice(-1)[0]) === null || _choices$slice$ === void 0 ? void 0 : _choices$slice$.label) ?? '';
  const [minValue, minLabelText] = getLabel(minFullLabel);
  const [maxValue, maxLabelText] = getLabel(maxFullLabel);
  const instructionsId = `${questionId}-instructions`;
  const accessibleHeading = t(COPY$7.NPS_QUESTION_TITLE, {
    minValue,
    maxValue,
    minLabelText,
    maxLabelText,
    heading,
    instructionsId,
    srOnlyClass: classNames(srOnly)
  });
  const accessibleTitle = {
    ...title,
    heading: accessibleHeading
  };
  return React__default.createElement(QuestionField, {
    id: questionId,
    errorId: errorId,
    "data-testid": "NpsQuestionType",
    title: accessibleTitle,
    ...fieldProps
  }, React__default.createElement("div", {
    className: classNames(npsContainer, className)
  }, React__default.createElement("span", {
    className: classNames(npsLabel, minLabel),
    role: "presentation"
  }, minLabelText), React__default.createElement("span", {
    className: classNames(npsLabel, maxLabel),
    role: "presentation"
  }, maxLabelText), React__default.createElement("div", {
    className: classNames(npsRatingButtonList)
  }, choices.map(c => React__default.createElement(NpsRatingButton, {
    id: `${questionId}-${c.id}`,
    key: `${questionId}-${c.id}`,
    name: `${questionId}-rating`,
    value: c.id,
    className: classNames(npsRatingButton),
    onChange: ratingChanged,
    onClick: buttonClicked,
    onKeyDown: handleKeyboard,
    defaultChecked: defaultValue === c.id
  }, getLabel(c.label)[0])))));
}
const useStyles$h = createUseStyles(theme => {
  var _theme$breakpoints7;
  return {
    gridCell: {
      display: 'flex',
      flex: '1 auto',
      position: 'relative',
      padding: 3
    },
    gridCellMobile: {
      [`@media (max-width: ${(_theme$breakpoints7 = theme.breakpoints) === null || _theme$breakpoints7 === void 0 ? void 0 : _theme$breakpoints7.xs.max})`]: {
        justifyContent: 'flex-start',
        background: theme.correctAnswerHighlightColor,
        marginTop: '5px',
        marginBottom: '5px'
      }
    }
  };
});
function GridCell({
  isGridWhenMobile,
  children,
  ...props
}) {
  const {
    gridCell,
    gridCellMobile
  } = useStyles$h();
  return React__default.createElement("div", {
    className: classNames(gridCell, {
      [gridCellMobile]: !isGridWhenMobile
    }),
    role: "gridcell",
    ...props
  }, children);
}
const useStyles$g = createUseStyles(theme => {
  var _theme$breakpoints8, _theme$breakpoints9, _theme$breakpoints10, _theme$breakpoints11, _theme$breakpoints12;
  return {
    labelVisibleBase: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      textAlign: 'left',
      padding: [3, 3, 3, 7],
      fontWeight: theme.questionBody.fontWeight ?? null,
      fontFamily: theme.questionBody.fontFamily ?? null,
      fontSize: theme.questionBody.fontSize ?? null,
      width: 150,
      [`@media (max-width: ${(_theme$breakpoints8 = theme.breakpoints) === null || _theme$breakpoints8 === void 0 ? void 0 : _theme$breakpoints8.sm.max})`]: {
        width: 100
      },
      [`@media (max-width: ${(_theme$breakpoints9 = theme.breakpoints) === null || _theme$breakpoints9 === void 0 ? void 0 : _theme$breakpoints9.xs.max})`]: {
        width: 75
      }
    },
    labelVisibleMobile: {
      [`@media (max-width: ${(_theme$breakpoints10 = theme.breakpoints) === null || _theme$breakpoints10 === void 0 ? void 0 : _theme$breakpoints10.xs.max})`]: {
        width: '100%'
      }
    },
    labelHidden: {
      display: 'none'
    },
    rowBaseStyles: {
      display: 'flex',
      width: '100%',
      color: theme.answerColor,
      border: 'none',
      background: theme.correctAnswerHighlightColor,
      [`@media (max-width: ${(_theme$breakpoints11 = theme.breakpoints) === null || _theme$breakpoints11 === void 0 ? void 0 : _theme$breakpoints11.xs.max})`]: {
        marginTop: '5px',
        marginBottom: '5px'
      }
    },
    rowAsColumnStyles: {
      [`@media (max-width: ${(_theme$breakpoints12 = theme.breakpoints) === null || _theme$breakpoints12 === void 0 ? void 0 : _theme$breakpoints12.xs.max})`]: {
        flexDirection: 'column'
      }
    }
  };
});
function GridRow({
  id: rowId,
  row: rowIndex,
  label,
  columnDataArray,
  hideLabel,
  className,
  gridComponent,
  isGridWhenMobile
}) {
  const {
    rowBaseStyles,
    rowAsColumnStyles,
    labelHidden,
    labelVisibleBase,
    labelVisibleMobile
  } = useStyles$g();
  const labelVisibleClass = isGridWhenMobile ? labelVisibleBase : classNames(labelVisibleBase, labelVisibleMobile);
  const labelClass = hideLabel ? labelHidden : labelVisibleClass;
  return React__default.createElement("div", {
    id: rowId,
    role: "row",
    className: classNames(rowBaseStyles, className, {
      [rowAsColumnStyles]: !isGridWhenMobile
    })
  }, React__default.createElement("div", {
    id: `${rowId}-header`,
    role: "rowheader",
    className: labelClass
  }, React__default.createElement(RichText, {
    element: "span",
    text: label
  })), columnDataArray.map(({
    id: colId
  }, colIndex) => {
    const cellId = `${rowId}-${colId}-cell`;
    const props = {
      rowId,
      rowIndex,
      colId,
      colIndex,
      label,
      'aria-labelledby': `${rowId}-header ${colId}-header`
    };
    return React__default.createElement(GridCell, {
      id: cellId,
      key: cellId,
      "data-row": rowIndex,
      "data-col": colIndex,
      isGridWhenMobile: isGridWhenMobile
    }, gridComponent === null || gridComponent === void 0 ? void 0 : gridComponent({
      ...props
    }));
  }));
}
const useStyles$f = createUseStyles(theme => {
  var _theme$breakpoints13, _theme$breakpoints14, _theme$breakpoints15, _theme$breakpoints16, _theme$breakpoints17;
  return {
    gridContainer: {
      width: '100%',
      // grid keeps the grid rows all the same length, and therefore the grid columns in alignment
      display: 'grid'
    },
    gridStyles: {
      display: 'flex',
      flexWrap: 'wrap',
      color: theme.answerColor,
      border: 'none'
    },
    stripeBasic: {
      '& [role="row"]:nth-child(even)': {
        background: 'transparent'
      }
    },
    stripeBasicMobile: {
      [`@media (max-width: ${(_theme$breakpoints13 = theme.breakpoints) === null || _theme$breakpoints13 === void 0 ? void 0 : _theme$breakpoints13.xs.max})`]: {
        '& [role="row"]': {
          background: 'transparent'
        }
      }
    },
    stripeOther: {
      '& [role="row"]': {
        background: 'transparent',
        width: '100%',
        '& [data-other]': {
          textAlign: 'left'
        }
      },
      // alternating elements 2 at a time (1+2, 5+6, 9+10) with n starting at 0
      '& [role="row"]:nth-child(4n+1), & [role="row"]:nth-child(4n+2)': {
        background: theme.correctAnswerHighlightColor
      }
    },
    stripeOtherMobile: {
      [`@media (max-width: ${(_theme$breakpoints14 = theme.breakpoints) === null || _theme$breakpoints14 === void 0 ? void 0 : _theme$breakpoints14.xs.max})`]: {
        '& [role="row"]:nth-child(4n+1), & [role="row"]:nth-child(4n+2)': {
          background: 'transparent'
        }
      }
    },
    columnContainerBase: {
      display: 'flex',
      width: '100%'
    },
    columnContainerMobile: {
      [`@media (max-width: ${(_theme$breakpoints15 = theme.breakpoints) === null || _theme$breakpoints15 === void 0 ? void 0 : _theme$breakpoints15.xs.max})`]: {
        display: 'none'
      }
    },
    columnHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      flex: 1,
      padding: 3,
      color: theme.answerColor,
      fontWeight: theme.questionBody.fontWeight ?? null,
      fontFamily: theme.questionBody.fontFamily ?? null,
      fontSize: 14,
      textAlign: 'center'
    },
    bufferVisible: {
      width: 150,
      [`@media (max-width: ${(_theme$breakpoints16 = theme.breakpoints) === null || _theme$breakpoints16 === void 0 ? void 0 : _theme$breakpoints16.sm.max})`]: {
        width: 100
      },
      [`@media (max-width: ${(_theme$breakpoints17 = theme.breakpoints) === null || _theme$breakpoints17 === void 0 ? void 0 : _theme$breakpoints17.xs.max})`]: {
        width: 75
      }
    },
    bufferHidden: {
      display: 'none'
    },
    scrollContainer: {
      overflowX: 'auto'
    }
  };
});
function MatrixGrid({
  id,
  className,
  rowDataArray,
  columnDataArray,
  commentColumnOtherOption,
  hideLabel,
  gridComponent,
  commentColumnComponent,
  isGridWhenMobile
}) {
  const gridRef = useRef(null);
  /**
   * @note This is specific to MatrixRating, logic should be moved there and favour
   * composition over configuration
   */
  /** If true "other" inputs are rendered per-row  */
  const hasCommentColumnOther = (commentColumnOtherOption === null || commentColumnOtherOption === void 0 ? void 0 : commentColumnOtherOption.type) === 'COMMENT_COLUMN' && commentColumnComponent;
  let computedRows;
  if (hasCommentColumnOther) {
    // fill rows with artificial rows for the other column options
    computedRows = rowDataArray.reduce((acc, row) => {
      return [...acc, row, {
        ...row,
        id: `${row.id}-other`,
        associatedId: row.id,
        isOtherRow: true
      }];
    }, []);
  } else {
    computedRows = rowDataArray;
  }
  const {
    gridStyles,
    columnContainerBase,
    columnContainerMobile,
    columnHeader,
    bufferHidden,
    bufferVisible,
    stripeBasic,
    stripeBasicMobile,
    stripeOther,
    stripeOtherMobile,
    gridContainer,
    scrollContainer
  } = useStyles$f();
  const columnCount = columnDataArray.length;
  const stripeOtherClass = isGridWhenMobile ? stripeOther : classNames(stripeOther, stripeOtherMobile);
  const stripeBasicClass = isGridWhenMobile ? stripeBasic : classNames(stripeBasic, stripeBasicMobile);
  const renderStripe = commentColumnOtherOption ? stripeOtherClass : stripeBasicClass;
  const bufferClass = hideLabel ? bufferHidden : bufferVisible;
  return React__default.createElement("div", {
    className: scrollContainer
  }, React__default.createElement("div", {
    id: id,
    role: "grid",
    ref: gridRef,
    className: gridContainer
  }, React__default.createElement("div", {
    role: "rowgroup",
    className: "ghead"
  }, React__default.createElement("div", {
    role: "row",
    className: classNames(columnContainerBase, {
      [columnContainerMobile]: !isGridWhenMobile
    })
  }, React__default.createElement("div", {
    role: "gridcell",
    className: bufferClass
  }), columnDataArray.map(column => {
    return React__default.createElement("div", {
      id: `${column.id}-header`,
      role: "columnheader",
      key: column.id,
      className: columnHeader
    }, React__default.createElement(RichText, {
      element: "span",
      text: column.label
    }));
  }))), React__default.createElement("div", {
    role: "rowgroup",
    className: classNames('gbody', gridStyles, renderStripe, className)
  }, computedRows.map((row, rowIndex) => !row.isOtherRow ? React__default.createElement(GridRow, {
    id: row.id,
    hideLabel: hideLabel,
    key: row.id,
    row: rowIndex,
    label: row.label,
    columnDataArray: columnDataArray,
    gridComponent: gridComponent,
    isGridWhenMobile: isGridWhenMobile
  }) : React__default.createElement("div", {
    role: "row",
    "data-other": true,
    key: row.id
  }, React__default.createElement(GridCell, {
    id: `${rowIndex}-${columnCount + 1}-cell`,
    "data-row": rowIndex,
    "data-col": columnCount + 1,
    colSpan: columnCount + 1,
    isGridWhenMobile: isGridWhenMobile
  }, commentColumnComponent === null || commentColumnComponent === void 0 ? void 0 : commentColumnComponent({
    commentColumnOtherOption,
    row,
    columnCount
  })))))));
}
const useStyles$e = createUseStyles({
  cellInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }
});
const UNSELECTED_OPTION = 'unselectedOption';
const COPY$6 = defineMessages({
  SELECT_AN_OPTION: {
    id: 'MatrixDropdown.EmptyTopNativeSelect',
    defaultMessage: 'Select an option',
    description: 'Label for screen readers when the top/default selection is empty'
  }
});
function MatrixDropdown({
  id: questionId,
  choices: rows = [],
  columnChoices: columns = [],
  choiceComment,
  onChange,
  responses: defaultResponses = [],
  disabled: _disabled,
  readOnly: _ro,
  required: _req,
  ...questionFieldProps
}) {
  const errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  const {
    options,
    sortableOptions: sortableRows,
    commentOption
  } = useQuestionChoices([...rows, choiceComment]);
  const [responseValue, setResponseValue] = useState(defaultResponses);
  /**
   * Default value by id
   * used for text-input based choices (i.e. choiceComment)
   * Matrix provides a 2D Array construct
   */
  const getDefaultValueById = id => {
    var _defaultChoice$value$;
    const defaultChoice = defaultResponses.find(c => c.id === id);
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : (_defaultChoice$value$ = defaultChoice.value[0]) === null || _defaultChoice$value$ === void 0 ? void 0 : _defaultChoice$value$.value;
  };
  const handleChange = (e, gridCell) => {
    const {
      rowId,
      colId
    } = gridCell;
    const storedValuesForGrid = responseValue.filter(r => !(r.id === rowId));
    const rowDataContainingChange = responseValue.find(r => r.id === rowId) || {
      id: rowId,
      value: []
    };
    const prevCellsForChangedRow = rowDataContainingChange.value.filter(cell => cell.id !== colId);
    const newCellData = {
      id: colId,
      value: e.target.value
    };
    // remove old data for the changed cell
    const newCellsForChangedRow = prevCellsForChangedRow.filter(cell => cell.id !== colId);
    if (newCellData.value !== UNSELECTED_OPTION) {
      newCellsForChangedRow.push(newCellData);
    }
    // add the new row if at least one cell has a value other than UNSELECTED_OPTION
    const newRowForGrid = newCellsForChangedRow.length > 0 ? [{
      ...rowDataContainingChange,
      value: newCellsForChangedRow
    }] : [];
    const responses = [...storedValuesForGrid, ...newRowForGrid];
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const handleCommentChange = e => {
    const choiceData = options.find(c => c.id === e.target.id);
    const responses = responseValue.filter(c => c.type !== 'COMMENT');
    if (choiceData && !!e.target.value) {
      const {
        id,
        type
      } = choiceData;
      const response = {
        id,
        type,
        value: e.target.value
      };
      // @note: ensure to loop the values when transforming in RespWeb
      responses.push({
        id,
        type,
        value: [response]
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * Default value for the choices
   */
  const getDefaultValue = (rowId, colId) => {
    var _defaultResponses$fin5, _defaultResponses$fin6, _defaultResponses$fin7;
    return (_defaultResponses$fin5 = defaultResponses.find(c => c.id === rowId)) === null || _defaultResponses$fin5 === void 0 ? void 0 : (_defaultResponses$fin6 = _defaultResponses$fin5.value) === null || _defaultResponses$fin6 === void 0 ? void 0 : (_defaultResponses$fin7 = _defaultResponses$fin6.find(c => c.id === colId)) === null || _defaultResponses$fin7 === void 0 ? void 0 : _defaultResponses$fin7.value;
  };
  const {
    cellInputWrapper
  } = useStyles$e();
  const selectAnOptionWithDashes = `-- ${t(COPY$6.SELECT_AN_OPTION)} --`;
  return React__default.createElement(QuestionField, {
    id: questionId,
    "data-testid": "MatrixDropdownQuestionType",
    errorId: errorId,
    ...questionFieldProps
  }, React__default.createElement(MatrixGrid, {
    id: questionId,
    columnDataArray: columns,
    rowDataArray: sortableRows,
    isGridWhenMobile: true,
    // eslint-disable-next-line react/no-unstable-nested-components
    gridComponent: gridCell => {
      const {
        colId
      } = gridCell;
      return React__default.createElement("div", {
        className: cellInputWrapper
      }, React__default.createElement(NativeSelect, {
        onChange: e => handleChange(e, gridCell),
        defaultValue: getDefaultValue(gridCell.rowId, gridCell.colId),
        "aria-labelledby": gridCell['aria-labelledby']
      }, React__default.createElement(SelectAnswerOption, {
        value: UNSELECTED_OPTION,
        label: selectAnOptionWithDashes
      }),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      columns.find(col => col.id === colId).choices.map(choice => {
        return React__default.createElement(SelectAnswerOption, {
          key: choice.id,
          id: choice.id,
          label: choice.label,
          value: choice.id
        });
      })));
    }
  }), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS
  }));
}
const useStyles$d = createUseStyles(theme => {
  var _theme$breakpoints18, _theme$breakpoints19;
  return {
    cellInputWrapperBase: ({
      checked
    }) => ({
      display: 'flex',
      width: '100%',
      border: [1, 'solid', checked ? theme.questionColor : 'transparent'],
      '&:hover': {
        border: [1, checked ? 'solid' : 'dashed', theme.questionColor]
      },
      backgroundColor: checked ? theme.input.bgColor : 'transparent',
      '&:focus-within': {
        backgroundColor: theme.input.bgColor
      },
      padding: 5,
      borderRadius: 4,
      cursor: 'pointer'
    }),
    cellInputCenterOnly: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    cellInputLeftWhenMobile: {
      justifyContent: 'center',
      alignItems: 'center',
      [`@media (max-width: ${(_theme$breakpoints18 = theme.breakpoints) === null || _theme$breakpoints18 === void 0 ? void 0 : _theme$breakpoints18.xs.max})`]: {
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
      }
    },
    labelForMobileView: ({
      checked
    }) => ({
      marginLeft: 10,
      marginBottom: 2,
      fontWeight: checked ? 'bold' : theme.questionBody.fontWeight ?? null,
      fontFamily: theme.questionBody.fontFamily ?? null,
      fontSize: theme.questionBody.fontSize ?? null
    }),
    [`@media (min-width: ${(_theme$breakpoints19 = theme.breakpoints) === null || _theme$breakpoints19 === void 0 ? void 0 : _theme$breakpoints19.sm.min})`]: {
      labelForMobileView: {
        display: 'none'
      }
    }
  };
});
function RatingInput({
  qid: questionId,
  gridCell,
  checked = false,
  isMultipleSelectionsPerRow = false,
  className,
  onChange,
  columnChoices,
  isGridWhenMobile = false,
  ...props
}) {
  var _columnChoices$find;
  const {
    rowId = '',
    colId = '',
    'aria-labelledby': ariaLabelledBy
  } = gridCell || {};
  const CheckboxOrRadio = isMultipleSelectionsPerRow ? CheckboxInput$1 : RadioInput$1;
  const inputId = `${questionId}-${rowId}-${colId}`;
  const handleInputChange = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: rowId,
      value: e.target.value,
      checked: e.target.checked
    });
  };
  const {
    cellInputWrapperBase,
    cellInputLeftWhenMobile,
    cellInputCenterOnly,
    labelForMobileView
  } = useStyles$d({
    checked
  });
  const columnLabel = ((_columnChoices$find = columnChoices.find(column => column.id === colId)) === null || _columnChoices$find === void 0 ? void 0 : _columnChoices$find.label) || '';
  return React__default.createElement("label", {
    htmlFor: inputId,
    "aria-labelledby": ariaLabelledBy,
    className: classNames(cellInputWrapperBase, {
      [cellInputCenterOnly]: isGridWhenMobile
    }, {
      [cellInputLeftWhenMobile]: !isGridWhenMobile
    })
  }, React__default.createElement(CheckboxOrRadio, {
    id: inputId,
    value: colId,
    "data-component": true,
    checked: checked,
    onChange: handleInputChange,
    className: className,
    ...props
  }), !isGridWhenMobile && React__default.createElement(RichText, {
    element: "span",
    className: labelForMobileView,
    text: columnLabel
  }));
}
const useStyles$c = createUseStyles({
  gridComponentStyle: {
    display: 'flex',
    flexShrink: 0,
    width: 20,
    height: 20
  },
  commentChoiceContainer: {
    width: '100%'
  },
  commentColumnContainer: {
    margin: '1em'
  }
});
function MatrixRating({
  id: questionId,
  isMultipleSelectionsPerRow = false,
  choices = [],
  columnChoices = [],
  choiceOther,
  hideLabel,
  choiceNoneOfTheAbove,
  required,
  requiredType,
  choiceComment,
  isForcedRanking,
  onChange,
  responses: defaultResponses = [],
  disabled: _disabled,
  readOnly: _ro,
  ...questionFieldProps
}) {
  const errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  const {
    options,
    sortableOptions,
    commentOption,
    commentColumnOption,
    columnOptions
  } = useQuestionChoices([...choices, choiceNoneOfTheAbove ? {
    ...choiceNoneOfTheAbove,
    type: 'NOTA'
  } : undefined, choiceOther, choiceComment], [...columnChoices, choiceNoneOfTheAbove ? {
    ...choiceNoneOfTheAbove,
    type: 'NOTA'
  } : undefined]);
  const [responseValue, setResponseValue] = useState(defaultResponses);
  /**
   * Default value by id
   * used for text-input based choices (i.e. choiceComment)
   * Matrix provides a 2D Array construct
   */
  const getDefaultValueById = id => {
    var _defaultChoice$value$2;
    const defaultChoice = defaultResponses.find(c => c.id === id);
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : (_defaultChoice$value$2 = defaultChoice.value[0]) === null || _defaultChoice$value$2 === void 0 ? void 0 : _defaultChoice$value$2.value;
  };
  const isChecked = (rowId, colId) => {
    return !!responseValue.find(r => r.id === rowId && r.value.find(c => c.id === colId));
  };
  const unCheckOption = unSelectOptionID => {
    if (required && requiredType === 'ALL') {
      return;
    }
    const result = responseValue.filter(option => {
      return option.id !== unSelectOptionID;
    });
    setResponseValue(result);
    onChange === null || onChange === void 0 ? void 0 : onChange(result);
  };
  const handleClick = (e, gridCell) => {
    const input = e.target;
    const checkedOption = responseValue.find(option => option.id === gridCell.rowId && option.value[0].id === gridCell.colId);
    if (input.checked && !!checkedOption) {
      e.preventDefault();
      unCheckOption(checkedOption.id);
    }
  };
  const handleKeyboard = (e, gridCell) => {
    const checkedOption = responseValue.find(option => option.id === gridCell.rowId && option.value[0].id === gridCell.colId);
    if (checkedOption && e.code === 'Space') {
      e.preventDefault();
      unCheckOption(checkedOption.id);
    }
  };
  const handleChange = (e, gridCell) => {
    const {
      id: rowId,
      value: colId,
      checked
    } = e;
    const isNa = gridCell.colIndex > columnChoices.length - 1;
    const type = isNa ? 'NOTA' : undefined;
    const prevRows = responseValue.filter(r => r.id !== rowId);
    const currentRow = !isNa && responseValue.find(r => r.id === rowId && r.type !== 'NOTA') || {
      id: rowId,
      value: [],
      type
    };
    const currentCols = isMultipleSelectionsPerRow ? currentRow.value.filter(c => c.value !== colId) : [];
    if (checked) {
      currentCols.push({
        id: colId,
        value: colId
      });
    }
    const newRows = currentCols.length ? [{
      ...currentRow,
      value: currentCols
    }] : [];
    if (isForcedRanking) {
      const filteredRows = prevRows.find(r => r.value[0].value === currentCols[0].value);
      if (filteredRows && !isNa) {
        const found = prevRows.indexOf(filteredRows);
        prevRows.splice(found, 1);
      }
    }
    const rows = [...prevRows, ...newRows];
    const responses = rows;
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const handleCommentChange = e => {
    const choiceData = options.find(c => c.id === e.target.id);
    const responses = responseValue.filter(c => c.type !== 'COMMENT');
    if (choiceData && !!e.target.value) {
      const {
        id,
        type
      } = choiceData;
      const response = {
        id,
        type,
        value: e.target.value
      };
      // @note: ensure to loop the values when transforming in RespWeb
      responses.push({
        id,
        type,
        value: [response]
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const handleCommentColumnChange = (e, associatedRowId) => {
    if (!commentColumnOption) {
      return; // mainly here for type-safety
    }

    const currentRowData = responseValue.find(({
      id
    }) => id === associatedRowId);
    const allButNewValue = (currentRowData === null || currentRowData === void 0 ? void 0 : currentRowData.value.filter(({
      id
    }) => id !== commentColumnOption.id)) ?? [];
    const isDelete = !e.target.value && !!currentRowData && allButNewValue.length < (currentRowData === null || currentRowData === void 0 ? void 0 : currentRowData.value.length);
    const newValue = isDelete ? allButNewValue : [...allButNewValue, {
      id: commentColumnOption.id,
      value: e.target.value,
      type: 'COMMENT_COLUMN'
    }];
    const responses = responseValue.filter(({
      id
    }) => id !== associatedRowId);
    if (newValue.length > 0) {
      responses.push({
        id: associatedRowId,
        value: newValue
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const {
    gridComponentStyle,
    commentChoiceContainer,
    commentColumnContainer
  } = useStyles$c();
  return React__default.createElement(QuestionField, {
    id: questionId,
    "data-testid": "MatrixRatingQuestionType",
    errorId: errorId,
    ...questionFieldProps
  }, React__default.createElement(MatrixGrid, {
    id: questionId,
    hideLabel: hideLabel,
    columnDataArray: columnOptions,
    rowDataArray: sortableOptions,
    isGridWhenMobile: isForcedRanking,
    // eslint-disable-next-line react/no-unstable-nested-components
    gridComponent: gridCell => React__default.createElement(RatingInput, {
      qid: questionId,
      gridCell: gridCell,
      isMultipleSelectionsPerRow: isMultipleSelectionsPerRow,
      checked: isChecked(gridCell.rowId, gridCell.colId),
      onChange: e => handleChange(e, gridCell),
      name: isMultipleSelectionsPerRow ? undefined : `${gridCell.rowId}-group`,
      onClick: isMultipleSelectionsPerRow ? undefined : e => handleClick(e, gridCell),
      onKeyDown: isMultipleSelectionsPerRow ? undefined : e => handleKeyboard(e, gridCell),
      className: gridComponentStyle,
      isGridWhenMobile: isForcedRanking,
      columnChoices: columnOptions
    }),
    commentColumnOtherOption: commentColumnOption,
    commentColumnComponent: commentColumnOption ?
    // eslint-disable-next-line react/no-unstable-nested-components
    commentProps => React__default.createElement(CommentChoice, {
      id: `${commentProps.row.id}-comment`,
      label: commentColumnOption === null || commentColumnOption === void 0 ? void 0 : commentColumnOption.label,
      onChange: e => commentProps.row.associatedId && handleCommentColumnChange(e, commentProps.row.associatedId),
      lineCount: commentColumnOption.linesCount,
      charCount: commentColumnOption.charsCount,
      maxLength: TEXT_INPUT_MAX_CHARS,
      className: commentColumnContainer,
      "aria-labelledby": `${commentProps.row.associatedId}-header ${commentProps.row.id}-comment-label`
    }) : undefined
  }), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    className: commentChoiceContainer
  }));
}
const useStyles$b = createUseStyles(theme => {
  const breakpointSmMin = `@media screen and (max-width: ${theme.breakpoints.sm.min})`;
  const {
    bgColor: listItemBackground,
    activeColor: listItemBorderActive
  } = theme.input;
  const flexStart = 'flex-start';
  const lineHeight = 1.25;
  const controlsPadding = 6;
  const controlsFontSize = 'inherit';
  // helps align label-first-line to controls center
  const labelOffset = Math.floor(controlsPadding / lineHeight);
  return {
    listItem: {
      position: 'relative',
      userSelect: 'none',
      lineHeight: 0,
      outline: 'none',
      zIndex: ({
        ghost
      }) => ghost ? 5 : 'auto',
      '&:active, &:focus, &:focus-within': {
        zIndex: 5
      },
      '&:active $content, &:focus-within $content': {
        outlineWidth: 1,
        outlineStyle: ({
          ghost
        }) => ghost ? 'dashed' : 'solid',
        outlineColor: listItemBorderActive
      },
      '&:active $content, &:focus $content': {
        outlineWidth: 3,
        outlineStyle: ({
          ghost
        }) => ghost ? 'dashed' : 'solid',
        outlineColor: listItemBorderActive
      }
    },
    rankItemContainer: {
      display: 'flex',
      fontSize: theme.questionBody.fontSize,
      lineHeight,
      color: theme.questionBody.color
    },
    orderIndex: {
      padding: '16px 5px 10px 5px',
      visibility: ({
        ranksVisible
      }) => ranksVisible ? 'visible' : 'hidden',
      minWidth: '45px',
      display: 'flex'
    },
    content: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: flexStart,
      alignItems: flexStart,
      gap: 10,
      flex: '1 auto',
      borderWidth: 1,
      borderRadius: 4,
      borderStyle: 'solid',
      borderColor: 'transparent',
      background: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)',
      padding: 10,
      cursor: 'move',
      [breakpointSmMin]: {
        flexWrap: 'wrap'
      }
    },
    dragHandle: {
      outline: 'none',
      visibility: ({
        ghost
      }) => ghost ? 'hidden' : 'visible',
      fontSize: controlsFontSize,
      lineHeight: 0,
      padding: controlsPadding,
      touchAction: 'none',
      '&::after': {
        content: "''",
        position: 'absolute',
        display: 'block',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    },
    label: {
      visibility: ({
        ghost
      }) => ghost ? 'hidden' : 'visible',
      display: 'flex',
      justifyContent: flexStart,
      alignItems: flexStart,
      flex: '1 auto',
      paddingTop: labelOffset,
      '& iframe': {
        position: 'relative'
      },
      overflowWrap: 'anywhere',
      [breakpointSmMin]: {
        order: 3,
        paddingLeft: '6px',
        width: '100%'
      }
    },
    controls: {
      visibility: ({
        ghost
      }) => ghost ? 'hidden' : 'visible',
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-around',
      gap: 10,
      fontSize: controlsFontSize,
      [breakpointSmMin]: {
        order: 2,
        flex: '1 1 auto',
        justifyContent: 'flex-end'
      }
    }
  };
});
function RankingRow({
  className,
  dragListeners,
  dragRef,
  ghost,
  id,
  position,
  label,
  controls,
  onFocus,
  ranksVisible = true,
  ...props
}, ref) {
  const {
    listItem,
    rankItemContainer,
    orderIndex,
    content: contentContainer,
    dragHandle: dragHandleContainer,
    label: labelContainer,
    controls: controlsContainer
  } = useStyles$b({
    ghost,
    ranksVisible
  });
  const labelId = `${id}-label`;
  const index = position ?? -1;
  const indexLabel = index >= 0 ? index + 1 : '';
  return React__default.createElement("li", {
    id: id,
    className: classNames('rankItem', listItem, className),
    ref: ref,
    ...props
  }, React__default.createElement("div", {
    className: rankItemContainer
  }, React__default.createElement("span", {
    className: classNames('OrderIndex', orderIndex),
    "data-testid": "RankingRow__OrderIndex",
    "aria-hidden": true
  }, indexLabel), React__default.createElement("div", {
    className: classNames('rankItem__content', contentContainer)
  }, React__default.createElement("div", {
    "data-testid": "RankingRow__DragHandle",
    className: classNames('rankItem__dragHandle', dragHandleContainer),
    onFocus: onFocus,
    "data-pos": index,
    ref: dragRef,
    ...dragListeners
  }, React__default.createElement(DragHandleIcon$1, {
    className: "rankItem__dragHandleIcon"
  })), React__default.createElement("div", {
    "data-testid": "RankingRow__Label",
    className: classNames('rankItem__label', labelContainer)
  }, React__default.createElement(RichText, {
    id: labelId,
    element: "div",
    className: "rankItem__richText",
    translate: "no",
    text: label
  })), React__default.createElement("div", {
    "data-no-dnd": "true",
    "data-testid": "RankingRow__Controls",
    className: classNames('rankItem__controls', controlsContainer)
  }, controls))));
}
var RankingRow$1 = forwardRef(RankingRow);

/**
 * OrderButton
 *
 * @todo: replace instances with reusable `Button` component that satisfies
 * all scenarios, variants and themes.
 */
const useStyles$a = createUseStyles(theme => ({
  orderButton: {
    color: '#000',
    backgroundColor: '#fff',
    fontSize: 'inherit',
    border: [1, 'solid', '#000'],
    borderRadius: 4,
    padding: [6, 6],
    maxWidth: '100%',
    cursor: 'pointer',
    lineHeight: 0,
    outlineColor: theme.primaryAccentColor,
    '&[aria-disabled]': {
      backgroundColor: 'rgba(255,255,255,.5)',
      borderColor: 'rgba(0,0,0,.5)',
      pointerEvents: 'none',
      cursor: 'default'
    },
    '&[aria-disabled] > svg': {
      opacity: 0.5,
      cursor: 'default'
    },
    '&:focus, &:focus-visible': {
      borderColor: theme.primaryAccentColor,
      outline: `2px solid ${theme.primaryAccentColor}`
    }
  },
  '@media (hover: hover) and (pointer: fine)': {
    orderButton: {
      '&:hover': {
        borderColor: theme.primaryAccentColor,
        outline: `2px solid ${theme.primaryAccentColor}`
      }
    }
  },
  srOnly: visuallyHidden
}));
function OrderButton({
  icon,
  children: label,
  className,
  disabled,
  ...props
}) {
  const {
    orderButton,
    srOnly
  } = useStyles$a();
  return React__default.createElement("button", {
    type: "button",
    "aria-disabled": disabled || undefined,
    className: classNames('order-button', orderButton, className),
    ...props
  }, icon, React__default.createElement("span", {
    className: srOnly
  }, label));
}
const useStyles$9 = createUseStyles({
  controlsContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-around',
    gap: 10
  },
  applicableControl: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  }
});
const COPY$5 = defineMessages({
  RANK_NA: {
    id: 'OrderControl.NA',
    defaultMessage: 'N/A',
    description: '[Type: label][Vis: high] - not applicable label'
  },
  ARIA_RANK_NA: {
    id: 'OrderControl.AriaNA',
    defaultMessage: 'Not Applicable',
    description: '[Type: label][Vis: high] - accessible not applicable label'
  }
});
const RANK_DIRECTION_BACKWARD = -1;
const RANK_DIRECTION_FORWARD = 1;
function OrderControl({
  id,
  labels,
  position,
  showApplicability = true,
  applicable: defaultApplicable = true,
  className,
  onApplicableChange,
  onOrderUp,
  onOrderDown,
  disableOrderUp = false,
  disableOrderDown = false,
  ...props
}) {
  const [applicable, setApplicable] = useState(defaultApplicable);
  const currentIndex = position ?? -1;
  const handleOrderUp = _e => {
    onOrderUp === null || onOrderUp === void 0 ? void 0 : onOrderUp({
      id,
      value: currentIndex,
      direction: RANK_DIRECTION_BACKWARD
    });
  };
  const handleOrderDown = _e => {
    onOrderDown === null || onOrderDown === void 0 ? void 0 : onOrderDown({
      id,
      value: currentIndex,
      direction: RANK_DIRECTION_FORWARD
    });
  };
  const handleApplicableChange = e => {
    const isApplicable = !e.target.checked;
    onApplicableChange === null || onApplicableChange === void 0 ? void 0 : onApplicableChange({
      id,
      applicable: isApplicable
    });
    setApplicable(isApplicable);
  };
  const applicableId = `${id}-applicable`;
  const {
    controlsContainer,
    applicableControl
  } = useStyles$9();
  return React__default.createElement("div", {
    id: id,
    className: classNames(controlsContainer, className),
    ...props
  }, React__default.createElement(OrderButton, {
    disabled: disableOrderUp || !applicable,
    onClick: handleOrderUp,
    icon: React__default.createElement(CaretUpOutlineIcon, null)
  }, labels.orderUpLabel), React__default.createElement(OrderButton, {
    disabled: disableOrderDown || !applicable,
    onClick: handleOrderDown,
    icon: React__default.createElement(CaretDownOutlineIcon, null)
  }, labels.orderDownLabel), showApplicability && React__default.createElement("label", {
    className: classNames('order-na', applicableControl),
    htmlFor: applicableId,
    "aria-label": t(COPY$5.ARIA_RANK_NA)
  }, React__default.createElement(CheckboxInput$1, {
    id: applicableId,
    checked: !applicable,
    onChange: handleApplicableChange
  }), React__default.createElement(T, {
    desc: COPY$5.RANK_NA
  })));
}
const useStyles$8 = createUseStyles({
  item: {},
  itemDisabled: {
    '& .rankItem__dragHandle::after': {
      cursor: 'default'
    },
    '& .rankItem__dragHandle, & .rankItem__label': {
      opacity: 0.5
    }
  }
});
const COPY$4 = defineMessages({
  ARIA_RANK_MOVE_UP: {
    id: 'RankingItem.AriaRankMoveUp',
    defaultMessage: 'Move up {label}',
    description: '[Type: button][Vis: high] - accessible rank move up label'
  },
  ARIA_RANK_MOVE_DOWN: {
    id: 'RankingItem.AriaRankMoveDown',
    defaultMessage: 'Move down {label}',
    description: '[Type: button][Vis: high] - accessible rank move down label'
  }
});
function RankingItem({
  id,
  className,
  label,
  position: index,
  listLength,
  applicable,
  showApplicability,
  onApplicableChange,
  onOrderUp,
  onOrderDown,
  ranksVisible,
  ...props
}) {
  const textOnlyLabel = stripHTML(label);
  const controlLabels = {
    orderUpLabel: t(COPY$4.ARIA_RANK_MOVE_UP, {
      label: textOnlyLabel
    }),
    orderDownLabel: t(COPY$4.ARIA_RANK_MOVE_DOWN, {
      label: textOnlyLabel
    })
  };
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    setActivatorNodeRef
  } = useSortable({
    id,
    /*
     * role=listitem is forced to override DnD-kits use of role=button.
     * This re-instates proper a11y announcements of the role
     */
    attributes: {
      role: 'listitem',
      tabIndex: -1
    },
    disabled: !applicable,
    data: {
      id,
      position: index,
      label,
      applicable,
      showApplicability
    }
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };
  const handleOrderUp = e => {
    onOrderUp === null || onOrderUp === void 0 ? void 0 : onOrderUp({
      ...e,
      id
    });
  };
  const handleOrderDown = e => {
    onOrderDown === null || onOrderDown === void 0 ? void 0 : onOrderDown({
      ...e,
      id
    });
  };
  const handleApplicableChange = e => {
    onApplicableChange === null || onApplicableChange === void 0 ? void 0 : onApplicableChange({
      ...e,
      id
    });
  };
  const {
    item,
    itemDisabled
  } = useStyles$8({
    applicable
  });
  return React__default.createElement(RankingRow$1, {
    id: id,
    label: label,
    position: index,
    className: classNames(item, {
      [itemDisabled]: !applicable
    }, className),
    ref: setNodeRef,
    style: style,
    ghost: isDragging,
    ...attributes,
    dragListeners: listeners,
    dragRef: setActivatorNodeRef,
    ranksVisible: ranksVisible,
    controls: React__default.createElement(OrderControl, {
      id: `${id}-control`,
      position: index,
      applicable: applicable,
      showApplicability: !!showApplicability,
      onApplicableChange: handleApplicableChange,
      onOrderUp: handleOrderUp,
      onOrderDown: handleOrderDown,
      labels: controlLabels,
      disableOrderUp: index === 0,
      disableOrderDown: index === listLength - 1
    }),
    ...props
  });
}
const useRankingIds = ({
  rankings,
  choiceNotApplicable
}) => {
  return useMemo(() => {
    const order = rankings.filter(r => !!r && r.visible).sort((a, b) => Number(a.label) - Number(b.label)).map(r => r.id);
    if (choiceNotApplicable) {
      order.push(choiceNotApplicable.id);
    }
    return order;
  }, [rankings, choiceNotApplicable]);
};
const useRankingState = ({
  choices,
  rankingIds,
  defaultResponses = [],
  choiceNotApplicable
}) => {
  const findResponseByChoiceId = id => defaultResponses.find(r => r.id === id);
  const findPositionByRankId = id => rankingIds.findIndex(rid => rid === id);
  return useState(() => {
    // Filter choices that exist and are visible, add rankable meta data
    return choices.filter(c => !!c && c.visible).map(({
      id,
      label
    }, defaultIndex) => {
      const {
        value: rankId = rankingIds[defaultIndex],
        type
      } = findResponseByChoiceId(id) || {};
      const item = {
        id,
        label,
        type,
        value: rankId,
        applicable: rankId !== (choiceNotApplicable === null || choiceNotApplicable === void 0 ? void 0 : choiceNotApplicable.id),
        index: findPositionByRankId(rankId)
      };
      return item;
    }).sort((a, b) => a.index - b.index);
  });
};

/* istanbul ignore file */
function shouldHandleEvent(element) {
  let cur = element;
  while (cur) {
    if (cur.dataset && cur.dataset.noDnd) {
      return false;
    }
    cur = cur.parentElement;
  }
  return true;
}
const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter]
};
class PointerSensor extends PointerSensor$1 {}
PointerSensor.activators = [{
  eventName: 'onPointerDown',
  handler: ({
    nativeEvent: event
  }, {
    onActivation
  }) => {
    if (!shouldHandleEvent(event.target)) {
      return false;
    }
    onActivation === null || onActivation === void 0 ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
class KeyboardSensor extends KeyboardSensor$1 {}
KeyboardSensor.activators = [{
  eventName: 'onKeyDown',
  handler: ({
    nativeEvent: event
  }, {
    keyboardCodes = defaultKeyboardCodes,
    onActivation
  }, {
    active
  }) => {
    const {
      code
    } = event;
    if (keyboardCodes.start.includes(code)) {
      const activator = active.activatorNode.current;
      if (activator && event.target !== activator || !shouldHandleEvent(event.target)) {
        return false;
      }
      event.preventDefault();
      onActivation === null || onActivation === void 0 ? void 0 : onActivation({
        event
      });
      return true;
    }
    return false;
  }
}];
const useStyles$7 = createUseStyles({
  list: {
    '& > *': {
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none'
    }
  },
  listItem: {
    marginBottom: 10
  },
  dragOverlay: {
    opacity: 0.5,
    '& .rankItem__orderIndex, & .rankItem__controls': {
      opacity: 0
    }
  },
  srOnly: {
    ...visuallyHidden
  }
});
const COPY$3 = defineMessages({
  ARIA_RANK_MOVED_UP: {
    id: 'Ranking.AriaRankMovedUp',
    defaultMessage: '{label} moved up to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved up label'
  },
  ARIA_RANK_MOVED_DOWN: {
    id: 'Ranking.AriaRankMovedDown',
    defaultMessage: '{label} moved down to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved down label'
  },
  ARIA_RANK_MOVED_TO_TOP: {
    id: 'Ranking.AriaRankAtTop',
    defaultMessage: '{label} moved to the top of the list',
    description: '[Type: button][Vis: high] - accessible ranking at top of list'
  },
  ARIA_RANK_MOVED_TO_BOTTOM: {
    id: 'Ranking.AriaRankAtBottom',
    defaultMessage: '{label} moved to the bottom of the list',
    description: '[Type: button][Vis: high] - accessible ranking at bottom of list'
  }
});
/** Turn off a11y announcements for Drag and Drop in the DnDContext - this is handled by the order buttons */
const emptyStringNoop = () => '';
const dndAnnouncements = {
  onDragStart: emptyStringNoop,
  onDragMove: emptyStringNoop,
  onDragOver: emptyStringNoop,
  onDragEnd: emptyStringNoop,
  onDragCancel: emptyStringNoop
};
const dndAccessibility = {
  announcements: dndAnnouncements,
  screenReaderInstructions: {
    draggable: ''
  }
};
function Ranking({
  id: questionId,
  disabled: _dis,
  readOnly: _ro,
  choices = /* istanbul ignore next: cannot reach default branch */[],
  rankings = /* istanbul ignore next: cannot reach default branch */[],
  choiceNotApplicable,
  responses: defaultResponses = [],
  onChange,
  hideRanks = false,
  ...fieldProps
}) {
  var _activeItem$data$curr, _activeItem$data$curr2;
  /**
   * @author <Keisha Mukasa>[kmukasa@surveymonkey.com]
   * @description The id has been modified to work in __hybrid__ mode. The `id` needs to
   * be different from the question-field `id` normally created/used.
   * @see https://code.corp.surveymonkey.com/webplatform/smquestions/pull/1204
   * @todo remove prefix 'hybrid-' when no longer required
   */
  const fieldId = `hybrid-${questionId}`;
  /**
   * @description `createLegendId` is used internally by [QuestionFieldLayoutTemplate](https://code.corp.surveymonkey.com/webplatform/smquestions/blob/master/packages/question-ui/src/capabilities/respondent-survey/components/QuestionFieldLayoutTemplate/QuestionFieldLayoutTemplate.tsx#L157)
   * to create an id.  This `id` cannot be passed down via props.  It is recreated here for `ARIA` referencing.
   */
  const questionTitleId = createLegendId(fieldId);
  const errorId = createErrorId(questionId);
  const sensors = useSensors(useSensor(PointerSensor));
  // toggles display of N/A choice
  const showApplicability = choiceNotApplicable !== undefined;
  // create ranking order (N/A choice is last)
  const rankingIds = useRankingIds({
    rankings,
    choiceNotApplicable
  });
  const [, setActiveId] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  // for Aria-Live
  const [statusMessage, announceStatus] = useState('');
  const setAnnoucement = str => {
    setTimeout(() => announceStatus(''), 5000);
    announceStatus(str);
  };
  const [ranksVisible, setRanksVisible] = useState(hideRanks);
  const [listItems, setListItems] = useRankingState({
    choices,
    defaultResponses,
    choiceNotApplicable,
    rankingIds
  });
  /* istanbul ignore next */
  const getItemIndices = (items, fromId, toId) => {
    const fromIndex = items.findIndex(item => item.id === fromId);
    const toIndex = items.findIndex(item => item.id === toId);
    return {
      fromIndex,
      toIndex
    };
  };
  /* istanbul ignore next */
  const moveById = (items, fromId, toId) => {
    const {
      fromIndex,
      toIndex
    } = getItemIndices(items, fromId, toId);
    return arrayMove(items, fromIndex, toIndex);
  };
  /* istanbul ignore next: cannot test drag-and-drop logic */
  const moveItem = (fromId, toId) => {
    setListItems(items => moveById(items, fromId, toId));
  };
  const {
    list,
    listItem,
    dragOverlay,
    srOnly
  } = useStyles$7();
  const orderedListProps = {
    /**
     * role is forced for a11y, so SR's will announce properly,
     * this is somehow lost or manipulated, possibly, by DnD-Kit
     */
    role: 'list',
    className: list,
    'aria-labelledby': questionTitleId
  };
  const updateRankingOrder = (current, next) => {
    const nextValue = Math.max(0, Math.min(next, listItems.length - 1));
    const responses = arrayMove(listItems, current, nextValue).map((response, index) => ({
      ...response,
      index,
      value: rankingIds[index]
    }));
    setRanksVisible(true);
    setListItems(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const announcePosition = (current, next, label) => {
    const nextPos = Math.max(0, Math.min(next, listItems.length - 1));
    if (current === nextPos) return; // no change in position
    const position = nextPos + 1; // announce non-zero base number
    let message = COPY$3.ARIA_RANK_MOVED_DOWN;
    if (nextPos <= 0) {
      // moved to top
      message = COPY$3.ARIA_RANK_MOVED_TO_TOP;
    } else if (nextPos < current) {
      // moved up
      message = COPY$3.ARIA_RANK_MOVED_UP;
    } else if (nextPos >= listItems.length - 1) {
      // moved to bottom
      message = COPY$3.ARIA_RANK_MOVED_TO_BOTTOM;
    }
    setAnnoucement(t(message, {
      label: stripHTML(label),
      position
    }));
  };
  const handleOrderUp = e => {
    const {
      id: rowId,
      value: currentPosition,
      direction = /* istanbul ignore next: cannot reach default branch */0
    } = e;
    const item = listItems.find(li => li.id === rowId);
    const nextPosition = currentPosition + direction;
    updateRankingOrder(currentPosition, nextPosition);
    announcePosition(currentPosition, nextPosition, item.label);
  };
  const handleOrderDown = e => {
    const {
      id: rowId,
      value: currentPosition,
      direction = /* istanbul ignore next: cannot reach default branch */0
    } = e;
    const item = listItems.find(li => li.id === rowId);
    const nextPosition = currentPosition + direction;
    updateRankingOrder(currentPosition, nextPosition);
    announcePosition(currentPosition, nextPosition, item.label);
  };
  const handleApplicableChange = e => {
    /* istanbul ignore else: should never branch */
    if (showApplicability) {
      const {
        id,
        applicable
      } = e;
      const responses = listItems.map(item => ({
        ...item,
        ...(item.id === id ? {
          applicable
        } : {}),
        ...(item.id === id && !applicable ? {
          value: choiceNotApplicable.id
        } : {})
      }));
      setListItems(responses);
      onChange === null || onChange === void 0 ? void 0 : onChange(responses);
    }
  };
  /* istanbul ignore next: cannot test drag-and-drop logic */
  const handleDragStart = ({
    active
  }) => {
    setActiveId(active.id);
    setActiveItem(active);
  };
  /* istanbul ignore next: cannot test drag-and-drop logic */
  const handleDragEnd = ({
    active,
    over
  }) => {
    if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
      moveItem(active.id, over === null || over === void 0 ? void 0 : over.id);
    }
    setRanksVisible(true);
    setActiveId(null);
    setActiveItem(null);
  };
  return React__default.createElement(QuestionField, {
    id: `hybrid-${questionId}`,
    errorId: errorId,
    "data-testid": "RankingQuestionType",
    ...fieldProps
  }, React__default.createElement("div", {
    role: "status",
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: srOnly
  }, statusMessage), React__default.createElement(DndContext, {
    sensors: sensors,
    collisionDetection: closestCenter,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    accessibility: dndAccessibility
  }, React__default.createElement(SortableContext, {
    items: listItems,
    strategy: verticalListSortingStrategy
  }, React__default.createElement("ol", {
    ...orderedListProps
  }, listItems.map(({
    id: itemId,
    label,
    applicable
  }, index) => {
    return React__default.createElement(RankingItem, {
      id: itemId,
      key: itemId,
      label: label,
      position: index,
      listLength: listItems.length,
      applicable: applicable,
      showApplicability: !!showApplicability,
      onApplicableChange: handleApplicableChange,
      onOrderUp: handleOrderUp,
      onOrderDown: handleOrderDown,
      className: listItem,
      ranksVisible: ranksVisible
    });
  })), React__default.createElement(DragOverlay, null, /* istanbul ignore next: cannot test drag-and-drop logic */activeItem ? React__default.createElement(RankingRow$1, {
    id: activeItem.id,
    className: dragOverlay,
    label: (_activeItem$data$curr = activeItem.data.current) === null || _activeItem$data$curr === void 0 ? void 0 : _activeItem$data$curr.label,
    position: (_activeItem$data$curr2 = activeItem.data.current) === null || _activeItem$data$curr2 === void 0 ? void 0 : _activeItem$data$curr2.index,
    ranksVisible: ranksVisible
  }) : null))));
}
function SingleTextbox({
  id: questionId,
  required: _req,
  disabled,
  readOnly,
  responses: defaultResponses = [],
  onChange,
  size,
  ...fieldProps
}) {
  const {
    error,
    errorId = createErrorId(questionId),
    title: {
      id: titleId
    }
  } = fieldProps;
  const defaultValue = useMemo(() => {
    var _defaultResponses$fin8;
    return ((_defaultResponses$fin8 = defaultResponses.find(r => !!r.value)) === null || _defaultResponses$fin8 === void 0 ? void 0 : _defaultResponses$fin8.value) ?? '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const handleChange = e => {
    const responses = e.target.value ? [{
      id: questionId,
      value: e.target.value
    }] : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  return React__default.createElement("div", null, React__default.createElement(QuestionField, {
    id: questionId,
    errorId: errorId,
    "data-testid": "SingleTextboxQuestionType",
    ...fieldProps
  }, React__default.createElement(TextInput$1, {
    name: questionId,
    defaultValue: defaultValue,
    disabled: disabled,
    readOnly: readOnly,
    size: size,
    onChange: handleChange,
    "aria-invalid": !!error,
    "aria-describedby": error && errorId,
    "aria-labelledby": titleId,
    maxLength: TEXT_INPUT_MAX_CHARS
  })));
}
var SingleTextbox$1 = withErrorBoundary(SingleTextbox);
const useStyles$6 = createUseStyles(theme => {
  return {
    textPresentationalStyles: {
      fontFamily: theme.questionTitle.fontFamily ?? 'inherit',
      fontSize: theme.questionTitle.fontSize ?? '16px',
      fontWeight: theme.questionTitle.fontWeight ?? (theme.isAccessible ? 500 : 300),
      textDecoration: theme.questionTitle.textDecoration ?? 'inherit',
      fontStyle: theme.questionTitle.fontStyle ?? 'inherit',
      color: theme.questionTitle.color ?? 'inherit'
    },
    buttonStyles: {
      marginTop: '20px'
    }
  };
});
function TextPresentational({
  text,
  padding = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  id,
  okButton = {
    visible: false
  }
}) {
  const richTextId = `text-presentational-${id}`;
  const {
    textPresentationalStyles,
    buttonStyles
  } = useStyles$6();
  const {
    visible: showButton,
    ...buttonProps
  } = okButton;
  return React__default.createElement(QuestionSpacing, {
    padding: padding,
    "data-testid": "TextPresentational"
  }, React__default.createElement(RichText, {
    id: richTextId,
    element: "div",
    text: text,
    className: textPresentationalStyles
  }), showButton && React__default.createElement(Button, {
    ...buttonProps,
    className: buttonStyles
  }));
}
var TextPresentational$1 = withErrorBoundary(TextPresentational);
const useStyles$5 = createUseStyles(theme => {
  return {
    clearableTextInputContainer: {
      display: 'flex',
      position: 'relative',
      '&:hover $textInput': {
        outline: `2px solid ${theme.primaryAccentColor}`
      }
    },
    textInput: ({
      isRTL,
      maxLength
    }) => ({
      width: `calc(${maxLength + 1}ch + 25px)`,
      height: 30,
      fontSize: 16,
      textAlign: isRTL ? 'right' : 'left',
      borderRadius: 3,
      padding: isRTL ? [0, 10, 0, 25] : [0, 25, 0, 10],
      margin: [10, 0, 0, 5]
    }),
    clearButton: ({
      isRTL
    }) => ({
      position: 'absolute',
      right: isRTL ? 'auto' : 5,
      left: isRTL ? 10 : 'auto',
      top: 15,
      backgroundColor: theme.secondaryAccentColor,
      borderRadius: 20,
      border: 'none',
      color: theme.primaryAccentColor,
      cursor: 'pointer',
      height: 20,
      width: 20,
      '&:hover': {
        color: theme.secondaryAccentColor,
        backgroundColor: theme.primaryAccentColor
      }
    }),
    clearButtonIcon: {
      width: 'inherit',
      height: 'inherit'
    },
    visuallyHidden
  };
});
function ClearableTextInput({
  id,
  className,
  value = '',
  onClear,
  clearVisible,
  clearButtonLabelText,
  maxLength = 8,
  ...props
}) {
  const {
    isRTL
  } = useContext(L10NContext);
  const {
    clearableTextInputContainer,
    textInput,
    clearButton,
    clearButtonIcon,
    visuallyHidden
  } = useStyles$5({
    isRTL,
    maxLength
  });
  const textBoxRef = useRef(null);
  const clearButtonClick = () => {
    var _textBoxRef$current;
    onClear === null || onClear === void 0 ? void 0 : onClear();
    (_textBoxRef$current = textBoxRef.current) === null || _textBoxRef$current === void 0 ? void 0 : _textBoxRef$current.focus();
  };
  return React__default.createElement("div", {
    className: classNames(clearableTextInputContainer, className)
  }, React__default.createElement(TextInput$1, {
    id: id,
    className: classNames(textInput),
    maxLength: maxLength,
    size: maxLength,
    ref: textBoxRef,
    value: value,
    ...props
  }), clearVisible && React__default.createElement("button", {
    type: "button",
    tabIndex: -1,
    onClick: clearButtonClick,
    className: clearButton
  }, React__default.createElement(CloseOutlineIcon$1, {
    className: clearButtonIcon
  }), React__default.createElement("span", {
    className: visuallyHidden
  }, clearButtonLabelText)));
}
const useStyles$4 = createUseStyles(theme => {
  const fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    slider: {
      '-webkit-appearance': 'none',
      appearance: 'none',
      background: 'transparent',
      cursor: 'pointer',
      width: '100%',
      '&:focus': {
        outline: 'none',
        // Chrome, Safari, Opera, Edge focus style
        '&::-webkit-slider-thumb': {
          border: ['1px', 'solid', theme.answerColor],
          outline: [3, 'solid', theme.answerColor],
          outlineOffset: '0.2rem'
        },
        // Firefox focus style
        '&::-moz-range-thumb': {
          border: ['1px', 'solid', theme.answerColor],
          outline: [3, 'solid', theme.answerColor],
          outlineOffset: '0.2rem'
        }
      },
      // Chrome, Safari, Opera and Edge Chromium styles
      // slider track
      '&::-webkit-slider-runnable-track': {
        backgroundColor: '#ddd',
        border: [1, 'solid', theme.answerColor],
        borderRadius: '0.5rem',
        height: '0.75rem'
      },
      // slider thumb
      '&::-webkit-slider-thumb': {
        '-webkit-appearance': 'none',
        appearance: 'none',
        marginTop: '-6px',
        borderRadius: '3rem',
        border: ['1px', 'solid', theme.answerColor],
        backgroundColor: theme.primaryAccentColor,
        height: '1.5rem',
        width: '1.5rem'
      },
      // Firefox styles
      // slider track
      '&::-moz-range-track': {
        backgroundColor: '#ddd',
        border: [1, 'solid', theme.answerColor],
        borderRadius: '0.5rem',
        height: '0.75rem'
      },
      // slider thumb
      '&::-moz-range-thumb': {
        borderRadius: '3rem',
        border: [1, 'solid', theme.answerColor],
        backgroundColor: theme.primaryAccentColor,
        height: '1.25rem',
        width: '1.25rem'
      }
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: 10
    },
    labelItem: {
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: '14px !important',
      fontWeight: theme.questionBody.fontWeight
    },
    container: {
      display: 'flex',
      gap: '0 25px',
      flexFlow: 'row wrap',
      justifyContent: 'space-between'
    },
    textInputContainer: {
      margin: 0
    },
    sliderContainer: {
      flexGrow: 4
    },
    alertMessageContainer: {
      width: '100%'
    },
    alertMessage: {
      display: 'flex',
      width: '100%',
      alignSelf: 'flex-end',
      alignItems: 'center',
      color: theme.questionColor,
      marginTop: 20,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 16,
      fontWeight: fontWeightOptions.light
    },
    alertMessageIcon: {
      margin: [1, 3, 0, 0]
    }
  };
});
function RangeSlider({
  className,
  minValue,
  maxValue,
  stepSize,
  labels,
  hideTextBox,
  startPosition,
  defaultValue,
  clearButtonLabelText,
  stepMessage,
  errorMessage,
  onChange
}) {
  const {
    slider,
    labelContainer,
    labelItem,
    container,
    sliderContainer,
    textInputContainer,
    alertMessage,
    alertMessageIcon,
    alertMessageContainer
  } = useStyles$4();
  const startValue = defaultValue || startPosition;
  const [responseValue, setResponseValue] = useState('');
  const [rangeValue, setRangeValue] = useState(startValue.toString());
  const [textValue, setTextValue] = useState(defaultValue || '');
  const [showStepMessage, setShowStepMessage] = useState(false);
  const [showInvalidEntryMessage, setShowInvalidEntryMessage] = useState(false);
  const {
    left: minLabelText,
    middle: middleLabelText,
    right: maxLabelText
  } = labels;
  const changeValue = value => {
    const intVal = parseInt(value, 10);
    let responseVal = '';
    let textBoxVal = '';
    let displayStepMessage = false;
    let displayInvalidMessage = false;
    if (intVal < minValue) {
      textBoxVal = value;
      displayInvalidMessage = true;
    } else if (intVal > maxValue) {
      textBoxVal = value;
      displayInvalidMessage = true;
    } else if (value === '' || (intVal - minValue) % stepSize === 0) {
      responseVal = value;
      textBoxVal = value;
    } else if (Number.isNaN(intVal)) {
      displayInvalidMessage = true;
      textBoxVal = value;
    } else {
      // The value lies between two step points.
      // Determine the closest step point and make that the current value.
      responseVal = (Math.round((intVal - minValue) / stepSize) * stepSize + minValue).toString();
      textBoxVal = responseVal;
      displayStepMessage = true;
    }
    setRangeValue(responseVal || startPosition.toString());
    setResponseValue(responseVal);
    setTextValue(textBoxVal);
    onChange === null || onChange === void 0 ? void 0 : onChange(responseVal);
    setShowStepMessage(displayStepMessage);
    setShowInvalidEntryMessage(displayInvalidMessage);
  };
  const valueChangeHandler = answerValue => {
    if (answerValue !== responseValue) {
      changeValue(answerValue);
    }
  };
  const clearText = () => {
    changeValue('');
  };
  const getAccessibleValueText = rValue => {
    const value = parseInt(rValue, 10);
    if (value === minValue) {
      return `${value}, ${minLabelText}`;
    }
    if (value === Math.round(maxValue / 2)) {
      return `${value}, ${middleLabelText}`;
    }
    if (value === maxValue) {
      return `${value}, ${maxLabelText}`;
    }
    return rValue;
  };
  const invalidEntryMessage = errorMessage.replace(/\{0}/, minValue.toString()).replace(/\{1}/, maxValue.toString());
  return React__default.createElement("div", {
    className: classNames(className, container)
  }, React__default.createElement("div", {
    className: sliderContainer
  }, React__default.createElement("div", {
    className: labelContainer
  }, React__default.createElement("div", {
    className: labelItem
  }, minLabelText), React__default.createElement("div", {
    className: labelItem
  }, middleLabelText), React__default.createElement("div", {
    className: labelItem
  }, maxLabelText)), React__default.createElement("input", {
    type: "range",
    "aria-valuetext": getAccessibleValueText(rangeValue),
    value: rangeValue,
    className: slider,
    min: minValue,
    max: maxValue,
    step: stepSize,
    onChange: e => {
      valueChangeHandler(e.target.value);
    }
  })), !hideTextBox && React__default.createElement(ClearableTextInput, {
    className: textInputContainer,
    onChange: e => {
      setTextValue(e.target.value);
    },
    onBlur: e => {
      valueChangeHandler(e.target.value);
    },
    onClear: clearText,
    value: textValue,
    maxLength: 8,
    clearVisible: !!textValue,
    inputMode: "numeric",
    pattern: "[0-9]*",
    clearButtonLabelText: clearButtonLabelText
  }), React__default.createElement("div", {
    "aria-live": "assertive",
    className: alertMessageContainer
  }, (showStepMessage || showInvalidEntryMessage) && React__default.createElement("div", {
    className: alertMessage
  }, React__default.createElement(InfoIcon$1, {
    className: alertMessageIcon
  }), showStepMessage && React__default.createElement("span", null, stepMessage), showInvalidEntryMessage && React__default.createElement("span", null, invalidEntryMessage))));
}
const COPY$2 = defineMessages({
  SLIDER_CLEAR_BUTTON_LABEL: {
    id: 'Slider.CLEAR_BUTTON_LABEL',
    defaultMessage: 'Clear',
    description: '[Type: label][Vis: low] - screen reader only label for clear button'
  },
  SLIDER_STEP_MESSAGE: {
    id: 'Slider.STEP_MESSAGE',
    defaultMessage: "We adjusted the number you entered based on the slider's scale.",
    description: '[Type: message][Vis: medium] - Message displayed when the entered value needs to be moved to the next closest step'
  }
});
function Slider({
  id: questionId,
  responses: defaultResponses = [],
  onChange,
  scaleOptions,
  hideNumericalInput,
  disabled: _dis,
  required: _req,
  readOnly: _ro,
  ...fieldProps
}) {
  const defaultValue = useMemo(() => {
    var _defaultResponses$fin9;
    return ((_defaultResponses$fin9 = defaultResponses.find(r => !!r.value)) === null || _defaultResponses$fin9 === void 0 ? void 0 : _defaultResponses$fin9.value) ?? '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const [, setResponseValue] = useState(defaultResponses);
  const clearButtonLabelText = t(COPY$2.SLIDER_CLEAR_BUTTON_LABEL);
  const stepMessage = t(COPY$2.SLIDER_STEP_MESSAGE);
  const valueChanged = selectedValue => {
    const responses = selectedValue ? [{
      id: questionId,
      value: selectedValue
    }] : [];
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const errorId = createErrorId(questionId);
  return React__default.createElement(QuestionField, {
    id: questionId,
    errorId: errorId,
    "data-testid": "SliderQuestionType",
    ...fieldProps
  }, React__default.createElement(RangeSlider, {
    defaultValue: parseInt(defaultValue, 10),
    hideTextBox: hideNumericalInput,
    stepMessage: stepMessage,
    clearButtonLabelText: clearButtonLabelText,
    onChange: valueChanged,
    ...scaleOptions
  }));
}
const useStyles$3 = createUseStyles({
  radioIconInput: {
    /* needed to override styles in BaseInput which effects opacity of icons */
    '& svg': {
      opacity: 1
    }
  }
});
function RadioIconInput({
  className,
  icon,
  ...props
}, forwardedRef) {
  const {
    inputProps
  } = useInputStyles(props);
  const {
    radioIconInput
  } = useStyles$3();
  return React__default.createElement(BaseInput$1, {
    type: "radio",
    className: classNames(radioIconInput, className),
    icon: icon,
    ref: forwardedRef,
    ...inputProps
  });
}
var RadioIconInput$1 = forwardRef(RadioIconInput);
const useStyles$2 = createUseStyles(theme => {
  var _theme$breakpoints20;
  return {
    visuallyHidden,
    inputStyles: {
      textAlign: 'center',
      margin: 'auto',
      marginTop: '4px',
      [`@media (max-width: ${(_theme$breakpoints20 = theme.breakpoints) === null || _theme$breakpoints20 === void 0 ? void 0 : _theme$breakpoints20.xs.max})`]: {
        margin: '5px',
        marginTop: '4px'
      },
      '&:hover': {
        outline: `1px dashed ${theme.questionColor}`,
        marginTop: '5px'
      },
      '&:focus-within': {
        outline: `1px solid ${theme.questionColor}`,
        marginTop: '5px'
      },
      color: ({
        selected = false,
        symbolColor = '#F5A623'
      }) => {
        if (selected) {
          return symbolColor;
        }
        return '#fff';
      }
    }
  };
});
function StarRatingItem({
  onChange,
  selected,
  checked: checkedProp,
  name: nameProp,
  symbolColor,
  ...props
}) {
  let checked = checkedProp;
  let name = nameProp;
  const radioGroup = useRadioGroup();
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  const {
    visuallyHidden,
    inputStyles
  } = useStyles$2({
    checked,
    selected,
    symbolColor: symbolColor ?? ''
  });
  const handleChange = e => {
    const {
      id,
      checked: isChecked,
      value
    } = e.target;
    radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange({
      id,
      checked: isChecked,
      value
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id,
      checked: isChecked,
      value
    });
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(RadioIconInput$1, {
    name: name,
    className: inputStyles,
    onChange: handleChange,
    checked: checked,
    ...props
  }), React__default.createElement("label", {
    className: visuallyHidden,
    htmlFor: props.id
  }, props.label));
}
const useStyles$1 = createUseStyles(theme => {
  var _theme$breakpoints21, _theme$breakpoints22, _theme$breakpoints23, _theme$breakpoints24, _theme$breakpoints25, _theme$breakpoints26;
  const {
    bgColor: listItemBackground
  } = theme.input;
  return {
    visuallyHidden,
    ratingGroupStyle: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-evenly',
      [`@media (max-width: ${(_theme$breakpoints21 = theme.breakpoints) === null || _theme$breakpoints21 === void 0 ? void 0 : _theme$breakpoints21.xs.max})`]: {
        flexDirection: 'column'
      }
    },
    starContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      width: '100%',
      textAlign: 'center',
      [`@media (max-width: ${(_theme$breakpoints22 = theme.breakpoints) === null || _theme$breakpoints22 === void 0 ? void 0 : _theme$breakpoints22.xs.max})`]: {
        backgroundColor: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)',
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
        marginBottom: '5px'
      }
    },
    starLabel: {
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 14,
      fontWeight: theme.questionBody.fontWeight,
      lineHeight: 1.25,
      [`@media (max-width: ${(_theme$breakpoints23 = theme.breakpoints) === null || _theme$breakpoints23 === void 0 ? void 0 : _theme$breakpoints23.xs.max})`]: {
        // overwrite TextInput styles
        fontSize: theme.questionBody.fontSize,
        marginTop: '8px'
      }
    },
    naLabel: {
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 14,
      fontWeight: theme.questionBody.fontWeight,
      lineHeight: 1.25,
      [`@media (max-width: ${(_theme$breakpoints24 = theme.breakpoints) === null || _theme$breakpoints24 === void 0 ? void 0 : _theme$breakpoints24.xs.max})`]: {
        // overwrite TextInput styles
        display: 'none'
      }
    },
    starRow: {
      height: '42px',
      fontSize: '2em',
      [`@media (min-width: ${(_theme$breakpoints25 = theme.breakpoints) === null || _theme$breakpoints25 === void 0 ? void 0 : _theme$breakpoints25.sm.min})`]: {
        backgroundColor: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)'
      }
    },
    naRow: {
      height: '42px',
      width: '100%',
      [`@media (min-width: ${(_theme$breakpoints26 = theme.breakpoints) === null || _theme$breakpoints26 === void 0 ? void 0 : _theme$breakpoints26.sm.min})`]: {
        backgroundColor: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)',
        '& label': {
          display: 'block',
          height: '42px'
        },
        '& span[class^="smqr-richTextContent"]': {
          display: 'none'
        }
      }
    }
  };
});
const COPY$1 = defineMessages({
  STAR: {
    id: 'StarRating.STAR',
    defaultMessage: '{count} {count, plural, one {star} other {stars}}',
    description: 'Star Symbol Rating Label'
  },
  SMILEY: {
    id: 'StarRating.Smiley',
    defaultMessage: '{count} {count, plural, one {smiley} other {smileys}}',
    description: 'Smiley Symbol Rating Label'
  },
  HEART: {
    id: 'StarRating.Heart',
    defaultMessage: '{count} {count, plural, one {heart} other {hearts}}',
    description: 'Heart Symbol Rating Label'
  },
  THUMB: {
    id: 'StarRating.Thumb',
    defaultMessage: '{count} {count, plural, one {thumb} other {thumbs}}',
    description: 'Thumb Symbol Rating Label'
  }
});
function StarRating({
  choices = [],
  choiceNoneOfTheAbove,
  choiceComment,
  disabled,
  required,
  id: questionId,
  rowId,
  readOnly: _ro,
  onChange,
  responses: defaultResponses = [],
  symbolOptions,
  ...fieldProps
}) {
  const errorId = createErrorId(questionId);
  const [response, setResponse] = useState(defaultResponses);
  /** Filter choices that exist and are visible  */
  const {
    options,
    sortableOptions: ratingOptions,
    notaOption,
    commentOption
  } = useQuestionChoices([...choices, choiceNoneOfTheAbove, choiceComment]);
  const isSelected = index => {
    const selectedResponse = response.find(c => c.type !== 'COMMENT');
    const selectedIndex = ratingOptions.findIndex(option => option.id === (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value));
    return selectedIndex >= index;
  };
  const isChecked = ratingId => {
    const selectedResponse = response.find(c => c.type !== 'COMMENT');
    return ratingId === (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value);
  };
  /**
   * Default value for the group
   */
  const defaultValue = useMemo(() => {
    var _defaultResponses$fin10;
    return (_defaultResponses$fin10 = defaultResponses.find(c => c.type !== 'COMMENT')) === null || _defaultResponses$fin10 === void 0 ? void 0 : _defaultResponses$fin10.value;
  },
  // defaultValues should not be changed post render (breaks rules of controlled components)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  /**
   * deselect choice if the question is not required
   */
  const unCheckOption = () => {
    if (required) {
      return;
    }
    const responses = response.filter(c => c.type === 'COMMENT');
    setResponse(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * Default value by id
   * used for text-input based choices
   */
  const getDefaultValueById = id => {
    const defaultChoice = defaultResponses.find(c => c.id === id);
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  const handleClick = e => {
    const input = e.target;
    const selectedResponse = response.find(c => c.type !== 'COMMENT');
    const isCheckedID = (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value) === input.id;
    if (isCheckedID && input.checked) {
      e.preventDefault();
      unCheckOption();
    }
  };
  const handleKeyboard = e => {
    const selectedResponse = response.find(c => c.type !== 'COMMENT');
    const isCheckedID = (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value) === e.target.id;
    if (isCheckedID && e.code === 'Space' || /* unCheck when ArrowLeft is pressed while on the first option */
    (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value) === options[0].id && e.code === 'ArrowLeft') {
      e.preventDefault();
      unCheckOption();
    }
  };
  const handleRadioChange = e => {
    const choiceData = ratingOptions.find(c => e.id === c.id);
    const responses = response.filter(c => c.type === 'COMMENT');
    if (choiceData) {
      const {
        type
      } = choiceData;
      responses.push({
        id: rowId,
        type,
        value: e.value
      });
      setResponse(responses);
      onChange === null || onChange === void 0 ? void 0 : onChange(responses);
    } else if (e.id === (notaOption === null || notaOption === void 0 ? void 0 : notaOption.id)) {
      responses.push({
        id: rowId,
        type: 'NOTA',
        value: e.value
      });
      setResponse(responses);
      onChange === null || onChange === void 0 ? void 0 : onChange(responses);
    }
  };
  const handleCommentChange = e => {
    const choiceData = options.find(c => c.id === e.target.id);
    const responses = response.filter(c => c.type !== 'COMMENT');
    if (choiceData && !!e.target.value) {
      const {
        id,
        type
      } = choiceData;
      responses.push({
        id,
        type,
        value: e.target.value
      });
    }
    setResponse(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  const radioGroupProps = {
    disabled,
    name: questionId,
    defaultValue,
    onChange: handleRadioChange
  };
  const {
    starLabel,
    naLabel,
    ratingGroupStyle,
    starContainer,
    naRow,
    starRow
  } = useStyles$1();
  const radioEvents = {
    onClick: handleClick,
    onKeyDown: handleKeyboard
  };
  const getHiddenLabel = index => {
    const count = index + 1;
    switch (symbolOptions === null || symbolOptions === void 0 ? void 0 : symbolOptions.symbol) {
      case 'HEART':
        return t(COPY$1.HEART, {
          count
        });
      case 'SMILEY':
        return t(COPY$1.SMILEY, {
          count
        });
      case 'THUMB':
        return t(COPY$1.THUMB, {
          count
        });
      default:
        return t(COPY$1.STAR, {
          count
        });
    }
  };
  const getIcon = () => {
    switch (symbolOptions === null || symbolOptions === void 0 ? void 0 : symbolOptions.symbol) {
      case 'HEART':
        return React__default.createElement(HeartIcon$1, null);
      case 'SMILEY':
        return React__default.createElement(SmileyIcon$1, null);
      case 'THUMB':
        return React__default.createElement(ThumbsUpIcon$1, null);
      default:
        return React__default.createElement(StarIcon$1, null);
    }
  };
  return React__default.createElement(QuestionField, {
    id: questionId,
    "data-testid": "StarRatingQuestionType",
    errorId: errorId,
    ...fieldProps
  }, React__default.createElement(RadioGroup, {
    ...radioGroupProps
  }, React__default.createElement("div", {
    className: ratingGroupStyle
  }, ratingOptions.map((ratingOption, index) => {
    return React__default.createElement("div", {
      className: starContainer,
      key: ratingOption.id
    }, React__default.createElement("div", {
      className: starLabel,
      id: `${ratingOption.id}-desc`
    }, ratingOption.label), React__default.createElement("div", {
      className: starRow
    }, React__default.createElement(StarRatingItem, {
      icon: getIcon(),
      id: ratingOption.id,
      label: getHiddenLabel(index),
      checked: isChecked(ratingOption.id),
      selected: isSelected(index),
      value: ratingOption.id,
      ...radioEvents,
      "aria-describedby": ratingOption.label ? `${ratingOption.id}-desc` : undefined,
      symbolColor: symbolOptions === null || symbolOptions === void 0 ? void 0 : symbolOptions.color
    })));
  }), notaOption && React__default.createElement("div", {
    className: starContainer,
    key: notaOption.id
  }, React__default.createElement("div", {
    className: naLabel,
    id: `${notaOption.id}-desc`
  }, notaOption.label), React__default.createElement("div", {
    className: naRow
  }, React__default.createElement(Radio$1, {
    id: notaOption.id,
    key: notaOption.id,
    value: notaOption.id,
    checked: isChecked(notaOption.id),
    "aria-describedby": fieldProps.error && errorId,
    inputSize: 20,
    ...radioEvents
  }, notaOption.label)))), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS
  })));
}
const useStyles = createUseStyles(theme => {
  const {
    fontSize,
    fontFamily,
    fontWeight
  } = theme.questionBody;
  const iconSize = '40px';
  return {
    srOnly: {
      ...visuallyHidden
    },
    container: {
      display: 'flex',
      flexDirection: 'column'
    },
    label: {
      fontSize,
      fontFamily,
      fontWeight,
      color: theme.questionColor,
      marginBottom: '14px'
    },
    instructionsContainer: {
      paddingBottom: '15px'
    },
    fileDragArea: {
      maxWidth: '600px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: '#404040',
      transition: 'all .2s linear',
      opacity: ({
        disabled
      }) => disabled ? 0.5 : 1,
      [`@media (min-width: ${theme.breakpoints.sm.min})`]: {
        padding: '20px',
        gap: '10px',
        backgroundColor: ({
          disabled,
          dragActive
        }) => !disabled && dragActive ? '#ABABAB' : '#EFEFEF',
        border: ({
          disabled,
          dragActive
        }) => !disabled && dragActive ? '1px dashed #ABABAB' : '1px dashed #404040',
        outline: ({
          disabled,
          dragActive
        }) => !disabled && dragActive ? '3px solid #404040' : 'none'
      }
    },
    draggingActive: {
      background: 'blue',
      [`@media (min-width: ${theme.breakpoints.sm.min})`]: {
        borderColor: '#ABABAB',
        backgroundColor: '#ABABAB',
        outline: '3px solid #404040'
      }
    },
    fileUploadDragDesktop: {
      display: 'none',
      [`@media (min-width: ${theme.breakpoints.sm.min})`]: {
        display: 'inline-block'
      }
    },
    stateArea: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      [`@media (min-width: ${theme.breakpoints.sm.min})`]: {
        minHeight: '90px'
      }
    },
    stateIcon: {
      fontSize: iconSize
    },
    stateText: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    removeFileButton: {
      height: '20px',
      borderRadius: '50%',
      padding: '0',
      border: 'none',
      background: 'transparent',
      fontSize: '20px',
      transition: 'all .2s linear',
      color: '#404040',
      cursor: 'pointer',
      '&:hover, &:focus': {
        outline: '1px solid rgba(64,64,64,1)',
        boxShadow: '0 0 4px transparent',
        outlineOffset: '5px'
      }
    },
    fileUploadText: {
      padding: '15px 0'
    },
    fileUploadLabel: {
      position: 'relative',
      marginRight: '5px',
      transition: 'all .2s linear',
      '&:has(input:focus)': {
        outline: '1px solid #0A7CC1',
        boxShadow: '0 0 4px transparent',
        outlineOffset: '5px'
      }
    },
    fileUploadInput: {
      cursor: 'pointer',
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      opacity: 0,
      fontSize: '.1px'
    },
    linkStyle: {
      color: '#0A7CC1',
      background: 'transparent',
      border: 'none',
      textDecoration: 'underline',
      padding: '0',
      fontSize: '1em',
      display: 'inline-block'
    },
    fileTypeListParagraph: {
      margin: 0
    },
    fileTypeListItem: {
      background: '#404040',
      borderRadius: '3px',
      padding: '5px',
      textTransform: 'uppercase',
      color: '#FFFFFF',
      fontWeight: '700',
      fontSize: '12px',
      margin: '0 5px'
    },
    loading: {
      width: iconSize,
      height: iconSize,
      border: '5px solid rgba(0,0,0,0.25)',
      borderBottomColor: '#008323',
      borderRadius: '50%',
      display: 'inline-block',
      boxSizing: 'border-box',
      animation: '$rotation 1s linear infinite'
    },
    '@keyframes rotation': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  };
});
const COPY = defineMessages({
  CHOOSE_OR_DRAG: {
    id: 'FileUpload.chooseDragFile',
    defaultMessage: '<div class={chooseClass}>Choose a file</div> <div class={dragClass}>or drag it here</div>',
    description: '[Type: label][Vis: high] - label for file input when a file has not been uploaded'
  },
  REPLACE_OR_DRAG: {
    id: 'FileUpload.replaceDragFile',
    defaultMessage: '<div class={chooseClass}>Replace file</div> <div class={dragClass}>or drag it here</div>',
    description: '[Type: label][Vis: high] - label for file input when a file has been uploaded'
  },
  SUPPORTED_FILES: {
    id: 'FileUpload.supportedFiles',
    defaultMessage: 'Supported Files',
    description: '[Type: label][Vis: high] - Prefix to the supported files list'
  },
  FILE_UPLOADING: {
    id: 'FileUpload.fileUploading',
    defaultMessage: 'File uploading',
    description: '[Type: label][Vis: high] - Label for when a file is uploading'
  },
  REMOVE_FILE: {
    id: 'FileUpload.removeFile',
    defaultMessage: 'Remove file',
    description: '[Type: label][Vis: high] - Label for the remove currently selected file button'
  },
  FILE_UPLOADED: {
    id: 'FileUpload.fileUploaded',
    defaultMessage: 'File uploaded successfully',
    description: '[Type: label][Vis: high] - Announcement message for when a file is uploaded successfully'
  }
});
const UPLOAD_STATE = {
  default: 'default',
  uploading: 'uploading',
  error: 'error',
  success: 'success'
};
function FileUpload({
  id: questionId,
  readOnly: _ro,
  disabled,
  responses: defaultResponses = [],
  instructions = 'Optional Instructions',
  validation,
  onChange,
  uploadFile,
  ...questionFieldProps
}) {
  /** possible states are default, uploading, error, success */
  const [state, setState] = useState(defaultResponses[0] ? UPLOAD_STATE.success : UPLOAD_STATE.default);
  const [dragActive, setDragActive] = useState(false);
  /** response is the main state data object from tier 1. Example: {id, value: https://s3.aws.com/filename.jpg} */
  const [response, setResponse] = useState(defaultResponses);
  const errorId = createErrorId(questionId);
  const [announcement, setAnnouncement] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const fileInputRef = useRef(null);
  const {
    formats: fileTypes = [],
    errorMessage: fileTypesError = ''
  } = validation || {};
  const handleDragOver = e => {
    e.preventDefault();
    if (!disabled) {
      setDragActive(true);
    }
  };
  const handleDragLeave = e => {
    e.preventDefault();
    if (!disabled) {
      setDragActive(false);
    }
  };
  const setAnnouncementString = str => {
    setTimeout(() => {
      setAnnouncement(str);
    }, 5000);
    setAnnouncement('');
  };
  const handleSetError = errorString => {
    setState(UPLOAD_STATE.error);
    setResponse([]);
    setAnnouncementString(errorString);
    setErrorMessage(errorString);
  };
  const handleFileUpload = async f => {
    if (f && fileTypes.includes(`${f.type.split('/')[1]}`)) {
      setState(UPLOAD_STATE.uploading);
      setAnnouncementString(t(COPY.FILE_UPLOADING));
      const fileResponse = await (uploadFile === null || uploadFile === void 0 ? void 0 : uploadFile(f));
      if (fileResponse) {
        if (fileResponse.error) {
          handleSetError(fileResponse.error);
        } else {
          setState(UPLOAD_STATE.success);
          const newResponse = [{
            id: questionId,
            value: fileResponse.url
          }];
          setResponse(newResponse);
          /** value will be an s3.awe.com url */
          onChange === null || onChange === void 0 ? void 0 : onChange(newResponse);
          setAnnouncementString(t(COPY.FILE_UPLOADED));
        }
      }
      /** not sure what to do if there is no file response */
    } else {
      handleSetError(fileTypesError);
    }
  };
  const handleDrop = e => {
    e.preventDefault();
    if (!disabled) {
      setDragActive(false);
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        handleFileUpload(e.dataTransfer.files[0]);
      }
    }
  };
  const handleFileInput = e => {
    if (!disabled && e.target.files && e.target.files.length > 0) {
      handleFileUpload(e.target.files[0]);
    }
  };
  const handleClearFile = () => {
    var _fileInputRef$current;
    setState(UPLOAD_STATE.default);
    setAnnouncementString('');
    (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.focus();
  };
  const {
    srOnly,
    container,
    instructionsContainer,
    fileDragArea,
    stateArea,
    stateIcon,
    stateText,
    fileUploadText,
    fileTypeListItem,
    loading,
    linkStyle,
    fileUploadDragDesktop,
    removeFileButton,
    fileUploadLabel,
    fileUploadInput,
    fileTypeListParagraph
  } = useStyles({
    dragActive,
    disabled
  });
  /** using <div> because sm-intl doesn't allow the use of <span> */
  const chooseFileLabel = t(COPY.CHOOSE_OR_DRAG, {
    chooseClass: linkStyle,
    dragClass: fileUploadDragDesktop
  }, {
    html: true
  });
  const replaceFileLabel = t(COPY.REPLACE_OR_DRAG, {
    chooseClass: linkStyle,
    dragClass: fileUploadDragDesktop
  }, {
    html: true
  });
  return React__default.createElement(QuestionField, {
    id: questionId,
    "data-testid": "FileUpload",
    errorId: errorId,
    ...questionFieldProps
  }, React__default.createElement("div", {
    role: "status",
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: srOnly
  }, announcement), React__default.createElement("div", {
    className: container
  }, instructions !== undefined && React__default.createElement("p", {
    className: instructionsContainer
  }, instructions), React__default.createElement("div", {
    className: classNames(fileDragArea),
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    "data-testid": "FileUpload__DropArea"
  }, React__default.createElement("div", {
    className: stateArea
  }, React__default.createElement("div", {
    className: stateIcon
  }, state === 'default' && React__default.createElement(CloudArrowUpIcon$1, {
    color: "#404040"
  }), state === 'uploading' && React__default.createElement("span", {
    className: loading
  }), state === 'error' && React__default.createElement(WarningIcon$1, {
    color: "#CC0000 "
  }), state === 'success' && React__default.createElement(CheckOutlineIcon$1, null)), React__default.createElement("div", {
    className: stateText
  }, state === 'uploading' && React__default.createElement(T, {
    desc: COPY.FILE_UPLOADING
  }), state === 'error' && errorMessage, state === 'success' && response[0] && React__default.createElement(React__default.Fragment, null, response[0].value.split('/').pop(), React__default.createElement("button", {
    type: "button",
    onClick: handleClearFile,
    "aria-label": t(COPY.REMOVE_FILE),
    className: removeFileButton
  }, React__default.createElement(CloseOutlineIcon$1, null))))), React__default.createElement("div", {
    className: fileUploadText
  }, !disabled && React__default.createElement("label", {
    htmlFor: `${questionId}-fileInput`,
    className: fileUploadLabel
  }, state === 'success' || state === 'uploading' ? replaceFileLabel : chooseFileLabel, React__default.createElement("input", {
    type: "file",
    id: `${questionId}-fileInput`,
    ref: fileInputRef,
    accept: fileTypes.join(),
    onChange: handleFileInput,
    "aria-describedby": "fileTypeList",
    className: fileUploadInput
  }))), React__default.createElement("p", {
    id: `${questionId}-fileTypeList`,
    className: fileTypeListParagraph
  }, React__default.createElement("span", {
    className: srOnly
  }, React__default.createElement(T, {
    desc: COPY.SUPPORTED_FILES
  })), ' ', fileTypes.map(type => {
    const typeNoDot = type.replace('.', '');
    return React__default.createElement("span", {
      key: typeNoDot,
      className: fileTypeListItem
    }, typeNoDot);
  })))));
}
export { BestWorst$1 as BestWorst, CaretDownIcon, CaretDownOutlineIcon, Checkbox$1 as Checkbox, CommentBox$1 as CommentBox, DateTime$1 as DateTime, Dropdown$1 as Dropdown, FileUpload, ImageChoice$1 as ImageChoice, ImagePresentational$1 as ImagePresentational, MatrixDropdown, MatrixRating, MultipleChoice, MultipleTextbox, NativeSelect, SelectAnswerOption as NativeSelectOption, Nps, Ranking, SingleTextbox$1 as SingleTextbox, Slider, StarRating, TextPresentational$1 as TextPresentational };